{
  "app": {
    "name": "HMS",
    "fullName": "ລະບົບບໍລິຫານໂຮງໝໍ",
    "tagline": "ການດູແລທີ່ເຊື່ອມໂຍງກັນ."
  },
  "common": {
    "save": "ບັນທຶກ",
    "saving": "ກຳລັງບັນທຶກ…",
    "cancel": "ຍົກເລີກ",
    "close": "ປິດ",
    "edit": "ແກ້ໄຂ",
    "delete": "ລຶບ",
    "add": "ເພີ່ມ",
    "create": "ສ້າງ",
    "search": "ຄົ້ນຫາ",
    "searchPlaceholder": "ຄົ້ນຫາ…",
    "loading": "ກຳລັງໂຫຼດ…",
    "retry": "ລອງໃໝ່",
    "back": "ກັບຄືນ",
    "next": "ຕໍ່ໄປ",
    "previous": "ກ່ອນໜ້າ",
    "confirm": "ຢືນຢັນ",
    "yes": "ແມ່ນ",
    "no": "ບໍ່",
    "actions": "ການດຳເນີນການ",
    "status": "ສະຖານະ",
    "details": "ລາຍລະອຽດ",
    "none": "ບໍ່ມີ",
    "all": "ທັງໝົດ",
    "optional": "ບໍ່ບັງຄັບ",
    "required": "ຈຳເປັນ",
    "notes": "ໝາຍເຫດ",
    "reason": "ເຫດຜົນ",
    "date": "ວັນທີ",
    "time": "ເວລາ",
    "from": "ຈາກ",
    "to": "ເຖິງ",
    "filter": "ກັ່ນຕອງ",
    "clear": "ລ້າງ",
    "refresh": "ໂຫຼດຄືນ",
    "print": "ພິມ",
    "export": "ສົ່ງອອກ",
    "import": "ນຳເຂົ້າ",
    "reset": "ຕັ້ງຄ່າຄືນ",
    "view": "ເບິ່ງ",
    "open": "ເປີດ",
    "submit": "ສົ່ງ",
    "select": "ເລືອກ",
    "selectPlaceholder": "ເລືອກ…",
    "noResults": "ບໍ່ພົບຂໍ້ມູນ",
    "total": "ລວມ",
    "showing": "{{from}}–{{to}} ຈາກ {{total}}",
    "unknown": "ບໍ່ຮູ້",
    "saved": "ບັນທຶກແລ້ວ",
    "today": "ມື້ນີ້",
    "name": "ຊື່",
    "code": "ລະຫັດ",
    "type": "ປະເພດ",
    "description": "ລາຍລະອຽດ",
    "createdAt": "ສ້າງເມື່ອ",
    "updatedAt": "ອັບເດດເມື່ອ",
    "yearsShort": "{{count}} ປີ",
    "dash": "—",
    "more": "ເພີ່ມເຕີມ",
    "active": "ໃຊ້ງານ",
    "inactive": "ບໍ່ໃຊ້ງານ",
    "first": "ໜ້າທຳອິດ",
    "last": "ໜ້າສຸດທ້າຍ",
    "pageOf": "ໜ້າ {{page}} ຈາກ {{pages}}",
    "rowsPerPage": "ແຖວຕໍ່ໜ້າ",
    "pagination": "ການແບ່ງໜ້າ",
    "viewAs": "ສະແດງແບບ",
    "views": {
      "list": "ລາຍການ",
      "cards": "ບັດ",
      "grid": "ຕາຕະລາງ"
    },
    "datePlaceholder": "ວວ/ດດ/ປປປປ",
    "pickDate": "ເລືອກວັນທີ",
    "change": "ປ່ຽນ",
    "goToPage": "ໄປທີ່ໜ້າ",
    "jumpBack": "ຖອຍຫຼັງ {{count}} ໜ້າ",
    "jumpForward": "ຖັດໄປ {{count}} ໜ້າ",
    "cancelled": "ຍົກເລີກແລ້ວ",
    "choose": "ເລືອກ…",
    "selectAll": "ເລືອກທັງໝົດ"
  },
  "nav": {
    "dashboard": "ໜ້າຫຼັກ",
    "patients": "ຄົນເຈັບ",
    "appointments": "ນັດໝາຍ",
    "queue": "ຄິວ",
    "encounters": "ການກວດປິ່ນປົວ",
    "pharmacy": "ຫ້ອງຢາ",
    "laboratory": "ຫ້ອງວິເຄາະ",
    "billing": "ໃບບິນ ແລະ ຮັບເງິນ",
    "administration": "ການບໍລິຫານ",
    "users": "ຜູ້ໃຊ້",
    "departments": "ພະແນກ",
    "practitioners": "ແພດ ແລະ ບຸກຄະລາກອນ",
    "hospital": "ໂຮງໝໍ",
    "auditLog": "ບັນທຶກການກວດສອບ",
    "translations": "ການແປພາສາ",
    "languages": "ພາສາ",
    "settings": "ການຕັ້ງຄ່າ",
    "notifications": "ການແຈ້ງເຕືອນ",
    "signOut": "ອອກຈາກລະບົບ",
    "menu": "ເມນູ",
    "home": "ໜ້າຫຼັກ",
    "eyeCenter": "ສູນຕາ",
    "treatmentCycles": "ວົງຈອນການປິ່ນປົວ",
    "patientApp": "ແອັບຄົນເຈັບ",
    "reports": "ລາຍງານ",
    "locations": "ສະຖານທີ່",
    "inventory": "ຄັງສິນຄ້າ",
    "inpatient": "ຄົນເຈັບນອນໂຮງໝໍ",
    "bedBoard": "ກະດານຕຽງ",
    "admissions": "ການເຂົ້ານອນໂຮງໝໍ",
    "wardSetup": "ຫວອດ, ຫ້ອງ ແລະ ຕຽງ",
    "specialServices": "ບໍລິການພິເສດ",
    "serviceWorklist": "ລາຍການວຽກ",
    "serviceCatalog": "ບໍລິການ ແລະ ລາຄາ",
    "pos": "ຮ້ານຂາຍຢາ POS",
    "posCounter": "ຂາຍ",
    "salesHistory": "ປະຫວັດການຂາຍ",
    "itemsPrices": "ລາຍການ ແລະ ລາຄາ",
    "finance": "ການເງິນ ແລະ ບັນຊີ",
    "collapseMenu": "ຫຍໍ້ເມນູ",
    "expandMenu": "ຂະຫຍາຍເມນູ",
    "posStock": "ສິນຄ້າ ແລະ ການເຕີມ",
    "posCatalog": "ລາຍການສິນຄ້າ ແລະ ລາຄາ",
    "diseases": "ພະຍາດ",
    "nationalReporting": "ລາຍງານລະດັບຊາດ",
    "area": {
      "patientAdmin": "ການບໍລິຫານຄົນເຈັບ",
      "clinical": "ການກວດ ແລະ ປິ່ນປົວ",
      "eye": "ສູນຕາ",
      "inpatient": "ຄົນເຈັບໃນ",
      "supplies": "ຢາ ແລະ ພັດສະດຸ",
      "finance": "ການເງິນ",
      "reporting": "ຜົນງານ ແລະ ລາຍງານລະດັບຊາດ",
      "engagement": "ການພົວພັນກັບຄົນເຈັບ",
      "platform": "ລະບົບ ແລະ ການບໍລິຫານ"
    },
    "tenants": "ອົງກອນ ແລະ ໂຮງໝໍ",
    "referrals": "ການສົ່ງຕໍ່",
    "followUps": "ການນັດຕິດຕາມ",
    "duplicates": "ຄົນເຈັບຊ້ຳກັນ",
    "roles": "ບົດບາດ ແລະ ສິດ",
    "appointmentDashboard": "ພາບລວມ",
    "appointmentList": "ລາຍການນັດໝາຍ",
    "disabilityTypes": "ປະເພດຄວາມພິການ",
    "queueDashboard": "ໜ້າຈໍພະນັກງານ",
    "queueKiosk": "ຕູ້ບໍລິການຕົນເອງ",
    "queueDisplay": "ຈໍສະແດງຄິວ",
    "queueReport": "ເວລາລໍຖ້າ",
    "queueServices": "ຈຸດບໍລິການຄິວ",
    "staffKpi": "KPI ພະນັກງານ",
    "staffDashboard": "ພາບລວມ",
    "staffLeaderboard": "ອັນດັບ",
    "staffTargets": "ເປົ້າໝາຍ"
  },
  "auth": {
    "signIn": "ເຂົ້າສູ່ລະບົບ",
    "signInTitle": "ຍິນດີຕ້ອນຮັບ",
    "signInSubtitle": "ເຂົ້າສູ່ລະບົບເພື່ອເຂົ້າໃຊ້ງານລະບົບໂຮງໝໍ.",
    "username": "ຊື່ຜູ້ໃຊ້ ຫຼື ອີເມວ",
    "password": "ລະຫັດຜ່ານ",
    "signingIn": "ກຳລັງເຂົ້າສູ່ລະບົບ…",
    "sessionExpired": "ເຊດຊັນໝົດອາຍຸແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.",
    "changePassword": "ປ່ຽນລະຫັດຜ່ານ",
    "currentPassword": "ລະຫັດຜ່ານປັດຈຸບັນ",
    "newPassword": "ລະຫັດຜ່ານໃໝ່",
    "confirmPassword": "ຢືນຢັນລະຫັດຜ່ານໃໝ່",
    "passwordMismatch": "ລະຫັດຜ່ານບໍ່ກົງກັນ",
    "passwordChanged": "ປ່ຽນລະຫັດຜ່ານແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.",
    "passwordPolicy": "ຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ, ມີຕົວພິມໃຫຍ່, ຕົວພິມນ້ອຍ ແລະ ຕົວເລກ.",
    "switchHospital": "ປ່ຽນໂຮງໝໍ",
    "hospital": "ໂຮງໝໍ",
    "demoAccounts": "ບັນຊີທົດລອງ",
    "showPassword": "ສະແດງລະຫັດຜ່ານ",
    "hidePassword": "ເຊື່ອງລະຫັດຜ່ານ",
    "usernamePlaceholder": "ເຊັ່ນ doctor",
    "featureClinical": "ຄົນເຈັບ, ການກວດ, ຫ້ອງຢາ, ຫ້ອງວິເຄາະ ແລະ ການເງິນ ໃນບ່ອນດຽວ",
    "featureAnalytics": "ໜ້າຫຼັກສົດ ແລະ ການວິເຄາະປຽບທຽບລາຍປີ",
    "featureLanguages": "ລາວ, ໄທ, ອັງກິດ, ຈີນ ແລະ ຫວຽດນາມ — ປັບແຕ່ງຄຳສັບໄດ້",
    "featureSecurity": "ສິດການເຂົ້າເຖິງຕາມບົດບາດ ພ້ອມບັນທຶກການກວດສອບຄົບຖ້ວນ",
    "stats": {
      "title": "ສະຖິຕິປັດຈຸບັນ",
      "patients": "ຄົນເຈັບລົງທະບຽນ",
      "newThisMonth": "+{{count}} ເດືອນນີ້",
      "visitsThisYear": "ການມາກວດປີນີ້",
      "today": "ມື້ນີ້ {{count}}",
      "eyeExams": "ການກວດຕາ",
      "surgeries": "ຜ່າຕັດຕາ {{count}} ຄັ້ງ",
      "villages": "ບ້ານທີ່ໄດ້ຮັບບໍລິການ",
      "provinces": "ໃນ {{count}} ແຂວງ",
      "departments": "ພະແນກປິ່ນປົວ",
      "practitioners": "ທ່ານໝໍ {{count}} ທ່ານ",
      "appAccounts": "ຜູ້ໃຊ້ແອັບຄົນເຈັບ",
      "patientApp": "ຜ່ານແອັບມືຖື",
      "visitsByMonth": "ການມາກວດຕໍ່ເດືອນ (12 ເດືອນຫຼ້າສຸດ)"
    },
    "app": {
      "title": "ແອັບມືຖື",
      "download": "ດາວໂຫຼດ APK",
      "scan": "ສະແກນດ້ວຍໂທລະສັບ",
      "howTo": "ວິທີຕິດຕັ້ງ",
      "step1": "ດາວໂຫຼດ APK ໃສ່ໂທລະສັບ Android (Android 7.0 ຂຶ້ນໄປ).",
      "step2": "ເປີດໄຟລ໌ ແລ້ວອະນຸຍາດການຕິດຕັ້ງແອັບຈາກແຫຼ່ງນີ້ເມື່ອຖືກຖາມ.",
      "step3": "ເປີດແອັບ: ຄົນເຈັບສ້າງບັນຊີດ້ວຍເບີໂທ ຫຼື ອີເມວ; ພະນັກງານເຂົ້າສູ່ລະບົບດ້ວຍຊື່ຜູ້ໃຊ້.",
      "version": "Android · ເວີຊັນ {{version}} · {{date}}",
      "patient": {
        "name": "HMS ຄົນເຈັບ",
        "desc": "ສຳລັບຄົນເຈັບ: ລົງທະບຽນດ້ວຍເບີໂທ ຫຼື ອີເມວ, ເບິ່ງປະຫວັດ, ຄິວ ແລະ ໃບບິນ"
      },
      "staff": {
        "name": "HMS ພະນັກງານ",
        "desc": "ສຳລັບພະນັກງານໂຮງໝໍ: ເຂົ້າສູ່ລະບົບດ້ວຍບັນຊີ HMS"
      }
    }
  },
  "errors": {
    "generic": "ມີບາງຢ່າງຜິດພາດ. ກະລຸນາລອງໃໝ່.",
    "network": "ບໍ່ສາມາດເຊື່ອມຕໍ່ເຊີບເວີໄດ້. ກະລຸນາກວດສອບການເຊື່ອມຕໍ່.",
    "UNAUTHORIZED": "ກະລຸນາເຂົ້າສູ່ລະບົບເພື່ອດຳເນີນການຕໍ່.",
    "INVALID_CREDENTIALS": "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ.",
    "ACCOUNT_LOCKED": "ບັນຊີຖືກລັອກຊົ່ວຄາວ ຍ້ອນໃສ່ລະຫັດຜິດຫຼາຍເທື່ອ. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ.",
    "ACCOUNT_DISABLED": "ບັນຊີນີ້ຖືກປິດ. ຕິດຕໍ່ໂຮງໝໍ.",
    "TOKEN_INVALID": "ເຊດຊັນບໍ່ຖືກຕ້ອງແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.",
    "TOKEN_REUSED": "ເຊດຊັນຖືກປິດເພື່ອຄວາມປອດໄພ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.",
    "SESSION_EXPIRED": "ເຊດຊັນໝົດອາຍຸແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.",
    "NO_HOSPITAL_ACCESS": "ບັນຊີຂອງທ່ານຍັງບໍ່ມີສິດເຂົ້າໃຊ້ໂຮງໝໍໃດ.",
    "HOSPITAL_ACCESS_DENIED": "ທ່ານບໍ່ມີສິດເຂົ້າໃຊ້ໂຮງໝໍນັ້ນ.",
    "FORBIDDEN": "ທ່ານບໍ່ມີສິດດຳເນີນການນີ້.",
    "NOT_FOUND": "ບໍ່ພົບຂໍ້ມູນທີ່ຮ້ອງຂໍ.",
    "VALIDATION_FAILED": "ກະລຸນາແກ້ໄຂຊ່ອງທີ່ໝາຍໄວ້.",
    "INVALID_JSON": "ບໍ່ສາມາດອ່ານຄຳຮ້ອງຂໍໄດ້.",
    "INVALID_PARAMETER": "ຄ່າການກັ່ນຕອງບໍ່ຖືກຕ້ອງ.",
    "DUPLICATE": "ມີຂໍ້ມູນທີ່ມີຄ່າດຽວກັນຢູ່ແລ້ວ.",
    "CONFLICT": "ຂໍ້ມູນນີ້ຂັດກັບຂໍ້ມູນທີ່ມີຢູ່.",
    "VERSION_CONFLICT": "ມີຄົນອື່ນແກ້ໄຂຂໍ້ມູນນີ້ແລ້ວ. ກະລຸນາໂຫຼດຄືນແລ້ວລອງໃໝ່.",
    "SCHEDULE_CONFLICT": "ເວລານີ້ຊ້ຳກັບນັດໝາຍອື່ນຂອງແພດຄົນນີ້.",
    "INVALID_STATE": "ບໍ່ສາມາດດຳເນີນການນີ້ໃນສະຖານະປັດຈຸບັນ.",
    "INVALID_TRANSITION": "ບໍ່ສາມາດດຳເນີນການນີ້ໃນສະຖານະປັດຈຸບັນ.",
    "MRN_EXISTS": "ເລກເວດລະບຽນນີ້ຖືກໃຊ້ແລ້ວ.",
    "DUPLICATE_IDENTIFIER": "ມີຄົນເຈັບທີ່ໃຊ້ເລກປະຈຳຕົວນີ້ແລ້ວ.",
    "POTENTIAL_DUPLICATE": "ມີຄົນເຈັບທີ່ຄ້າຍຄືກັນຢູ່ແລ້ວ.",
    "ALLERGY_WARNING": "ຢານີ້ກົງກັບປະຫວັດການແພ້ທີ່ບັນທຶກໄວ້.",
    "OVERPAYMENT": "ຈຳນວນເງິນເກີນຍອດຄ້າງຊຳລະ.",
    "TOO_MANY_REQUESTS": "ມີຄຳຮ້ອງຂໍຫຼາຍເກີນໄປ. ກະລຸນາລໍຖ້າຈັກໜ້ອຍ.",
    "INTERNAL_ERROR": "ເກີດຂໍ້ຜິດພາດທີ່ເຊີບເວີ.",
    "UNSIGNED_NOTES": "ກະລຸນາລົງນາມ ຫຼື ລຶບບັນທຶກສະບັບຮ່າງກ່ອນສຳເລັດ.",
    "ENCOUNTER_CLOSED": "ການກວດປິ່ນປົວນີ້ປິດແລ້ວ.",
    "ENCOUNTER_EXISTS": "ມີການກວດປິ່ນປົວສຳລັບນັດໝາຍນີ້ແລ້ວ.",
    "ENCOUNTER_HAS_ACTIVITY": "ບໍ່ສາມາດຍົກເລີກການກວດທີ່ມີບັນທຶກລົງນາມ ຫຼື ມີຄຳສັ່ງແລ້ວ.",
    "QUEUE_CLOSED": "ຄິວຂອງພະແນກນີ້ປິດແລ້ວ.",
    "INVOICE_HAS_PAYMENTS": "ກະລຸນາຄືນເງິນກ່ອນຍົກເລີກໃບແຈ້ງໜີ້.",
    "EMPTY_INVOICE": "ກະລຸນາເພີ່ມຢ່າງໜ້ອຍໜຶ່ງລາຍການໃນໃບແຈ້ງໜີ້.",
    "SPECIMEN_NOT_COLLECTED": "ກະລຸນາເກັບຕົວຢ່າງກ່ອນບັນທຶກຜົນ.",
    "RESULT_VERIFIED": "ຜົນທີ່ຢືນຢັນແລ້ວຕ້ອງແກ້ໄຂຜ່ານການແກ້ຜົນ, ບໍ່ແມ່ນບັນທຶກໃໝ່.",
    "NOTHING_TO_DISPENSE": "ບໍ່ມີຢາທີ່ຕ້ອງຈ່າຍແລ້ວ.",
    "QUANTITY_EXCEEDED": "ຈຳນວນເກີນກວ່າທີ່ສັ່ງ.",
    "CANNOT_DISABLE_SELF": "ທ່ານບໍ່ສາມາດປິດບັນຊີຂອງຕົນເອງໄດ້.",
    "CONSTRAINT_VIOLATION": "ຂໍ້ມູນຂັດກັບກົດລະບຽບທາງການແພດ ຫຼື ທຸລະກິດ.",
    "INVALID_REFERENCE": "ບໍ່ພົບຂໍ້ມູນທີ່ອ້າງອີງ.",
    "PATIENT_INACTIVE": "ເວດລະບຽນຄົນເຈັບນີ້ບໍ່ໄດ້ໃຊ້ງານ.",
    "PATIENT_MISMATCH": "ຂໍ້ມູນທີ່ເລືອກເປັນຂອງຄົນເຈັບຄົນອື່ນ.",
    "NOTE_SIGNED": "ບັນທຶກທີ່ລົງນາມແລ້ວແກ້ໄຂບໍ່ໄດ້; ກະລຸນາສ້າງບັນທຶກແກ້ໄຂ.",
    "NOTE_NOT_SIGNED": "ແກ້ໄຂໄດ້ສະເພາະບັນທຶກທີ່ລົງນາມແລ້ວ.",
    "NO_DEPARTMENT": "ກະລຸນາເລືອກພະແນກກ່ອນ.",
    "IDEMPOTENCY_KEY_REUSED": "ຄຳຮ້ອງຊຳລະນີ້ຖືກໃຊ້ກັບໃບແຈ້ງໜີ້ອື່ນແລ້ວ.",
    "LOCALE_REQUIRED": "ບໍ່ສາມາດປິດພາສາອັງກິດໄດ້.",
    "RETRY": "ຂໍ້ມູນກຳລັງຖືກໃຊ້ຢູ່. ກະລຸນາລອງໃໝ່.",
    "EXAM_SIGNED": "ການກວດນີ້ລົງນາມແລ້ວ. ກະລຸນາສ້າງສະບັບແກ້ໄຂ.",
    "EXAM_EMPTY": "ກະລຸນາບັນທຶກຜົນກວດຢ່າງໜ້ອຍໜຶ່ງລາຍການກ່ອນລົງນາມ.",
    "EXAM_EXISTS": "ການມາກວດນີ້ມີການກວດຕາທີ່ເປີດຢູ່ແລ້ວ.",
    "EXAM_NOT_SIGNED": "ແກ້ໄຂໄດ້ສະເພາະການກວດທີ່ລົງນາມແລ້ວ.",
    "EYE_SIDE_MISMATCH": "ຕາບໍ່ກົງກັນ: ຂ້າງຕາບໍ່ກົງກັບແຜນ ຫຼື ຜົນວັດແທກ.",
    "PREOP_NOT_CONFIRMED": "ກະລຸນາເຮັດລາຍການກວດຄວາມປອດໄພກ່ອນຜ່າຕັດໃຫ້ສຳເລັດກ່ອນ.",
    "BIOMETRY_REQUIRED": "ການຜ່າຕັດຕາຕໍ້ຕ້ອງມີການວັດແທກຕາ (biometry) ຂອງຕາທີ່ຈະຜ່າ.",
    "IOL_NOT_SELECTED": "ກະລຸນາເລືອກເລນແກ້ວຕາທຽມກ່ອນຢືນຢັນ.",
    "IOL_POWER_MISMATCH": "ກຳລັງເລນທີ່ໃສ່ບໍ່ກົງກັບແຜນທີ່ເລືອກໄວ້.",
    "IMPLANT_EXPIRED": "ອຸປະກອນຝັງໝົດອາຍຸແລ້ວ.",
    "MEDICATION_EXPIRED": "ຢາລັອດນີ້ໝົດອາຍຸແລ້ວ.",
    "IOL_OUT_OF_RANGE": "ຄ່າວັດແທກຢູ່ນອກຂອບເຂດຂອງສູດ.",
    "BIOMETRY_LOCKED": "ຜົນວັດແທກນີ້ຖືກໃຊ້ຜ່າຕັດແລ້ວ.",
    "DATE_IN_PAST": "ວັນທີຜ່ານມາແລ້ວ.",
    "PATHWAY_SHARED": "ແມ່ແບບທີ່ໃຊ້ຮ່ວມກັນແກ້ໄຂບໍ່ໄດ້. ກະລຸນາສຳເນົາໄປໂຮງໝໍຂອງທ່ານ.",
    "STAGE_IN_USE": "ລຶບຂັ້ນຕອນທີ່ມີຄົນເຈັບຢູ່ບໍ່ໄດ້.",
    "PATHWAY_ARCHIVED": "ວົງຈອນນີ້ຖືກເກັບແລ້ວ.",
    "ACTIVATION_INVALID": "ລະຫັດເປີດໃຊ້ບໍ່ຖືກຕ້ອງ ຫຼື ໝົດອາຍຸ.",
    "OTP_INVALID": "ລະຫັດບໍ່ຖືກຕ້ອງ.",
    "OTP_EXPIRED": "ລະຫັດໝົດອາຍຸແລ້ວ. ກະລຸນາຂໍໃໝ່.",
    "OTP_LOCKED": "ໃສ່ຜິດຫຼາຍເທື່ອ. ກະລຸນາຂໍລະຫັດໃໝ່.",
    "OTP_RATE_LIMITED": "ຂໍລະຫັດຫຼາຍເກີນໄປ. ລອງໃໝ່ພາຍຫຼັງ.",
    "VERIFICATION_REQUIRED": "ກະລຸນາສະແດງບັດປະຈຳຕົວຢູ່ໂຕະລົງທະບຽນກ່ອນ.",
    "QUEUE_PAUSED": "ພະແນກນີ້ຢຸດຮັບບັດຄິວຜ່ານແອັບຊົ່ວຄາວ.",
    "EID_INVALID": "QR ບໍ່ຖືກຕ້ອງ ຫຼື ໝົດອາຍຸ. ໃຫ້ຄົນເຈັບໂຫຼດໃໝ່.",
    "EID_OTHER_HOSPITAL": "QR ນີ້ເປັນຂອງໂຮງໝໍອື່ນ.",
    "PHOTO_TOO_LARGE": "ຮູບຕ້ອງບໍ່ເກີນ 2 MB",
    "PHOTO_INVALID": "ກະລຸນາອັບໂຫຼດຮູບ JPEG, PNG ຫຼື WebP",
    "SUBDISTRICT_IN_USE": "ມີຄົນເຈັບຢູ່ໃນກຸ່ມບ້ານນີ້, ບໍ່ສາມາດລຶບໄດ້",
    "INSUFFICIENT_STOCK": "ສິນຄ້າທີ່ໃຊ້ໄດ້ບໍ່ພຽງພໍ",
    "SELF_APPROVAL": "ຕ້ອງໃຫ້ຜູ້ອື່ນກວດ ຫຼື ອະນຸມັດສິ່ງທີ່ທ່ານສ້າງເອງ",
    "NO_DISPENSING_STORE": "ຍັງບໍ່ໄດ້ຕັ້ງຄັງຈ່າຍຢາ",
    "NOTHING_APPROVED": "ອະນຸມັດຢ່າງໜ້ອຍໜຶ່ງລາຍການ ຫຼື ປະຕິເສດໃບສະເໜີ",
    "DUPLICATE_LINE": "ແຕ່ລະລາຍການໃສ່ໄດ້ຄັ້ງດຽວ",
    "DISCOUNT_EXCEEDS_BALANCE": "ສ່ວນຫຼຸດເຮັດໃຫ້ຍອດບິນຕ່ຳກວ່າທີ່ຈ່າຍແລ້ວ",
    "BED_UNAVAILABLE": "ຕຽງນີ້ບໍ່ຫວ່າງ",
    "BED_OCCUPIED": "ມີຄົນເຈັບຢູ່ຕຽງນີ້",
    "ALREADY_ADMITTED": "ຄົນເຈັບນອນໂຮງໝໍຢູ່ແລ້ວ",
    "WARD_OCCUPIED": "ຍັງມີຄົນເຈັບຢູ່ຫວອດນີ້",
    "ROOM_OCCUPIED": "ມີຕຽງໃນຫ້ອງນີ້ມີຄົນເຈັບ",
    "DISCHARGE_PENDING": "ຍັງມີວຽກທີ່ບໍ່ສຳເລັດ",
    "ADMISSION_HAS_ACTIVITY": "ມີຄຳສັ່ງ ຫຼື ບິນແລ້ວ, ໃຫ້ອອກໂຮງໝໍແທນ",
    "SAME_BED": "ຄົນເຈັບຢູ່ຕຽງນີ້ແລ້ວ",
    "ALREADY_BILLED": "ອອກບິນແລ້ວ, ກະລຸນາຍົກເລີກບິນກ່ອນ",
    "NOT_FOR_SALE": "ລາຍການນີ້ບໍ່ຂາຍ",
    "PATIENT_REQUIRED": "ກະລຸນາເລືອກຄົນເຈັບສຳລັບຢາຄວບຄຸມ",
    "NO_CASH_SESSION": "ກະລຸນາເປີດລິ້ນຊັກເງິນກ່ອນ",
    "SESSION_OPEN": "ທ່ານມີລິ້ນຊັກເງິນເປີດຢູ່ແລ້ວ",
    "SESSION_CLOSED": "ລິ້ນຊັກເງິນນັ້ນປິດແລ້ວ, ໃຫ້ບັນທຶກການສົ່ງຄືນແທນ",
    "STORE_INACTIVE": "ສາງນີ້ບໍ່ໄດ້ໃຊ້ງານ",
    "TOO_MANY_IMAGES": "ຮູບຫຼາຍເກີນໄປ",
    "POS_REFILL_ONLY": "ສິນຄ້າໄປຈຸດຂາຍ POS ຕ້ອງສົ່ງຕາມຄຳຂໍເຕີມສິນຄ້າ POS",
    "POS_OUTLET": "ສິນຄ້າຂອງຈຸດຂາຍ POS ປ່ຽນໄດ້ຜ່ານການເຕີມ ແລະ ການຂາຍເທົ່ານັ້ນ",
    "NOT_A_POS_OUTLET": "ການຂາຍຕ້ອງເຮັດຈາກຈຸດຂາຍ POS",
    "NOT_IN_CATALOG": "ຂໍໄດ້ສະເພາະສິນຄ້າທີ່ຢູ່ໃນລາຍການ POS",
    "NOTHING_TO_SEND": "ບໍ່ມີສິນຄ້າໃຫ້ສົ່ງ: ສາງບໍ່ມີສິນຄ້າທີ່ຂໍ",
    "EXCEEDS_SENT": "ຮັບຫຼາຍກວ່າທີ່ສົ່ງມາ",
    "DUPLICATE_CODE": "ລະຫັດນີ້ຖືກໃຊ້ແລ້ວ",
    "TYPE_IN_USE": "ປະເພດນີ້ຍັງມີພະຍາດຢູ່. ຍ້າຍພະຍາດ ຫຼື ປິດການໃຊ້ງານແທນ.",
    "SEGREGATION_OF_DUTIES": "ຕ້ອງໃຫ້ຜູ້ອື່ນທີ່ບໍ່ແມ່ນຜູ້ສ້າງເປັນຜູ້ອະນຸມັດ",
    "NOT_DRAFT": "ເຮັດໄດ້ສະເພາະສະບັບຮ່າງ",
    "NOT_VALIDATED": "ກະລຸນາກວດສອບກ່ອນ",
    "NOT_APPROVED": "ຕ້ອງອະນຸມັດກ່ອນ",
    "SNAPSHOT_HAS_ERRORS": "ສະບັບລາຍງານມີຂໍ້ຜິດພາດ; ແກ້ໄຂແລ້ວສ້າງສະບັບໃໝ່",
    "HASH_MISMATCH": "ເນື້ອໃນສະບັບລາຍງານບໍ່ກົງກັບລາຍນິ້ວມືຂໍ້ມູນ",
    "SNAPSHOT_FINAL": "ສະບັບລາຍງານນີ້ປ່ຽນແປງບໍ່ໄດ້ອີກ",
    "SNAPSHOT_NOT_APPROVED": "ສະບັບລາຍງານຕ້ອງໄດ້ຮັບການອະນຸມັດ",
    "OPEN_BATCH_EXISTS": "ມີຊຸດຂໍ້ມູນອື່ນສຳລັບຂໍ້ມູນດຽວກັນທີ່ຍັງເປີດຢູ່",
    "MAPPING_OVERLAP": "ມີການຈັບຄູ່ອື່ນຄອບຄຸມວັນທີເຫຼົ່ານີ້ແລ້ວ; ໃຫ້ເຊົາໃຊ້ອັນນັ້ນກ່ອນ",
    "METADATA_MISSING": "ກະລຸນາດຶງ metadata DHIS2 ກ່ອນ",
    "INSTANCE_DISABLED": "ການເຊື່ອມຕໍ່ DHIS2 ນີ້ຖືກປິດ",
    "NOT_RETRYABLE": "ຊຸດນີ້ສົ່ງໃໝ່ບໍ່ໄດ້",
    "NOT_RECONCILABLE": "ກວດທຽບໄດ້ສະເພາະຊຸດທີ່ສົ່ງແລ້ວ",
    "NOT_CANCELLABLE": "ຊຸດນີ້ຍົກເລີກບໍ່ໄດ້ແລ້ວ",
    "INVALID_PERIOD": "ໃສ່ໄລຍະເຊັ່ນ 202610, 2026Q4 ຫຼື 2026",
    "PERIOD_TYPE_MISMATCH": "ໄລຍະບໍ່ກົງກັບຄວາມຖີ່ຂອງລາຍງານ",
    "REPORT_RETIRED": "ລາຍງານນີ້ເຊົາໃຊ້ແລ້ວ",
    "REPORT_EMPTY": "ລາຍງານນີ້ບໍ່ມີ KPI ທີ່ໃຊ້ງານ",
    "NO_DIRECTION": "ກຳນົດກ່ອນວ່າສູງດີ ຫຼື ຕ່ຳດີ",
    "DUPLICATE_NAME": "ຊື່ນີ້ຖືກໃຊ້ແລ້ວ",
    "UNKNOWN_CALCULATOR": "ບໍ່ຮູ້ຈັກຕົວຄິດໄລ່",
    "CONCURRENT_CHANGE": "ມີການປ່ຽນແປງໃນລະຫວ່າງນີ້; ລອງໃໝ່",
    "ALREADY_RETIRED": "ເຊົາໃຊ້ແລ້ວ",
    "OWN_TENANT": "ທ່ານບໍ່ສາມາດລະງັບອົງກອນທີ່ທ່ານກຳລັງໃຊ້ຢູ່",
    "OWN_HOSPITAL": "ທ່ານບໍ່ສາມາດປິດໃຊ້ໂຮງໝໍທີ່ທ່ານກຳລັງໃຊ້ຢູ່",
    "REFERRAL_CLOSED": "ການສົ່ງຕໍ່ທີ່ສຳເລັດແລ້ວແກ້ໄຂບໍ່ໄດ້",
    "PATIENT_MERGED": "ບັນທຶກຄົນເຈັບນີ້ຖືກລວມເຂົ້າບັນທຶກອື່ນແລ້ວ",
    "MERGE_PENDING": "ການລວມສອງບັນທຶກນີ້ກຳລັງລໍຖ້າອະນຸມັດຢູ່ແລ້ວ",
    "BOTH_ADMITTED": "ທັງສອງບັນທຶກກຳລັງນອນໂຮງໝໍ; ໃຫ້ອອກໂຮງໝໍໜຶ່ງບັນທຶກກ່ອນ",
    "FOLLOW_UP_CLOSED": "ການນັດຕິດຕາມນີ້ສິ້ນສຸດແລ້ວ",
    "NOT_REQUESTED": "ຄຳຂໍນີ້ຖືກຕັດສິນແລ້ວ",
    "ROLE_LOCKED": "ຜູ້ດູແລສູງສຸດມີທຸກສິດສະເໝີ",
    "ROLE_BUILT_IN": "ບົດບາດທີ່ມີໃນລະບົບລຶບບໍ່ໄດ້; ໃຫ້ເອົາສິດອອກແທນ",
    "ROLE_IN_USE": "ບົດບາດນີ້ຍັງມອບໃຫ້ຜູ້ໃຊ້ຢູ່",
    "DISABILITY_TYPE_IN_USE": "ມີຄົນເຈັບທີ່ມີປະເພດຄວາມພິການນີ້. ໃຫ້ປິດການໃຊ້ແທນ.",
    "DISABILITY_TYPE_HAS_SUB_TYPES": "ລຶບ ຫຼື ຍ້າຍປະເພດຍ່ອຍຂອງມັນກ່ອນ."
  },
  "validation": {
    "required": "ຈຳເປັນຕ້ອງໃສ່",
    "invalid": "ຄ່າບໍ່ຖືກຕ້ອງ",
    "invalidType": "ຄ່າບໍ່ຖືກຕ້ອງ",
    "tooLong": "ຍາວເກີນໄປ",
    "invalidOption": "ກະລຸນາເລືອກຕົວເລືອກທີ່ຖືກຕ້ອງ",
    "invalidDate": "ກະລຸນາໃສ່ວັນທີທີ່ຖືກຕ້ອງ",
    "invalidDateTime": "ກະລຸນາໃສ່ວັນທີ ແລະ ເວລາທີ່ຖືກຕ້ອງ",
    "invalidNumber": "ກະລຸນາໃສ່ຕົວເລກ",
    "invalidInteger": "ກະລຸນາໃສ່ຈຳນວນເຕັມ",
    "outOfRange": "ຄ່າຢູ່ນອກຂອບເຂດ",
    "invalidEmail": "ກະລຸນາໃສ່ອີເມວທີ່ຖືກຕ້ອງ",
    "invalidPhone": "ກະລຸນາໃສ່ເບີໂທທີ່ຖືກຕ້ອງ",
    "implausibleDate": "ວັນທີບໍ່ສົມເຫດສົມຜົນ",
    "weakPassword": "ລະຫັດຜ່ານບໍ່ປອດໄພພໍ",
    "incorrect": "ບໍ່ຖືກຕ້ອງ",
    "inPast": "ເວລາຜ່ານມາແລ້ວ",
    "invalidKey": "ລະຫັດຂໍ້ຄວາມບໍ່ຖືກຕ້ອງ",
    "invalidValue": "ຂໍ້ຄວາມແປບໍ່ຖືກຕ້ອງ",
    "tooMany": "ລາຍການຫຼາຍເກີນໄປ",
    "mustConfirm": "ຕ້ອງຢືນຢັນ",
    "eyeSideMismatch": "ຕາບໍ່ກົງກັບການກວດ",
    "beforeStart": "ຕ້ອງຫຼັງວັນເລີ່ມ",
    "invalidUrl": "ກະລຸນາໃສ່ລິ້ງທີ່ຖືກຕ້ອງ",
    "exceedsOutstanding": "ຫຼາຍກວ່າຈຳນວນທີ່ຍັງຄ້າງ",
    "expired": "ໝົດອາຍຸແລ້ວ",
    "exceedsAvailable": "ຫຼາຍກວ່າທີ່ມີ",
    "insufficient": "ບໍ່ພຽງພໍ",
    "duplicate": "ຊ້ຳກັນ",
    "min": "ໜ້ອຍເກີນໄປ",
    "max": "ຫຼາຍເກີນໄປ",
    "notDiscountable": "ຄ່າທຳນຽມນີ້ບໍ່ສາມາດຫຼຸດໄດ້",
    "belowMin": "ຕ້ອງບໍ່ຕ່ຳກວ່າຂັ້ນຕ່ຳ",
    "inFuture": "ບໍ່ສາມາດເປັນເວລາໃນອະນາຄົດ",
    "tooOld": "ຍ້ອນຫຼັງຫຼາຍເກີນໄປ (ບໍ່ເກີນ 30 ວັນ)",
    "beforeAdmission": "ບໍ່ສາມາດກ່ອນເວລາເຂົ້າ ຫຼື ການຍ້າຍຕຽງຄັ້ງສຸດທ້າຍ",
    "httpsRequired": "ລະບົບຈິງຕ້ອງໃຊ້ https",
    "notFound": "ບໍ່ພົບ",
    "notAllowed": "ບໍ່ອະນຸຍາດຢູ່ບ່ອນນີ້",
    "platformOnly": "ສິດລະດັບແພລດຟອມມີໄດ້ສະເພາະຜູ້ດູແລສູງສຸດ",
    "disabilityAlone": "ປະເພດນີ້ເລືອກຮ່ວມກັບປະເພດອື່ນບໍ່ໄດ້",
    "disabilityOneSubtype": "ເລືອກປະເພດຍ່ອຍໄດ້ພຽງອັນດຽວ",
    "tooDeep": "ຫຼາຍຂັ້ນເກີນໄປ"
  },
  "enums": {
    "sex": {
      "MALE": "ຊາຍ",
      "FEMALE": "ຍິງ",
      "OTHER": "ອື່ນໆ",
      "UNKNOWN": "ບໍ່ຮູ້"
    },
    "maritalStatus": {
      "SINGLE": "ໂສດ",
      "MARRIED": "ແຕ່ງງານ",
      "DIVORCED": "ຢ່າຮ້າງ",
      "WIDOWED": "ໝ້າຍ",
      "SEPARATED": "ແຍກກັນຢູ່",
      "UNKNOWN": "ບໍ່ຮູ້"
    },
    "patientStatus": {
      "ACTIVE": "ໃຊ້ງານ",
      "INACTIVE": "ບໍ່ໃຊ້ງານ",
      "DECEASED": "ເສຍຊີວິດ",
      "MERGED": "ລວມເວດລະບຽນແລ້ວ"
    },
    "appointmentStatus": {
      "BOOKED": "ຈອງແລ້ວ",
      "CONFIRMED": "ຢືນຢັນແລ້ວ",
      "CHECKED_IN": "ລົງທະບຽນມາຮອດ",
      "IN_PROGRESS": "ກຳລັງກວດ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ",
      "NO_SHOW": "ບໍ່ມາຕາມນັດ"
    },
    "encounterStatus": {
      "PLANNED": "ວາງແຜນ",
      "IN_PROGRESS": "ກຳລັງດຳເນີນ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "encounterType": {
      "OPD": "ຄົນເຈັບນອກ",
      "IPD": "ຄົນເຈັບໃນ",
      "EMERGENCY": "ສຸກເສີນ",
      "TELEMEDICINE": "ກວດທາງໄກ",
      "HOME_VISIT": "ຢ້ຽມຢາມຢູ່ເຮືອນ"
    },
    "ticketStatus": {
      "WAITING": "ລໍຖ້າ",
      "CALLED": "ເອີ້ນແລ້ວ",
      "SERVING": "ກຳລັງບໍລິການ",
      "SERVED": "ບໍລິການແລ້ວ",
      "SKIPPED": "ຂ້າມ",
      "CANCELLED": "ຍົກເລີກ",
      "TRANSFERRED": "ສົ່ງຕໍ່ແລ້ວ"
    },
    "queuePriority": {
      "NORMAL": "ທຳມະດາ",
      "URGENT": "ດ່ວນ",
      "EMERGENCY": "ສຸກເສີນ",
      "PRIORITY": "ບູລິມະສິດ"
    },
    "labPriority": {
      "ROUTINE": "ທຳມະດາ",
      "URGENT": "ດ່ວນ",
      "STAT": "ດ່ວນທີ່ສຸດ"
    },
    "labOrderStatus": {
      "ORDERED": "ສັ່ງແລ້ວ",
      "COLLECTED": "ເກັບຕົວຢ່າງແລ້ວ",
      "IN_PROGRESS": "ກຳລັງວິເຄາະ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "labItemStatus": {
      "ORDERED": "ສັ່ງແລ້ວ",
      "RESULTED": "ມີຜົນແລ້ວ",
      "VERIFIED": "ຢືນຢັນແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "resultStatus": {
      "PRELIMINARY": "ຜົນເບື້ອງຕົ້ນ",
      "VERIFIED": "ຢືນຢັນແລ້ວ",
      "CORRECTED": "ແກ້ໄຂແລ້ວ"
    },
    "resultFlag": {
      "N": "ປົກກະຕິ",
      "L": "ຕ່ຳ",
      "H": "ສູງ",
      "LL": "ຕ່ຳວິກິດ",
      "HH": "ສູງວິກິດ",
      "A": "ຜິດປົກກະຕິ"
    },
    "prescriptionStatus": {
      "ISSUED": "ອອກໃບສັ່ງແລ້ວ",
      "PARTIALLY_DISPENSED": "ຈ່າຍຢາບາງສ່ວນ",
      "DISPENSED": "ຈ່າຍຢາແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "invoiceStatus": {
      "DRAFT": "ສະບັບຮ່າງ",
      "ISSUED": "ຍັງບໍ່ຊຳລະ",
      "PARTIALLY_PAID": "ຊຳລະບາງສ່ວນ",
      "PAID": "ຊຳລະແລ້ວ",
      "VOID": "ຍົກເລີກ"
    },
    "paymentStatus": {
      "PENDING": "ລໍຖ້າ",
      "COMPLETED": "ສຳເລັດ",
      "FAILED": "ລົ້ມເຫຼວ",
      "REFUNDED": "ຄືນເງິນແລ້ວ"
    },
    "paymentMethod": {
      "CASH": "ເງິນສົດ",
      "CARD": "ບັດ",
      "BANK_TRANSFER": "ໂອນຜ່ານທະນາຄານ",
      "QR": "ຊຳລະຜ່ານ QR",
      "MOBILE_MONEY": "ເງິນມືຖື",
      "INSURANCE": "ປະກັນໄພ"
    },
    "allergySeverity": {
      "MILD": "ເລັກນ້ອຍ",
      "MODERATE": "ປານກາງ",
      "SEVERE": "ຮຸນແຮງ",
      "LIFE_THREATENING": "ອັນຕະລາຍເຖິງຊີວິດ"
    },
    "allergyStatus": {
      "ACTIVE": "ຍັງມີ",
      "INACTIVE": "ບໍ່ມີແລ້ວ",
      "RESOLVED": "ຫາຍແລ້ວ",
      "ENTERED_IN_ERROR": "ບັນທຶກຜິດ"
    },
    "alertSeverity": {
      "INFO": "ຂໍ້ມູນ",
      "WARNING": "ເຕືອນ",
      "CRITICAL": "ວິກິດ"
    },
    "noteType": {
      "SOAP": "SOAP",
      "PROGRESS": "ຄວາມຄືບໜ້າ",
      "ADMISSION": "ຮັບເຂົ້ານອນ",
      "DISCHARGE": "ອອກໂຮງໝໍ",
      "NURSING": "ພະຍາບານ",
      "CONSULT": "ປຶກສາ",
      "PROCEDURE": "ຫັດຖະການ"
    },
    "noteStatus": {
      "DRAFT": "ສະບັບຮ່າງ",
      "SIGNED": "ລົງນາມແລ້ວ",
      "AMENDED": "ຖືກແກ້ໄຂ"
    },
    "diagnosisType": {
      "PRIMARY": "ຫຼັກ",
      "SECONDARY": "ຮອງ",
      "ADMITTING": "ເມື່ອຮັບເຂົ້າ",
      "DISCHARGE": "ເມື່ອອອກ",
      "DIFFERENTIAL": "ແຍກໂລກ"
    },
    "verificationStatus": {
      "PROVISIONAL": "ເບື້ອງຕົ້ນ",
      "CONFIRMED": "ຢືນຢັນແລ້ວ",
      "REFUTED": "ຕັດອອກ",
      "ENTERED_IN_ERROR": "ບັນທຶກຜິດ"
    },
    "departmentType": {
      "CLINICAL": "ຄລີນິກ",
      "DIAGNOSTIC": "ບົ່ງມະຕິ",
      "SUPPORT": "ສະໜັບສະໜູນ",
      "ADMINISTRATIVE": "ບໍລິຫານ"
    },
    "userStatus": {
      "ACTIVE": "ໃຊ້ງານ",
      "LOCKED": "ຖືກລັອກ",
      "DISABLED": "ປິດການໃຊ້ງານ"
    },
    "role": {
      "SUPER_ADMIN": "ຜູ້ດູແລລະບົບສູງສຸດ",
      "HOSPITAL_ADMIN": "ຜູ້ດູແລໂຮງໝໍ",
      "DOCTOR": "ທ່ານໝໍ",
      "NURSE": "ພະຍາບານ",
      "RECEPTIONIST": "ພະນັກງານຕ້ອນຮັບ",
      "PHARMACIST": "ເພສັດກອນ",
      "LAB_TECHNICIAN": "ພະນັກງານຫ້ອງວິເຄາະ",
      "CASHIER": "ພະນັກງານເກັບເງິນ",
      "OPTOMETRIST": "ນັກວັດແທກສາຍຕາ",
      "INVENTORY_MANAGER": "ຜູ້ຈັດການຄັງ",
      "PROCUREMENT_APPROVER": "ຜູ້ອະນຸມັດການຈັດຊື້",
      "IMAGING_TECHNICIAN": "ນັກເຕັກນິກຮູບພາບການແພດ",
      "ACCOUNTANT": "ເຈົ້າໜ້າທີ່ການເງິນ",
      "POS_MANAGER": "ຜູ້ຈັດການຮ້ານຂາຍຢາ",
      "REPORTING_OFFICER": "ເຈົ້າໜ້າທີ່ລາຍງານລະດັບຊາດ",
      "REPORTING_APPROVER": "ຜູ້ອະນຸມັດລາຍງານ",
      "SYSTEM_ADMIN": "ຜູ້ດູແລລະບົບ",
      "HOSPITAL_DIRECTOR": "ຜູ້ອຳນວຍການໂຮງໝໍ",
      "MEDICAL_DIRECTOR": "ຮອງຜູ້ອຳນວຍການດ້ານການແພດ",
      "OPHTHALMOLOGIST": "ແພດຊ່ຽວຊານຕາ",
      "OPHTHALMIC_SURGEON": "ແພດຜ່າຕັດຕາ",
      "OPHTHALMIC_NURSE": "ພະຍາບານຕາ",
      "DIAGNOSTIC_TECHNICIAN": "ນັກວິຊາການກວດວິນິດໄສ",
      "MEDICAL_RECORDS_OFFICER": "ເຈົ້າໜ້າທີ່ເວດລະບຽນ",
      "AUDITOR": "ຜູ້ກວດສອບ",
      "QUEUE_DEVICE": "ອຸປະກອນຕູ້ບໍລິການ / ຈໍສະແດງ"
    },
    "medicationOrderStatus": {
      "ACTIVE": "ລໍຖ້າຈ່າຍ",
      "COMPLETED": "ຈ່າຍແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "eyeExamStatus": {
      "DRAFT": "ຮ່າງ",
      "IN_PROGRESS": "ກຳລັງກວດ",
      "SIGNED": "ລົງນາມແລ້ວ",
      "AMENDED": "ຖືກແກ້ໄຂແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "surgeryStatus": {
      "PLANNED": "ວາງແຜນແລ້ວ",
      "CONFIRMED": "ຢືນຢັນລາຍການກວດແລ້ວ",
      "IN_PROGRESS": "ກຳລັງຜ່າຕັດ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "followUpStatus": {
      "SCHEDULED": "ນັດແລ້ວ",
      "COMPLETED": "ສຳເລັດ",
      "MISSED": "ບໍ່ມາ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "eyeMedStatus": {
      "ACTIVE": "ກຳລັງໃຊ້",
      "COMPLETED": "ຄົບກຳນົດ",
      "STOPPED": "ຢຸດແລ້ວ"
    },
    "carePlanStatus": {
      "ACTIVE": "ກຳລັງດຳເນີນ",
      "COMPLETED": "ສຳເລັດ",
      "STOPPED": "ຢຸດແລ້ວ"
    },
    "portalStatus": {
      "ACTIVE": "ແອັບໃຊ້ງານໄດ້",
      "DISABLED": "ແອັບຖືກປິດ"
    },
    "portalVerification": {
      "VERIFIED": "ຢືນຢັນຕົວຕົນແລ້ວ",
      "PENDING_VERIFICATION": "ລໍຖ້າກວດບັດ"
    },
    "queueStatus": {
      "OPEN": "ເປີດ",
      "PAUSED": "ຢຸດຮັບບັດຜ່ານແອັບ",
      "CLOSED": "ປິດ"
    },
    "inventoryItemType": {
      "DRUG": "ຢາ",
      "SUPPLY": "ວັດສະດຸການແພດ",
      "EQUIPMENT": "ອຸປະກອນ",
      "DEVICE": "ອຸປະກອນການແພດ (ຂາຍ)"
    },
    "stockStatus": {
      "OUT": "ໝົດ",
      "LOW": "ໃກ້ໝົດ",
      "OK": "ພຽງພໍ",
      "OVER": "ເກີນ",
      "ASSET": "ລາຍເຄື່ອງ",
      "EXPIRING": "ໃກ້ໝົດອາຍຸ ≤ 90 ມື້"
    },
    "expiryStatus": {
      "EXPIRED": "ໝົດອາຍຸ",
      "EXPIRING": "ໃກ້ໝົດອາຍຸ"
    },
    "lotStatus": {
      "AVAILABLE": "ພ້ອມໃຊ້",
      "QUARANTINE": "ກັກໄວ້"
    },
    "movementType": {
      "OPENING": "ຍອດຍົກມາ",
      "RECEIPT": "ຮັບສິນຄ້າ",
      "DISPENSE": "ຈ່າຍຢາຕາມໃບສັ່ງ",
      "ISSUE": "ເບີກໃຫ້ພະແນກ",
      "TRANSFER_OUT": "ໂອນອອກ",
      "TRANSFER_IN": "ໂອນເຂົ້າ",
      "ADJUSTMENT_IN": "ປັບເພີ່ມ",
      "ADJUSTMENT_OUT": "ປັບຫຼຸດ",
      "WRITE_OFF": "ຕັດຈຳໜ່າຍ",
      "RETURN_TO_SUPPLIER": "ສົ່ງຄືນຜູ້ສະໜອງ",
      "SALE": "ຂາຍໜ້າຮ້ານ",
      "SALE_RETURN": "ຮັບຄືນຈາກການຂາຍ"
    },
    "adjustmentReason": {
      "OPENING_BALANCE": "ຍອດຍົກມາ",
      "COUNT_CORRECTION": "ແກ້ໄຂຈາກການກວດນັບ",
      "DONATION": "ໄດ້ຮັບບໍລິຈາກ",
      "FOUND": "ພົບເພີ່ມ",
      "EXPIRED": "ໝົດອາຍຸ",
      "DAMAGED": "ເສຍຫາຍ",
      "LOST": "ສູນຫາຍ",
      "RECALLED": "ຖືກຮຽກຄືນ",
      "DEFECTIVE": "ບົກພ່ອງ",
      "OTHER": "ອື່ນໆ"
    },
    "prStatus": {
      "DRAFT": "ສະບັບຮ່າງ",
      "SUBMITTED": "ລໍຖ້າອະນຸມັດ",
      "APPROVED": "ອະນຸມັດແລ້ວ",
      "REJECTED": "ປະຕິເສດ",
      "ORDERED": "ສັ່ງຊື້ແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "prPriority": {
      "NORMAL": "ປົກກະຕິ",
      "URGENT": "ດ່ວນ"
    },
    "poStatus": {
      "DRAFT": "ສະບັບຮ່າງ",
      "APPROVED": "ອະນຸມັດແລ້ວ",
      "SENT": "ສົ່ງຜູ້ສະໜອງແລ້ວ",
      "PARTIALLY_RECEIVED": "ຮັບແລ້ວບາງສ່ວນ",
      "RECEIVED": "ຮັບຄົບແລ້ວ",
      "CLOSED": "ປິດແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "storeType": {
      "MAIN": "ຄັງໃຫຍ່",
      "PHARMACY": "ຮ້ານຢາ",
      "WARD": "ຄັງຫວອດ",
      "CLINIC": "ຄັງຫ້ອງກວດ",
      "POS": "ຈຸດຂາຍ POS"
    },
    "assetStatus": {
      "IN_SERVICE": "ໃຊ້ງານໄດ້",
      "UNDER_MAINTENANCE": "ກຳລັງສ້ອມແປງ",
      "OUT_OF_SERVICE": "ໃຊ້ງານບໍ່ໄດ້",
      "DISPOSED": "ຈຳໜ່າຍແລ້ວ"
    },
    "assetEvent": {
      "MAINTENANCE": "ບຳລຸງຮັກສາ",
      "CALIBRATION": "ການປັບທຽບ",
      "INSPECTION": "ການກວດກາ",
      "REPAIR": "ການສ້ອມແປງ",
      "STATUS_CHANGE": "ປ່ຽນສະຖານະ",
      "TRANSFER": "ຍ້າຍ"
    },
    "maintenanceStatus": {
      "OK": "ຕາມກຳນົດ",
      "DUE": "ຮອດກຳນົດ ≤ 30 ມື້",
      "OVERDUE": "ເລີຍກຳນົດ",
      "NONE": "—"
    },
    "stockUnit": {
      "TABLET": "ເມັດ",
      "CAPSULE": "ແຄບຊູນ",
      "BOTTLE": "ຂວດ",
      "VIAL": "ຂວດນ້ອຍ",
      "AMPOULE": "ແອມພູນ",
      "SACHET": "ຊອງ",
      "TUBE": "ຫຼອດ",
      "INHALER": "ເຄື່ອງພົ່ນ",
      "PIECE": "ອັນ",
      "BOX": "ກ່ອງ",
      "PACK": "ແພັກ",
      "ROLL": "ມ້ວນ",
      "SYRINGE": "ເຂັມສັກ",
      "SET": "ຊຸດ",
      "UNIT": "ໜ່ວຍ"
    },
    "bedStatus": {
      "AVAILABLE": "ຫວ່າງ",
      "OCCUPIED": "ມີຄົນເຈັບ",
      "CLEANING": "ກຳລັງທຳຄວາມສະອາດ",
      "RESERVED": "ຈອງແລ້ວ",
      "OUT_OF_SERVICE": "ບໍ່ພ້ອມໃຊ້"
    },
    "roomType": {
      "STANDARD": "ທຳມະດາ",
      "PRIVATE": "ຫ້ອງດ່ຽວ",
      "VIP": "VIP",
      "ICU": "ຫ້ອງເບິ່ງແຍງພິເສດ",
      "OBSERVATION": "ຫ້ອງສັງເກດອາການ",
      "ISOLATION": "ຫ້ອງແຍກ"
    },
    "wardType": {
      "GENERAL": "ທົ່ວໄປ",
      "SURGICAL": "ຜ່າຕັດ",
      "PEDIATRIC": "ເດັກ",
      "MATERNITY": "ແມ່ ແລະ ເດັກ",
      "ICU": "ເບິ່ງແຍງພິເສດ",
      "OBSERVATION": "ສັງເກດອາການ",
      "ISOLATION": "ແຍກໂຣກ",
      "PRIVATE": "ຫ້ອງພິເສດ"
    },
    "bedType": {
      "STANDARD": "ທຳມະດາ",
      "ELECTRIC": "ຕຽງໄຟຟ້າ",
      "ICU": "ICU",
      "PEDIATRIC": "ເດັກ",
      "CRIB": "ຕຽງເດັກອ່ອນ"
    },
    "admissionType": {
      "EMERGENCY": "ສຸກເສີນ",
      "ELECTIVE": "ນັດລ່ວງໜ້າ",
      "TRANSFER_IN": "ສົ່ງຕໍ່ມາ",
      "DAY_CASE": "ນອນພາຍໃນມື້",
      "MATERNITY": "ເກີດລູກ"
    },
    "admissionStatus": {
      "ADMITTED": "ກຳລັງນອນໂຮງໝໍ",
      "DISCHARGED": "ອອກໂຮງໝໍແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "dischargeType": {
      "HOME": "ກັບບ້ານ",
      "REFERRED": "ສົ່ງຕໍ່",
      "AGAINST_ADVICE": "ອອກເອງ (ບໍ່ຕາມຄຳແນະນຳ)",
      "TRANSFERRED": "ຍ້າຍໂຮງໝໍ",
      "DECEASED": "ເສຍຊີວິດ"
    },
    "stayReason": {
      "ADMISSION": "ເຂົ້ານອນ",
      "TRANSFER": "ຍ້າຍຕຽງ"
    },
    "serviceCategory": {
      "XRAY": "ເອັກສະເຣ",
      "CT": "ຊີທີສະແກນ",
      "MRI": "MRI",
      "ULTRASOUND": "ອັລຕຣາຊາວ",
      "ECG": "ຄື້ນໄຟຟ້າຫົວໃຈ",
      "ECHO": "ອັລຕຣາຊາວຫົວໃຈ",
      "ENDOSCOPY": "ສ່ອງກ້ອງ",
      "PHYSIOTHERAPY": "ກາຍະພາບບຳບັດ",
      "DENTAL": "ແຂ້ວ",
      "PROCEDURE": "ຫັດຖະການ",
      "OTHER": "ອື່ນໆ"
    },
    "serviceOrderStatus": {
      "ORDERED": "ສັ່ງແລ້ວ",
      "IN_PROGRESS": "ກຳລັງດຳເນີນ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "serviceItemStatus": {
      "ORDERED": "ລໍຖ້າ",
      "IN_PROGRESS": "ກຳລັງເຮັດ",
      "REPORTED": "ລາຍງານແລ້ວ",
      "VERIFIED": "ຢັ້ງຢືນແລ້ວ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "saleStatus": {
      "COMPLETED": "ຊຳລະແລ້ວ",
      "PARTIALLY_RETURNED": "ສົ່ງຄືນບາງສ່ວນ",
      "RETURNED": "ສົ່ງຄືນແລ້ວ",
      "VOIDED": "ຍົກເລີກການຂາຍ"
    },
    "stockDocType": {
      "RECEIPT": "ຮັບສິນຄ້າ",
      "OPENING": "ຍອດຍົກມາ",
      "ADJUSTMENT_IN": "ປັບເພີ່ມ",
      "ISSUE": "ໃບເບີກ",
      "TRANSFER": "ໂອນຍ້າຍ",
      "ADJUSTMENT_OUT": "ປັບຫຼຸດ",
      "WRITE_OFF": "ຕັດຈຳໜ່າຍ",
      "RETURN_TO_SUPPLIER": "ສົ່ງຄືນຜູ້ສະໜອງ"
    },
    "stockDocStatus": {
      "DRAFT": "ຮ່າງ",
      "SUBMITTED": "ລໍຖ້າກວດສອບ",
      "POSTED": "ລົງບັນຊີແລ້ວ",
      "REJECTED": "ຖືກປະຕິເສດ",
      "CANCELLED": "ຍົກເລີກ",
      "IN_TRANSIT": "ກຳລັງຂົນສົ່ງ"
    },
    "expenseCategory": {
      "SUPPLIES": "ວັດສະດຸສິ້ນເປືອງ",
      "UTILITIES": "ຄ່າໄຟ ແລະ ນ້ຳ",
      "SALARIES": "ເງິນເດືອນ",
      "MAINTENANCE": "ສ້ອມແປງ",
      "RENT": "ຄ່າເຊົ່າ",
      "TRANSPORT": "ຂົນສົ່ງ",
      "MARKETING": "ໂຄສະນາ",
      "TRAINING": "ຝຶກອົບຮົມ",
      "TAXES": "ອາກອນ ແລະ ຄ່າທຳນຽມ",
      "OTHER": "ອື່ນໆ"
    },
    "expenseStatus": {
      "SUBMITTED": "ລໍຖ້າອະນຸມັດ",
      "APPROVED": "ອະນຸມັດແລ້ວ",
      "REJECTED": "ຖືກປະຕິເສດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "cashSessionStatus": {
      "OPEN": "ເປີດຢູ່",
      "CLOSED": "ປິດແລ້ວ – ລໍຖ້າກວດ",
      "VERIFIED": "ກວດແລ້ວ"
    },
    "priceType": {
      "CHARGE_ITEM": "ຄ່າທຳນຽມ",
      "SERVICE": "ບໍລິການພິເສດ",
      "MEDICATION": "ຢາ",
      "LAB_TEST": "ການກວດວິເຄາະ",
      "ROOM": "ຄ່າຕຽງ",
      "INVENTORY_ITEM": "ລາຄາແນະນຳຈາກສາງ",
      "POS_PRODUCT": "ຮ້ານຂາຍຢາ POS"
    },
    "priceStatus": {
      "ACTIVE": "ໃຊ້ງານ",
      "INACTIVE": "ບໍ່ໃຊ້ງານ",
      "DISCONTINUED": "ຢຸດຈຳໜ່າຍ",
      "NOT_FOR_SALE": "ບໍ່ຂາຍ"
    },
    "discountType": {
      "AMOUNT": "ຈຳນວນເງິນ",
      "PERCENT": "ເປີເຊັນ"
    },
    "plSection": {
      "REVENUE": "ລາຍຮັບ",
      "COST": "ຕົ້ນທຶນສິນຄ້າ",
      "EXPENSES": "ລາຍຈ່າຍ",
      "RESULT": "ຜົນໄດ້ຮັບ"
    },
    "plLine": {
      "INVOICES": "ໃບບິນຄົນເຈັບ",
      "POS_SALES": "ຂາຍໜ້າຮ້ານ",
      "REFUNDS": "ເງິນຄືນ",
      "TOTAL_REVENUE": "ລາຍຮັບລວມ",
      "COST_OF_GOODS": "ຢາ ແລະ ວັດສະດຸທີ່ໃຊ້",
      "GROSS_PROFIT": "ກຳໄລຂັ້ນຕົ້ນ",
      "TOTAL_EXPENSES": "ລາຍຈ່າຍລວມ",
      "NET_PROFIT": "ກຳໄລສຸດທິ"
    },
    "posLevel": {
      "OK": "ພຽງພໍ",
      "LOW": "ໃກ້ໝົດ",
      "OUT": "ໝົດ"
    },
    "posProductStatus": {
      "PUBLISHED": "ສະແດງຢູ່ POS",
      "HIDDEN": "ເຊື່ອງໄວ້"
    },
    "outletStatus": {
      "ACTIVE": "ກຳລັງໃຊ້",
      "INACTIVE": "ບໍ່ໄດ້ໃຊ້"
    },
    "refillStatus": {
      "DRAFT": "ສະບັບຮ່າງ",
      "SUBMITTED": "ລໍຖ້າສາງ",
      "PREPARING": "ກຳລັງກະກຽມ",
      "IN_TRANSIT": "ກຳລັງຂົນສົ່ງ",
      "RECEIVED": "ຮັບແລ້ວ",
      "REJECTED": "ຖືກປະຕິເສດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "patientTitle": {
      "MR": "ທ້າວ",
      "MRS": "ນາງ",
      "MISS": "ນາງສາວ",
      "BOY": "ເດັກຊາຍ",
      "GIRL": "ເດັກຍິງ",
      "DR": "ດຣ.",
      "MONK": "ພຣະ",
      "NOVICE": "ສາມະເນນ",
      "NUN": "ແມ່ຂາວ"
    },
    "reporting": {
      "ACHIEVED": "ບັນລຸ",
      "WARNING": "ເຕືອນ",
      "MISSED": "ບໍ່ບັນລຸ",
      "INSUFFICIENT_DATA": "ຂໍ້ມູນບໍ່ພຽງພໍ",
      "NOT_APPLICABLE": "ບໍ່ມີເປົ້າໝາຍ",
      "PENDING_REVIEW": "ລໍຖ້າທົບທວນ",
      "OK": "ປົກກະຕິ",
      "INCOMPLETE": "ບໍ່ຄົບ",
      "INVALID": "ບໍ່ຖືກຕ້ອງ",
      "DRAFT": "ຮ່າງ",
      "VALIDATED": "ກວດສອບແລ້ວ",
      "APPROVED": "ອະນຸມັດແລ້ວ",
      "SUPERSEDED": "ຖືກແທນທີ່",
      "INVALIDATED": "ຖືກຍົກເລີກ",
      "ACTIVE": "ໃຊ້ງານ",
      "RETIRED": "ເຊົາໃຊ້",
      "QUEUED": "ລໍຖ້າສົ່ງ",
      "SUBMITTING": "ກຳລັງສົ່ງ",
      "ACCEPTED": "ຮັບແລ້ວ",
      "PARTIALLY_ACCEPTED": "ຮັບບາງສ່ວນ",
      "REJECTED": "ຖືກປະຕິເສດ",
      "RETRY_PENDING": "ລໍຖ້າສົ່ງໃໝ່",
      "RECONCILIATION_REQUIRED": "ຕ້ອງກວດທຽບ",
      "CANCELLED": "ຍົກເລີກ",
      "PENDING": "ລໍຖ້າ",
      "IGNORED": "ຖືກຂ້າມ"
    },
    "kpiCategory": {
      "OPERATIONS": "ການບໍລິການ",
      "CLINICAL": "ຄລີນິກ",
      "SURGERY": "ການຜ່າຕັດ",
      "EYE_HEALTH": "ສຸຂະພາບຕາ",
      "EPIDEMIOLOGY": "ລະບາດວິທະຍາ",
      "INPATIENT": "ຄົນເຈັບໃນ",
      "SUPPLIES": "ພັດສະດຸ",
      "DATA_QUALITY": "ຄຸນນະພາບຂໍ້ມູນ",
      "STAFF": "ພະນັກງານ"
    },
    "kpiUnit": {
      "COUNT": "ຈຳນວນ",
      "PERCENT": "ເປີເຊັນ",
      "MINUTES": "ນາທີ",
      "DAYS": "ມື້",
      "RATIO": "ອັດຕາສ່ວນ"
    },
    "kpiDirection": {
      "HIGHER_BETTER": "ສູງຍິ່ງດີ",
      "LOWER_BETTER": "ຕ່ຳຍິ່ງດີ",
      "INFO": "ເພື່ອຂໍ້ມູນ"
    },
    "dimension": {
      "SEX": "ເພດ",
      "AGE_BAND": "ກຸ່ມອາຍຸ",
      "MALE": "ຊາຍ",
      "FEMALE": "ຍິງ",
      "AGE_0_14": "0–14 ປີ",
      "AGE_15_49": "15–49 ປີ",
      "AGE_50P": "50 ປີຂຶ້ນໄປ"
    },
    "dhis2Env": {
      "MOCK": "ຈຳລອງ",
      "STAGING": "ທົດສອບ",
      "PRODUCTION": "ລະບົບຈິງ"
    },
    "mappingType": {
      "ORG_UNIT": "ຫົວໜ່ວຍການຈັດຕັ້ງ",
      "DATA_SET": "ຊຸດຂໍ້ມູນ",
      "DATA_ELEMENT": "ອົງປະກອບຂໍ້ມູນ",
      "CATEGORY_OPTION": "ທາງເລືອກໝວດ"
    },
    "valueTransform": {
      "NONE": "ຕາມທີ່ຄິດໄລ່",
      "ROUND": "ຈຳນວນເຕັມ",
      "ONE_DECIMAL": "ທົດສະນິຍົມ 1 ຕຳແໜ່ງ"
    },
    "metadataKind": {
      "ORG_UNIT": "ຫົວໜ່ວຍ",
      "DATA_SET": "ຊຸດຂໍ້ມູນ",
      "DATA_ELEMENT": "ອົງປະກອບຂໍ້ມູນ",
      "CATEGORY_OPTION_COMBO": "ກຸ່ມໝວດ",
      "ATTRIBUTE_OPTION_COMBO": "ກຸ່ມຄຸນລັກສະນະ"
    },
    "tenantType": {
      "HEALTHCARE_GROUP": "ກຸ່ມສາທາລະນະສຸກ",
      "HOSPITAL": "ໂຮງໝໍ",
      "CLINIC": "ຄລີນິກ",
      "GOVERNMENT": "ລັດຖະບານ",
      "NGO": "ອົງການບໍ່ຂຶ້ນກັບລັດ"
    },
    "tenantStatus": {
      "ACTIVE": "ໃຊ້ງານ",
      "SUSPENDED": "ລະງັບ",
      "INACTIVE": "ປິດໃຊ້"
    },
    "referralStatus": {
      "REQUESTED": "ຂໍສົ່ງຕໍ່",
      "SENT": "ສົ່ງແລ້ວ",
      "ACCEPTED": "ຮັບແລ້ວ",
      "DECLINED": "ຖືກປະຕິເສດ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ",
      "UNREACHABLE": "ຕິດຕໍ່ບໍ່ໄດ້"
    },
    "referralDirection": {
      "OUT": "ສົ່ງອອກ",
      "IN": "ຮັບເຂົ້າ"
    },
    "referralPriority": {
      "ROUTINE": "ປົກກະຕິ",
      "URGENT": "ດ່ວນ",
      "EMERGENCY": "ສຸກເສີນ"
    },
    "referralTransport": {
      "SELF": "ເດີນທາງເອງ",
      "FAMILY": "ກັບຄອບຄົວ",
      "AMBULANCE": "ລົດໂຮງໝໍສຸກເສີນ",
      "HOSPITAL_VEHICLE": "ລົດໂຮງໝໍ",
      "OTHER": "ອື່ນໆ"
    },
    "referralEvent": {
      "CREATED": "ສ້າງ",
      "UPDATED": "ແກ້ໄຂ",
      "SENT": "ສົ່ງ",
      "ACCEPTED": "ຮັບ",
      "DECLINED": "ປະຕິເສດ",
      "CONTACT_ATTEMPT": "ຕິດຕໍ່",
      "UNREACHABLE": "ຕິດຕໍ່ບໍ່ໄດ້",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "contactResult": {
      "REACHED": "ຕິດຕໍ່ໄດ້",
      "NO_ANSWER": "ບໍ່ມີຄົນຮັບ",
      "WRONG_NUMBER": "ເບີຜິດ",
      "LEFT_MESSAGE": "ຝາກຂໍ້ຄວາມ"
    },
    "followUpPriority": {
      "ROUTINE": "ປົກກະຕິ",
      "URGENT": "ດ່ວນ"
    },
    "mergeStatus": {
      "REQUESTED": "ລໍຖ້າອະນຸມັດ",
      "APPROVED": "ລວມແລ້ວ",
      "REJECTED": "ປະຕິເສດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "queuePriorityReason": {
      "ELDERLY": "ຜູ້ສູງອາຍຸ",
      "DISABILITY": "ຄົນພິການ",
      "PREGNANT": "ແມ່ຍິງຖືພາ",
      "CHILD": "ເດັກນ້ອຍ",
      "CLINICAL": "ທາງຄລີນິກ",
      "OTHER": "ອື່ນໆ"
    },
    "queueStage": {
      "REGISTRATION": "ລົງທະບຽນ",
      "TRIAGE": "ຄັດແຍກ",
      "EXAMINATION": "ກວດ",
      "CONSULTATION": "ປຶກສາແພດ",
      "DIAGNOSTICS": "ກວດວິເຄາະ",
      "SURGERY": "ຜ່າຕັດ",
      "PHARMACY": "ຮ້ານຢາ",
      "CASHIER": "ຈ່າຍເງິນ",
      "OTHER": "ອື່ນໆ"
    },
    "queueSource": {
      "DESK": "ເຄົາເຕີ້",
      "APPOINTMENT": "ເຊັກອິນນັດໝາຍ",
      "QR": "ເຊັກອິນດ້ວຍ QR",
      "KIOSK": "ຕູ້ບໍລິການ",
      "MOBILE": "ແອັບຄົນເຈັບ"
    },
    "queueEvent": {
      "ISSUED": "ອອກບັດຄິວ",
      "CALLED": "ເອີ້ນແລ້ວ",
      "RECALLED": "ເອີ້ນຊ້ຳ",
      "SERVING": "ເລີ່ມບໍລິການ",
      "COMPLETED": "ສຳເລັດ",
      "SKIPPED": "ຂ້າມ (ບໍ່ຢູ່)",
      "REQUEUED": "ກັບເຂົ້າຄິວ",
      "RETURNED": "ກັບໄປລໍຖ້າ",
      "CANCELLED": "ຍົກເລີກ",
      "TRANSFERRED": "ສົ່ງຕໍ່",
      "PRIORITY_CHANGED": "ປ່ຽນບູລິມະສິດ",
      "PATIENT_LINKED": "ເຊື່ອມປະຫວັດຄົນເຈັບ"
    },
    "queueActor": {
      "STAFF": "ພະນັກງານ",
      "KIOSK": "ຕູ້ບໍລິການ",
      "PATIENT_APP": "ແອັບຄົນເຈັບ",
      "SYSTEM": "ລະບົບ"
    },
    "queueVisitStatus": {
      "ACTIVE": "ຢູ່ໂຮງໝໍ",
      "COMPLETED": "ສຳເລັດ",
      "CANCELLED": "ຍົກເລີກ"
    },
    "queueServiceStatus": {
      "ACTIVE": "ໃຊ້ງານ",
      "INACTIVE": "ບໍ່ໃຊ້ງານ"
    }
  },
  "dashboard": {
    "title": "ໜ້າຫຼັກ",
    "welcome": "ສະບາຍດີ, {{name}}",
    "subtitle": "ມື້ນີ້ທີ່ {{hospital}}",
    "patientsTotal": "ຄົນເຈັບທີ່ໃຊ້ງານ",
    "registeredToday": "ລົງທະບຽນມື້ນີ້",
    "appointmentsToday": "ນັດໝາຍມື້ນີ້",
    "queueWaiting": "ລໍຖ້າໃນຄິວ",
    "avgWait": "ເວລາລໍຖ້າສະເລ່ຍ",
    "openEncounters": "ການກວດທີ່ກຳລັງດຳເນີນ",
    "pendingPrescriptions": "ໃບສັ່ງຢາລໍຖ້າຈ່າຍ",
    "pendingLabOrders": "ຄຳສັ່ງວິເຄາະລໍຖ້າ",
    "revenueToday": "ລາຍຮັບມື້ນີ້",
    "outstanding": "ຍອດຄ້າງຊຳລະ",
    "encountersTrend": "ການກວດ · 7 ມື້ຜ່ານມາ",
    "revenueTrend": "ລາຍຮັບ · 7 ມື້ຜ່ານມາ",
    "appointmentsByDepartment": "ນັດໝາຍມື້ນີ້ຕາມພະແນກ",
    "minutes": "{{value}} ນາທີ",
    "noData": "ຍັງບໍ່ມີຂໍ້ມູນ",
    "quickActions": "ທາງລັດ"
  },
  "patients": {
    "title": "ຄົນເຈັບ",
    "register": "ລົງທະບຽນຄົນເຈັບ",
    "searchPlaceholder": "ຄົ້ນຫາດ້ວຍຊື່, ເລກເວດລະບຽນ, ເບີໂທ ຫຼື ເລກບັດປະຈຳຕົວ",
    "mrn": "ເລກເວດລະບຽນ",
    "name": "ຊື່",
    "firstName": "ຊື່",
    "middleName": "ຊື່ກາງ",
    "lastName": "ນາມສະກຸນ",
    "preferredName": "ຊື່ທີ່ໃຊ້ເອີ້ນ",
    "dateOfBirth": "ວັນເດືອນປີເກີດ",
    "age": "ອາຍຸ",
    "sex": "ເພດ",
    "bloodGroup": "ກຸ່ມເລືອດ",
    "maritalStatus": "ສະຖານະພາບ",
    "occupation": "ອາຊີບ",
    "nationality": "ສັນຊາດ",
    "phone": "ເບີໂທ",
    "email": "ອີເມວ",
    "address": "ທີ່ຢູ່",
    "emergencyContactName": "ຜູ້ຕິດຕໍ່ສຸກເສີນ",
    "emergencyContactPhone": "ເບີໂທຜູ້ຕິດຕໍ່ສຸກເສີນ",
    "nationalId": "ເລກບັດປະຈຳຕົວ",
    "preferredLanguage": "ພາສາທີ່ຕ້ອງການ",
    "identifiers": "ເອກະສານປະຈຳຕົວ",
    "identifierType": "ປະເພດເອກະສານ",
    "identifierValue": "ເລກທີເອກະສານ",
    "addIdentifier": "ເພີ່ມເອກະສານປະຈຳຕົວ",
    "registeredOn": "ລົງທະບຽນເມື່ອ",
    "sectionPersonal": "ຂໍ້ມູນສ່ວນຕົວ",
    "sectionContact": "ການຕິດຕໍ່",
    "sectionEmergency": "ຜູ້ຕິດຕໍ່ສຸກເສີນ",
    "sectionIdentifiers": "ເອກະສານປະຈຳຕົວ",
    "created": "ລົງທະບຽນຄົນເຈັບ {{mrn}} ແລ້ວ",
    "updated": "ອັບເດດເວດລະບຽນຄົນເຈັບແລ້ວ",
    "editTitle": "ແກ້ໄຂຂໍ້ມູນຄົນເຈັບ",
    "duplicateTitle": "ອາດເປັນຄົນເຈັບຊ້ຳ",
    "duplicateMessage": "ເວດລະບຽນເຫຼົ່ານີ້ຄ້າຍຄືກັນ. ເປີດເບິ່ງ ຫຼື ຢືນຢັນວ່າເປັນຄົນລະຄົນ.",
    "duplicateConfirm": "ເປັນຄົນລະຄົນ — ລົງທະບຽນຕໍ່",
    "identifierMatchTitle": "ເອກະສານປະຈຳຕົວນີ້ລົງທະບຽນແລ້ວ",
    "matchReason": {
      "NAME_AND_BIRTH_DATE": "ຊື່ ແລະ ວັນເກີດກົງກັນ",
      "PHONE_AND_FIRST_NAME": "ເບີໂທ ແລະ ຊື່ກົງກັນ"
    },
    "allergies": "ການແພ້",
    "noKnownAllergies": "ບໍ່ມີປະຫວັດການແພ້",
    "addAllergy": "ເພີ່ມການແພ້",
    "allergen": "ສິ່ງທີ່ແພ້",
    "reaction": "ອາການ",
    "severity": "ຄວາມຮຸນແຮງ",
    "onsetDate": "ວັນທີເລີ່ມ",
    "alerts": "ການເຕືອນ",
    "addAlert": "ເພີ່ມການເຕືອນ",
    "alertType": "ປະເພດການເຕືອນ",
    "alertMessage": "ຂໍ້ຄວາມ",
    "tabOverview": "ພາບລວມ",
    "tabEncounters": "ການກວດປິ່ນປົວ",
    "tabAppointments": "ນັດໝາຍ",
    "tabPrescriptions": "ໃບສັ່ງຢາ",
    "tabLabs": "ຜົນວິເຄາະ",
    "tabInvoices": "ໃບແຈ້ງໜີ້",
    "newEncounter": "ເລີ່ມການກວດ",
    "bookAppointment": "ຈອງນັດໝາຍ",
    "addToQueue": "ເພີ່ມເຂົ້າຄິວ",
    "empty": "ບໍ່ພົບຄົນເຈັບທີ່ກົງກັບການຄົ້ນຫາ.",
    "pickerPlaceholder": "ຄົ້ນຫາຄົນເຈັບດ້ວຍຊື່ ຫຼື ເລກເວດລະບຽນ",
    "sectionPhoto": "ຮູບຖ່າຍ",
    "sectionAddress": "ທີ່ຢູ່",
    "province": "ແຂວງ",
    "district": "ເມືອງ",
    "subdistrict": "ກຸ່ມບ້ານ",
    "village": "ບ້ານ",
    "addressLine": "ເຮືອນເລກທີ / ຖະໜົນ",
    "addressLineHint": "ບໍ່ບັງຄັບ: ເລກເຮືອນ, ໜ່ວຍ, ຖະໜົນ ຫຼື ຈຸດສັງເກດ",
    "chooseProvinceFirst": "ເລືອກແຂວງກ່ອນ",
    "chooseDistrictFirst": "ເລືອກເມືອງກ່ອນ",
    "noSubdistricts": "ບໍ່ມີກຸ່ມບ້ານ",
    "disability": "ຄວາມພິການ",
    "takePhoto": "ຖ່າຍຮູບ",
    "choosePhoto": "ເລືອກຮູບ",
    "undoPhoto": "ຍົກເລີກການປ່ຽນ",
    "removePhoto": "ລຶບຮູບ",
    "photoHint": "JPEG, PNG ຫຼື WebP. ຮູບຈະຖືກຫຍໍ້ຂະໜາດອັດຕະໂນມັດ.",
    "photoInvalid": "ໄຟລ໌ນີ້ບໍ່ແມ່ນຮູບທີ່ຮອງຮັບ",
    "nameTitle": "ຄຳນຳໜ້າ",
    "noTitle": "— ບໍ່ມີຄຳນຳໜ້າ —",
    "titleSuggested": "ແນະນຳຕາມເພດ ແລະ ອາຍຸ",
    "disabilityDetails": "ລາຍລະອຽດຄວາມພິການ"
  },
  "appointments": {
    "title": "ນັດໝາຍ",
    "book": "ຈອງນັດໝາຍ",
    "date": "ວັນທີ",
    "start": "ເລີ່ມ",
    "end": "ສິ້ນສຸດ",
    "time": "ເວລາ",
    "practitioner": "ແພດ",
    "department": "ພະແນກ",
    "type": "ປະເພດການມາ",
    "reason": "ເຫດຜົນທີ່ມາ",
    "notes": "ໝາຍເຫດ",
    "patient": "ຄົນເຈັບ",
    "anyPractitioner": "ແພດທັງໝົດ",
    "anyDepartment": "ທຸກພະແນກ",
    "checkIn": "ລົງທະບຽນມາຮອດ",
    "confirm": "ຢືນຢັນ",
    "cancel": "ຍົກເລີກນັດໝາຍ",
    "noShow": "ບໍ່ມາ",
    "startEncounter": "ເລີ່ມການກວດ",
    "openEncounter": "ເປີດການກວດ",
    "booked": "ຈອງນັດໝາຍ {{number}} ແລ້ວ",
    "checkedIn": "ລົງທະບຽນແລ້ວ — ບັດຄິວ {{ticket}}",
    "cancelled": "ຍົກເລີກນັດໝາຍແລ້ວ",
    "empty": "ບໍ່ມີນັດໝາຍໃນມື້ນີ້.",
    "priority": "ລຳດັບຄວາມສຳຄັນ",
    "number": "ເລກທີ"
  },
  "queue": {
    "title": "ຄິວ",
    "department": "ພະແນກ",
    "selectDepartment": "ເລືອກພະແນກ",
    "callNext": "ເອີ້ນຄິວຕໍ່ໄປ",
    "counter": "ຊ່ອງ / ຫ້ອງ",
    "waiting": "ລໍຖ້າ",
    "inService": "ເອີ້ນແລ້ວ / ກຳລັງບໍລິການ",
    "served": "ບໍລິການແລ້ວ",
    "ticket": "ບັດຄິວ",
    "issuedAt": "ອອກບັດເມື່ອ",
    "recall": "ເອີ້ນອີກຄັ້ງ",
    "startService": "ເລີ່ມບໍລິການ",
    "complete": "ສຳເລັດ",
    "skip": "ຂ້າມ",
    "requeue": "ກັບເຂົ້າຄິວ",
    "cancelTicket": "ຍົກເລີກບັດຄິວ",
    "walkIn": "ບັດຄິວ Walk-in",
    "display": "ໜ້າຈໍສະແດງຄິວ",
    "nowServing": "ກຳລັງບໍລິການ",
    "nextUp": "ຄິວຕໍ່ໄປ",
    "empty": "ບໍ່ມີຄົນລໍຖ້າ.",
    "calling": "ເອີ້ນຄິວ {{ticket}}",
    "waitMinutes": "{{value}} ນາທີ",
    "scanQr": "ສະແກນ QR ຄົນເຈັບ",
    "estimatedWait": "ເວລາລໍຖ້າໂດຍປະມານ",
    "min": "ນາທີ",
    "fromApp": "ບັດຄິວຈາກແອັບ",
    "loadDetail": "{{counters}} ຊ່ອງບໍລິການ · ລໍຖ້າສະເລ່ຍ {{avg}} ນາທີ · ດົນສຸດ {{longest}} ນາທີ",
    "open": "ເປີດ",
    "pause": "ຢຸດແອັບ",
    "pauseHelp": "ຢຸດຮັບບັດຈາກແອັບ; ໂຕະຍັງອອກບັດໄດ້",
    "close": "ປິດ",
    "source": {
      "MOBILE": "ຈາກແອັບຄົນເຈັບ",
      "QR": "ລົງທະບຽນດ້ວຍ QR",
      "KIOSK": "ຈາກຕູ້ບໍລິການ"
    },
    "subtitle": "ເອີ້ນ, ເອີ້ນຊ້ຳ, ຂ້າມ, ສົ່ງຕໍ່ ແລະ ສຳເລັດການບໍລິການຄົນເຈັບ ຢູ່ຈຸດບໍລິການຂອງທ່ານ",
    "kioskOpen": "ຕູ້ບໍລິການ",
    "report": "ເວລາລໍຖ້າ",
    "servicePoint": "ຈຸດບໍລິການ",
    "selectService": "ເລືອກຈຸດບໍລິການ",
    "allServices": "ທຸກຈຸດບໍລິການ",
    "stage": "ຂັ້ນຕອນ",
    "priorityWaiting": "ລໍຖ້າແບບບູລິມະສິດ",
    "nobodyCalled": "ຍັງບໍ່ມີໃຜຖືກເອີ້ນ. ກົດ “ເອີ້ນຄິວຕໍ່ໄປ”.",
    "skipped": "ຂ້າມ",
    "noSkipped": "ບໍ່ມີເລກທີ່ຖືກຂ້າມ.",
    "done": "ສຳເລັດແລ້ວ",
    "noneDone": "ຍັງບໍ່ມີໃຜສຳເລັດ.",
    "waitingTimes": "ລາຍງານເວລາລໍຖ້າ",
    "notRegistered": "ຍັງບໍ່ໄດ້ລົງທະບຽນ",
    "assistanceRequested": "ຂໍຄວາມຊ່ວຍເຫຼືອຢູ່ຕູ້ບໍລິການ",
    "priorityRequested": "ຂໍບູລິມະສິດ: {{reason}}",
    "hasDisability": "ມີບັນທຶກຄວາມພິການ",
    "age": "{{value}} ປີ",
    "sinceCalled": "ເວລານັບແຕ່ຖືກເອີ້ນ / ເລີ່ມບໍລິການ",
    "waited": "ລໍຖ້າ {{value}} ນາທີ",
    "recalled": "ເອີ້ນຊ້ຳ {{value}} ເທື່ອ",
    "findOrRegister": "ຊອກຫາ ຫຼື ລົງທະບຽນຄົນເຈັບ",
    "openEncounter": "ເປີດການກວດ",
    "transfer": "ສົ່ງຕໍ່",
    "backToQueue": "ກັບໄປລໍຖ້າ",
    "backToQueueHelp": "ໃຫ້ຄົນເຈັບກັບໄປລໍຖ້າ (ເຊັ່ນ ລໍຖ້າຢາຢອດຕາອອກລິດ); ຍັງຮັກສາລຳດັບເດີມ",
    "call": "ເອີ້ນ",
    "callThis": "ເອີ້ນເລກນີ້ດຽວນີ້ (ນອກລຳດັບ)",
    "priority": "ບູລິມະສິດ",
    "cancelTitle": "ຍົກເລີກບັດຄິວ {{ticket}}?",
    "cancelHelp": "ເລກນີ້ຈະຖືກປິດ ແລະ ຄົນເຈັບອອກຈາກຄິວ. ຂໍ້ມູນນີ້ຍັງຢູ່ໃນປະຫວັດຄິວ.",
    "cancelReason": "ເຫດຜົນ",
    "transferredIn": "ມາຈາກຄິວອື່ນ",
    "setPriority": "ບູລິມະສິດຂອງ {{ticket}}",
    "priorityHelp": {
      "NORMAL": "ຕາມລຳດັບການມາຮອດ",
      "PRIORITY": "ຜູ້ສູງອາຍຸ, ຄົນພິການ, ແມ່ຍິງຖືພາ, ເດັກນ້ອຍ",
      "URGENT": "ທາງຄລີນິກ: ກວດກ່ອນຄົນອື່ນ",
      "EMERGENCY": "ທາງຄລີນິກ: ກວດທັນທີ"
    },
    "triageOnly": "ບູລິມະສິດດ່ວນ ແລະ ສຸກເສີນ ກຳນົດໂດຍບຸກຄະລາກອນທາງການແພດ.",
    "priorityReason": "ເຫດຜົນບູລິມະສິດ",
    "note": "ໝາຍເຫດ",
    "transferTitle": "ສົ່ງ {{ticket}} ຕໍ່",
    "transferHelp": "ຄົນເຈັບໃຊ້ເລກເດີມ ແລະ ເຂົ້າຄິວທີ່ເລືອກ.",
    "registerFirst": "ຄົນເຈັບນີ້ຍັງບໍ່ໄດ້ລົງທະບຽນ. ກະລຸນາລົງທະບຽນ ຫຼື ຊອກຫາຄົນເຈັບກ່ອນ; ກ່ອນນັ້ນສົ່ງໄດ້ສະເພາະຈຸດລົງທະບຽນ.",
    "waitingCount": "ລໍຖ້າ {{value}} ຄົນ",
    "handoverNote": "ໝາຍເຫດສຳລັບຈຸດບໍລິການຕໍ່ໄປ",
    "handoverNoteHint": "ເຊັ່ນ ຢອດຢາຂະຫຍາຍຮູມ່ານຕາເວລາ 10:15",
    "transferred": "ສົ່ງ {{ticket}} ໄປ {{service}} ແລ້ວ",
    "linkPatientTitle": "ຄົນເຈັບຂອງບັດຄິວ {{ticket}}",
    "linkPatientHelp": "ຊອກຫາປະຫວັດຄົນເຈັບ ຫຼື ລົງທະບຽນຄົນເຈັບໃໝ່ (ເປີດແຖບໃໝ່) ແລ້ວຊອກຫາຢູ່ນີ້.",
    "findPatient": "ຄົນເຈັບ",
    "registerNew": "ລົງທະບຽນຄົນເຈັບໃໝ່",
    "linkPatient": "ເຊື່ອມກັບບັດຄິວ",
    "patientLinked": "ເຊື່ອມຄົນເຈັບກັບບັດຄິວແລ້ວ",
    "history": "ປະຫວັດຄິວ",
    "historyTitle": "ປະຫວັດຄິວຂອງ {{ticket}}",
    "patient": "ຄົນເຈັບ",
    "visitStatus": "ການມາໂຮງໝໍ",
    "timeInHospital": "ເວລາຢູ່ໂຮງໝໍ",
    "encounter": "ການກວດ",
    "noHistory": "ຍັງບໍ່ມີປະຫວັດ.",
    "displaySetup": "ຕັ້ງຄ່າຈໍສະແດງນີ້",
    "displaySetupHelp": "ເລືອກຈຸດບໍລິການທີ່ຈໍນີ້ຈະສະແດງ. ທີ່ຢູ່ຂອງໜ້າຈໍຈະຈື່ການເລືອກໄວ້, ໃຫ້ບັນທຶກ (bookmark) ໃນບຣາວເຊີຂອງຈໍ.",
    "openDisplay": "ເປີດຈໍສະແດງ",
    "displayTitle": "ຄິວ",
    "nowCalling": "ກຳລັງເອີ້ນ",
    "pleaseWait": "ກະລຸນາລໍຖ້າເລກຂອງທ່ານ",
    "missed": "ພາດຄິວ: ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້",
    "displayFooter": "ເລກຄິວຂອງທ່ານໃຊ້ຕະຫຼອດການມາໂຮງໝໍຄັ້ງນີ້. ກະລຸນາເກັບບັດຄິວໄວ້.",
    "soundOn": "ເປີດສຽງປະກາດ",
    "soundOff": "ປິດສຽງປະກາດ",
    "fullscreen": "ເຕັມຈໍ",
    "tapForSound": "ແຕະເພື່ອເປີດສຽງ",
    "announce": "ເລກ {{ticket}}, ເຊີນທີ່ {{counter}}, {{service}}",
    "rep": {
      "title": "ເວລາລໍຖ້າຄິວ",
      "subtitle": "ເວລາລໍຖ້າ ແລະ ເວລາບໍລິການ ຈາກປະຫວັດຄິວ ແຍກຕາມຈຸດບໍລິການ",
      "today": "ມື້ນີ້",
      "week": "7 ມື້",
      "month": "30 ມື້",
      "noData": "ບໍ່ມີບັດຄິວໃນຊ່ວງເວລານີ້.",
      "avgWait": "ເວລາລໍຖ້າສະເລ່ຍ",
      "medianWait": "ເວລາລໍຖ້າກາງ (median)",
      "p90Wait": "90% ຖືກເອີ້ນພາຍໃນ",
      "p90Hint": "ຄົນເຈັບ 9 ໃນ 10 ລໍຖ້າໜ້ອຍກວ່ານີ້",
      "maxWait": "ລໍຖ້າດົນທີ່ສຸດ",
      "waitHint": "ນັບແຕ່ເຂົ້າຄິວ ຮອດການເອີ້ນຄັ້ງທຳອິດ",
      "avgService": "ເວລາບໍລິການສະເລ່ຍ",
      "avgVisit": "ເວລາຢູ່ໂຮງໝໍສະເລ່ຍ",
      "visitsCompleted": "ສຳເລັດ {{value}} ຈາກ {{total}} ຄັ້ງ",
      "tickets": "ບັດຄິວ",
      "ticketsHint": "ບໍລິການແລ້ວ {{served}} · ສົ່ງຕໍ່ {{transferred}}",
      "missed": "ຂ້າມ (ບໍ່ຢູ່)",
      "cancelled": "ຍົກເລີກ {{value}}",
      "kiosk": "ມາຜ່ານຕູ້ບໍລິການ",
      "kioskHint": "ລົງທະບຽນທີ່ເຄົາເຕີ້ {{registered}} · ຂໍຄວາມຊ່ວຍເຫຼືອ {{help}}",
      "byHour": "ຈຳນວນມາຮອດຕາມຊົ່ວໂມງ",
      "arrivals": "ມາຮອດ {{value}} ຄົນ",
      "avgWaitShort": "ລໍຖ້າສະເລ່ຍ {{value}} ນາທີ",
      "bySourcePriority": "ຕາມຊ່ອງທາງ ແລະ ບູລິມະສິດ",
      "byService": "ຕາມຈຸດບໍລິການ",
      "transferredOn": "ສົ່ງຕໍ່",
      "byDay": "ຕາມວັນ"
    },
    "kiosk": {
      "title": "ເຊັກອິນດ້ວຍຕົນເອງ",
      "welcome": "ຍິນດີຕ້ອນຮັບ. ມື້ນີ້ພວກເຮົາຊ່ວຍຫຍັງທ່ານໄດ້?",
      "haveAppointment": "ຂ້ອຍມີນັດໝາຍມື້ນີ້",
      "haveAppointmentHint": "ເຊັກອິນ ແລະ ຮັບເລກຄິວ",
      "registeredWalkIn": "ຂ້ອຍເຄີຍມາກວດ, ບໍ່ມີນັດ",
      "registeredWalkInHint": "ຮັບເລກຄິວສຳລັບບໍລິການ",
      "newOrHelp": "ຄົນເຈັບໃໝ່ ຫຼື ຕ້ອງການຄວາມຊ່ວຍເຫຼືອ",
      "newOrHelpHint": "ຮັບເລກຄິວສຳລັບເຄົາເຕີ້ລົງທະບຽນ",
      "emergencyNote": "ກໍລະນີສຸກເສີນ? ກະລຸນາໄປພະແນກສຸກເສີນໂດຍກົງ ຫຼື ແຈ້ງພະນັກງານ.",
      "identifyTitle": "ຊອກຫາປະຫວັດຂອງທ່ານ",
      "mrnOrPhone": "ເລກປະຈຳຕົວໂຮງໝໍ (HN) ຫຼື ເບີໂທ",
      "birthDate": "ວັນເດືອນປີເກີດ",
      "day": "ວັນ",
      "month": "ເດືອນ",
      "year": "ປີ",
      "delete": "ລຶບ",
      "privacy": "ພວກເຮົາໃຊ້ຂໍ້ມູນນີ້ເພື່ອຊອກຫາປະຫວັດຂອງທ່ານເທົ່ານັ້ນ. ບໍ່ມີຂໍ້ມູນສ່ວນຕົວສະແດງເທິງໜ້າຈໍ.",
      "continue": "ຕໍ່ໄປ",
      "hello": "ສະບາຍດີ {{name}}.",
      "noAppointment": "ບໍ່ພົບນັດໝາຍຂອງທ່ານໃນມື້ນີ້.",
      "takeWalkIn": "ຮັບເລກຄິວສຳລັບບໍລິການ",
      "checkIn": "ເຊັກອິນ",
      "chooseService": "ທ່ານຕ້ອງການໄປບ່ອນໃດ?",
      "waitInfo": "ລໍຖ້າ {{waiting}} ຄົນ · ປະມານ {{minutes}} ນາທີ",
      "priorityQuestion": "ທ່ານຕ້ອງການບໍລິການແບບບູລິມະສິດບໍ?",
      "priorityHint": "ພະນັກງານຈະຢືນຢັນບູລິມະສິດເມື່ອເອີ້ນທ່ານ.",
      "request": {
        "ELDERLY": "ອາຍຸ 60 ປີຂຶ້ນໄປ",
        "DISABILITY": "ຄົນພິການ",
        "PREGNANT": "ແມ່ຍິງຖືພາ",
        "CHILD": "ມາກັບເດັກນ້ອຍ"
      },
      "notSure": "ບໍ່ແນ່ໃຈວ່າຈະໄປໃສ? ຮັບເລກຄິວສຳລັບເຄົາເຕີ້ລົງທະບຽນ",
      "helpTitle": "ເຄົາເຕີ້ລົງທະບຽນ",
      "helpText": "ພະນັກງານທີ່ເຄົາເຕີ້ລົງທະບຽນຈະລົງທະບຽນ ຫຼື ຊ່ວຍເຫຼືອທ່ານ ແລ້ວສົ່ງທ່ານໄປບໍລິການທີ່ຖືກຕ້ອງ.",
      "newPatientTicket": "ຂ້ອຍເປັນຄົນເຈັບໃໝ່",
      "needHelpTicket": "ຂ້ອຍຕ້ອງການຄວາມຊ່ວຍເຫຼືອ",
      "registrationTicket": "ຮັບເລກຄິວສຳລັບເຄົາເຕີ້ລົງທະບຽນ",
      "startOver": "ເລີ່ມໃໝ່",
      "yourNumber": "ເລກຄິວຂອງທ່ານ",
      "ahead": "ມີ {{value}} ຄົນກ່ອນທ່ານ · ປະມານ {{minutes}} ນາທີ",
      "slipNote": "ກະລຸນາເບິ່ງເລກຂອງທ່ານເທິງໜ້າຈໍ. ເລກນີ້ໃຊ້ຕະຫຼອດການມາໂຮງໝໍຄັ້ງນີ້.",
      "slipRegistration": "ກະລຸນາລໍຖ້າຈົນກວ່າເລກຂອງທ່ານຖືກເອີ້ນໄປເຄົາເຕີ້ລົງທະບຽນ.",
      "alreadyQueued": "ທ່ານມີເລກຄິວມື້ນີ້ແລ້ວ. ນີ້ແມ່ນເລກເດີມ.",
      "print": "ພິມບັດຄິວ",
      "done": "ແລ້ວໆ",
      "error": {
        "NOT_FOUND": "ບໍ່ພົບປະຫວັດຂອງທ່ານດ້ວຍຂໍ້ມູນນີ້.",
        "TOO_MANY_REQUESTS": "ລອງຫຼາຍເທື່ອເກີນໄປ. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້ລົງທະບຽນ.",
        "QUEUE_PAUSED": "ການເຊັກອິນດ້ວຍຕົນເອງຢຸດຊົ່ວຄາວສຳລັບບໍລິການນີ້. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້.",
        "QUEUE_CLOSED": "ບໍລິການນີ້ປິດມື້ນີ້. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້.",
        "NOT_TODAY": "ນັດໝາຍນີ້ບໍ່ແມ່ນມື້ນີ້.",
        "INVALID_TRANSITION": "ນັດໝາຍນີ້ເຊັກອິນຢູ່ນີ້ບໍ່ໄດ້. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້.",
        "NO_DEPARTMENT": "ນັດໝາຍນີ້ເຊັກອິນຢູ່ນີ້ບໍ່ໄດ້. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້.",
        "OTHER": "ເກີດຂໍ້ຜິດພາດ. ກະລຸນາຕິດຕໍ່ເຄົາເຕີ້ລົງທະບຽນ."
      }
    }
  },
  "encounters": {
    "title": "ການກວດປິ່ນປົວ",
    "mine": "ຄົນເຈັບຂອງຂ້ອຍ",
    "all": "ທັງໝົດ",
    "today": "ມື້ນີ້",
    "number": "ເລກທີການກວດ",
    "type": "ປະເພດ",
    "startedAt": "ເລີ່ມເມື່ອ",
    "endedAt": "ສິ້ນສຸດເມື່ອ",
    "chiefComplaint": "ອາການສຳຄັນ",
    "practitioner": "ແພດ",
    "department": "ພະແນກ",
    "complete": "ສຳເລັດການກວດ",
    "completeConfirm": "ສຳເລັດການກວດນີ້ບໍ? ບັນທຶກ ແລະ ຄຳສັ່ງຈະແກ້ໄຂບໍ່ໄດ້ອີກ.",
    "cancel": "ຍົກເລີກການກວດ",
    "cancelReason": "ເຫດຜົນທີ່ຍົກເລີກ",
    "started": "ເລີ່ມການກວດ {{number}} ແລ້ວ",
    "completed": "ສຳເລັດການກວດແລ້ວ",
    "vitals": "ສັນຍານຊີບ",
    "recordVitals": "ບັນທຶກສັນຍານຊີບ",
    "temperature": "ອຸນຫະພູມ",
    "heartRate": "ອັດຕາການເຕັ້ນຂອງຫົວໃຈ",
    "respiratoryRate": "ອັດຕາການຫາຍໃຈ",
    "bloodPressure": "ຄວາມດັນເລືອດ",
    "systolic": "ຄວາມດັນຕົວເທິງ",
    "diastolic": "ຄວາມດັນຕົວລຸ່ມ",
    "spo2": "SpO₂",
    "weight": "ນ້ຳໜັກ",
    "height": "ລວງສູງ",
    "bmi": "BMI",
    "painScore": "ລະດັບຄວາມເຈັບ (0–10)",
    "recordedAt": "ບັນທຶກເມື່ອ",
    "recordedBy": "ໂດຍ",
    "unitCelsius": "°C",
    "unitBpm": "ຄັ້ງ/ນາທີ",
    "unitPerMin": "/ນາທີ",
    "unitMmHg": "mmHg",
    "unitPercent": "%",
    "unitKg": "ກິໂລ",
    "unitCm": "ຊມ",
    "diagnoses": "ການບົ່ງມະຕິ",
    "addDiagnosis": "ເພີ່ມການບົ່ງມະຕິ",
    "diagnosisCode": "ລະຫັດ ICD-10",
    "diagnosisDescription": "ລາຍລະອຽດ",
    "diagnosisType": "ປະເພດ",
    "verification": "ການຢືນຢັນ",
    "markEnteredInError": "ໝາຍວ່າບັນທຶກຜິດ",
    "notes": "ບັນທຶກທາງການແພດ",
    "newNote": "ບັນທຶກໃໝ່",
    "noteType": "ປະເພດບັນທຶກ",
    "content": "ເນື້ອໃນ",
    "saveDraft": "ບັນທຶກສະບັບຮ່າງ",
    "saveAndSign": "ບັນທຶກ ແລະ ລົງນາມ",
    "sign": "ລົງນາມ",
    "amend": "ແກ້ໄຂເພີ່ມເຕີມ",
    "amendReason": "ເຫດຜົນທີ່ແກ້ໄຂ",
    "amendmentOf": "ການແກ້ໄຂຂອງບັນທຶກກ່ອນໜ້າ",
    "signedBy": "ລົງນາມໂດຍ {{name}} · {{time}}",
    "draftBy": "ສະບັບຮ່າງໂດຍ {{name}}",
    "prescriptions": "ໃບສັ່ງຢາ",
    "newPrescription": "ສັ່ງຢາໃໝ່",
    "labOrders": "ຄຳສັ່ງວິເຄາະ",
    "newLabOrder": "ສັ່ງກວດວິເຄາະ",
    "noVitals": "ຍັງບໍ່ໄດ້ບັນທຶກສັນຍານຊີບ.",
    "noDiagnoses": "ຍັງບໍ່ມີການບົ່ງມະຕິ.",
    "noNotes": "ຍັງບໍ່ມີບັນທຶກ.",
    "noPrescriptions": "ບໍ່ມີໃບສັ່ງຢາ.",
    "noLabOrders": "ບໍ່ມີຄຳສັ່ງວິເຄາະ.",
    "closedBanner": "ການກວດນີ້ {{status}} ແລະ ອ່ານໄດ້ຢ່າງດຽວ.",
    "start": "ເລີ່ມການກວດ",
    "empty": "ບໍ່ພົບການກວດປິ່ນປົວ.",
    "soapTemplate": "S (ອາການ):\nO (ກວດພົບ):\nA (ປະເມີນ):\nP (ແຜນການ):"
  },
  "pharmacy": {
    "title": "ຫ້ອງຢາ",
    "worklist": "ລໍຖ້າຈ່າຍ",
    "history": "ປະຫວັດ",
    "catalog": "ລາຍການຢາ",
    "prescription": "ໃບສັ່ງຢາ",
    "prescriptionNumber": "ເລກທີໃບສັ່ງຢາ",
    "prescriber": "ຜູ້ສັ່ງຢາ",
    "issuedAt": "ອອກເມື່ອ",
    "items": "ລາຍການ",
    "medication": "ຢາ",
    "selectMedication": "ຄົ້ນຫາຢາ",
    "dose": "ຂະໜາດ",
    "doseUnit": "ຫົວໜ່ວຍ",
    "frequency": "ຄວາມຖີ່",
    "route": "ວິທີໃຊ້",
    "duration": "ໄລຍະເວລາ",
    "quantity": "ຈຳນວນ",
    "instructions": "ຄຳແນະນຳ",
    "addItem": "ເພີ່ມຢາ",
    "removeItem": "ເອົາອອກ",
    "issue": "ລົງນາມ ແລະ ອອກໃບສັ່ງ",
    "issued": "ອອກໃບສັ່ງຢາ {{number}} ແລ້ວ",
    "dispense": "ຈ່າຍຢາ",
    "dispenseAll": "ຈ່າຍຢາທີ່ເຫຼືອທັງໝົດ",
    "dispensed": "ຈ່າຍຢາແລ້ວ",
    "dispensedQty": "ຈ່າຍແລ້ວ",
    "remaining": "ເຫຼືອ",
    "cancelPrescription": "ຍົກເລີກໃບສັ່ງຢາ",
    "allergyWarningTitle": "ເຕືອນການແພ້ຢາ",
    "allergyWarningBody": "{{medication}} ກົງກັບການແພ້ທີ່ບັນທຶກໄວ້ “{{allergen}}” ({{severity}}).",
    "overrideAndIssue": "ຢືນຢັນ ແລະ ອອກໃບສັ່ງ",
    "patientAllergies": "ການແພ້ຂອງຄົນເຈັບ",
    "genericName": "ຊື່ສາມັນ",
    "brandName": "ຊື່ການຄ້າ",
    "strength": "ຄວາມແຮງ",
    "dosageForm": "ຮູບແບບຢາ",
    "unitPrice": "ລາຄາຕໍ່ໜ່ວຍ",
    "manufacturer": "ຜູ້ຜະລິດ",
    "newMedication": "ເພີ່ມຢາໃໝ່",
    "editMedication": "ແກ້ໄຂຂໍ້ມູນຢາ",
    "empty": "ບໍ່ມີໃບສັ່ງຢາລໍຖ້າ."
  },
  "lab": {
    "title": "ຫ້ອງວິເຄາະ",
    "worklist": "ລາຍການລໍຖ້າ",
    "completed": "ສຳເລັດແລ້ວ",
    "order": "ຄຳສັ່ງວິເຄາະ",
    "orderNumber": "ເລກທີຄຳສັ່ງ",
    "orderedBy": "ສັ່ງໂດຍ",
    "orderedAt": "ສັ່ງເມື່ອ",
    "priority": "ລຳດັບຄວາມສຳຄັນ",
    "tests": "ລາຍການກວດ",
    "selectTests": "ເລືອກລາຍການກວດ",
    "clinicalNotes": "ຂໍ້ມູນທາງຄລີນິກ",
    "placeOrder": "ສົ່ງຄຳສັ່ງ",
    "orderPlaced": "ສົ່ງຄຳສັ່ງວິເຄາະ {{number}} ແລ້ວ",
    "collect": "ເກັບຕົວຢ່າງ",
    "collected": "ເກັບຕົວຢ່າງແລ້ວ",
    "specimen": "ຕົວຢ່າງ",
    "result": "ຜົນ",
    "value": "ຄ່າ",
    "resultText": "ຜົນ (ຂໍ້ຄວາມ)",
    "flag": "ເຄື່ອງໝາຍ",
    "unit": "ຫົວໜ່ວຍ",
    "referenceRange": "ຄ່າອ້າງອີງ",
    "saveResult": "ບັນທຶກຜົນ",
    "verify": "ຢືນຢັນຜົນ",
    "verified": "ຢືນຢັນຜົນແລ້ວ",
    "correct": "ແກ້ໄຂຜົນ",
    "correctionReason": "ເຫດຜົນການແກ້ໄຂ",
    "corrected": "ແກ້ໄຂຜົນແລ້ວ",
    "enteredBy": "ບັນທຶກໂດຍ",
    "verifiedBy": "ຢືນຢັນໂດຍ",
    "cancelOrder": "ຍົກເລີກຄຳສັ່ງ",
    "empty": "ບໍ່ມີຄຳສັ່ງວິເຄາະໃນລາຍການນີ້.",
    "category": "ໝວດ",
    "price": "ລາຄາ",
    "turnaround": "ເວລາອອກຜົນ",
    "awaitingResult": "ລໍຖ້າຜົນ"
  },
  "billing": {
    "title": "ໃບບິນ ແລະ ຮັບເງິນ",
    "invoices": "ໃບແຈ້ງໜີ້",
    "newInvoice": "ສ້າງໃບແຈ້ງໜີ້",
    "invoice": "ໃບແຈ້ງໜີ້",
    "invoiceNumber": "ເລກທີໃບແຈ້ງໜີ້",
    "patient": "ຄົນເຈັບ",
    "encounter": "ການກວດ",
    "items": "ລາຍການ",
    "description": "ລາຍລະອຽດ",
    "quantity": "ຈຳນວນ",
    "unitPrice": "ລາຄາຕໍ່ໜ່ວຍ",
    "discount": "ສ່ວນຫຼຸດ",
    "tax": "ອາກອນ",
    "subtotal": "ລວມຍ່ອຍ",
    "total": "ລວມທັງໝົດ",
    "paid": "ຊຳລະແລ້ວ",
    "balance": "ຍອດຄ້າງ",
    "issuedAt": "ອອກເມື່ອ",
    "chargeItems": "ບໍລິການ ແລະ ຄ່າທຳນຽມ",
    "addCharge": "ເພີ່ມບໍລິການ",
    "unbilledItems": "ລາຍການທີ່ຍັງບໍ່ໄດ້ເກັບເງິນຈາກການກວດ",
    "includeUnbilled": "ລວມຢາ ແລະ ການກວດວິເຄາະທີ່ຍັງບໍ່ໄດ້ເກັບເງິນ",
    "payments": "ການຊຳລະເງິນ",
    "recordPayment": "ບັນທຶກການຊຳລະ",
    "amount": "ຈຳນວນເງິນ",
    "method": "ວິທີຊຳລະ",
    "provider": "ຜູ້ໃຫ້ບໍລິການ",
    "reference": "ເລກອ້າງອີງ",
    "paymentRecorded": "ບັນທຶກການຊຳລະແລ້ວ",
    "payInFull": "ຊຳລະເຕັມຈຳນວນ",
    "void": "ຍົກເລີກໃບແຈ້ງໜີ້",
    "voidReason": "ເຫດຜົນທີ່ຍົກເລີກ",
    "refund": "ຄືນເງິນ",
    "refundReason": "ເຫດຜົນທີ່ຄືນເງິນ",
    "receipt": "ໃບຮັບເງິນ",
    "printReceipt": "ພິມໃບຮັບເງິນ",
    "created": "ສ້າງໃບແຈ້ງໜີ້ {{number}} ແລ້ວ",
    "pendingConfirmation": "ລໍຖ້າການຢືນຢັນຈາກຜູ້ໃຫ້ບໍລິການ",
    "outstanding": "ຄ້າງຊຳລະ",
    "thankYou": "ຂອບໃຈ. ຂໍໃຫ້ຫາຍໄວໆ!",
    "selectEncounter": "ການກວດ (ບໍ່ບັງຄັບ)",
    "empty": "ບໍ່ພົບໃບແຈ້ງໜີ້.",
    "receivedBy": "ຮັບເງິນໂດຍ",
    "applyDiscount": "ສ່ວນຫຼຸດ",
    "discountHint": "ສ່ວນຫຼຸດຈະຖືກບັນທຶກພ້ອມຊື່ຂອງທ່ານ ແລະ ເຫດຜົນ, ຕ້ອງມີສິດໃຫ້ສ່ວນຫຼຸດ.",
    "discountPreview": "ສ່ວນຫຼຸດ {{discount}} · ຍອດໃໝ່ {{total}}",
    "discountSaved": "ບັນທຶກສ່ວນຫຼຸດແລ້ວ",
    "lineDiscounts": "ສ່ວນຫຼຸດລາຍການ",
    "noDiscount": "ບໍ່ມີສ່ວນຫຼຸດ",
    "billDiscount": "ສ່ວນຫຼຸດທັງບິນ"
  },
  "admin": {
    "usersTitle": "ຜູ້ໃຊ້",
    "newUser": "ເພີ່ມຜູ້ໃຊ້",
    "editUser": "ແກ້ໄຂຜູ້ໃຊ້",
    "username": "ຊື່ຜູ້ໃຊ້",
    "fullName": "ຊື່ ແລະ ນາມສະກຸນ",
    "email": "ອີເມວ",
    "phone": "ເບີໂທ",
    "roles": "ບົດບາດ",
    "password": "ລະຫັດຜ່ານເລີ່ມຕົ້ນ",
    "resetPassword": "ຕັ້ງລະຫັດຜ່ານໃໝ່",
    "newPassword": "ລະຫັດຜ່ານໃໝ່",
    "disable": "ປິດການໃຊ້ງານ",
    "enable": "ເປີດການໃຊ້ງານ",
    "lastLogin": "ເຂົ້າລະບົບຄັ້ງລ່າສຸດ",
    "locked": "ຖືກລັອກ",
    "userCreated": "ສ້າງຜູ້ໃຊ້ແລ້ວ",
    "isPractitioner": "ຜູ້ໃຊ້ນີ້ເປັນບຸກຄະລາກອນທາງການແພດ",
    "employeeCode": "ລະຫັດພະນັກງານ",
    "specialty": "ຄວາມຊຳນານ",
    "licenseNumber": "ເລກທີໃບອະນຸຍາດ",
    "departmentsTitle": "ພະແນກ",
    "newDepartment": "ເພີ່ມພະແນກ",
    "departmentType": "ປະເພດພະແນກ",
    "practitionersTitle": "ແພດ ແລະ ບຸກຄະລາກອນ",
    "newPractitioner": "ເພີ່ມບຸກຄະລາກອນ",
    "displayName": "ຊື່ທີ່ສະແດງ",
    "department": "ພະແນກ",
    "hospitalTitle": "ການຕັ້ງຄ່າໂຮງໝໍ",
    "hospitalName": "ຊື່ໂຮງໝໍ",
    "registrationNumber": "ເລກທະບຽນ",
    "timezone": "ເຂດເວລາ",
    "currency": "ສະກຸນເງິນ",
    "defaultLanguage": "ພາສາເລີ່ມຕົ້ນ",
    "organization": "ອົງກອນ",
    "auditTitle": "ບັນທຶກການກວດສອບ",
    "auditAction": "ການກະທຳ",
    "auditResource": "ຂໍ້ມູນ",
    "auditActor": "ຜູ້ໃຊ້",
    "auditTime": "ເວລາ",
    "auditIp": "ທີ່ຢູ່ IP",
    "auditChanges": "ການປ່ຽນແປງ",
    "auditBefore": "ກ່ອນ",
    "auditAfter": "ຫຼັງ",
    "auditResourceId": "ລະຫັດຂໍ້ມູນ",
    "hospitalDetails": "ຂໍ້ມູນທົ່ວໄປ",
    "hospitalLocation": "ທີ່ຕັ້ງ",
    "addressDetails": "ຖະໜົນ, ອາຄານ ແລະ ລາຍລະອຽດອື່ນ",
    "addressDetailsHint": "ພິມຢູ່ຫົວເອກະສານ ກ້ອງຊື່ໂຮງໝໍ",
    "latitude": "ເສັ້ນຂະໜານ (Latitude)",
    "longitude": "ເສັ້ນແວງ (Longitude)",
    "latitudeHint": "ລະຫວ່າງ -90 ຫາ 90; ໃສ່ທັງສອງ ຫຼື ບໍ່ໃສ່ເລີຍ",
    "longitudeHint": "ລະຫວ່າງ -180 ຫາ 180; ໃສ່ທັງສອງ ຫຼື ບໍ່ໃສ່ເລີຍ",
    "openMap": "ເປີດໃນແຜນທີ່",
    "clearPosition": "ລຶບພິກັດ",
    "positionHint": "ອົງສາທົດສະນິຍົມ ເຊັ່ນ 17.966000 ແລະ 102.600000 ສຳລັບວຽງຈັນ. ປຸ່ມ ໃຊ້ຕຳແໜ່ງຂອງຂ້ອຍ ໃຊ້ໄດ້ເມື່ອຢູ່ໃນໂຮງໝໍ.",
    "useMyLocation": "ໃຊ້ຕຳແໜ່ງຂອງຂ້ອຍ",
    "locateFailed": "ອ່ານຕຳແໜ່ງຂອງອຸປະກອນນີ້ບໍ່ໄດ້",
    "hospitalPhoto": "ຮູບ ແລະ ໂລໂກ້ໂຮງໝໍ",
    "changePhoto": "ປ່ຽນຮູບ",
    "uploadPhoto": "ອັບໂຫຼດຮູບ",
    "removePhoto": "ລຶບຮູບ",
    "photoHint": "JPEG, PNG ຫຼື WebP. ຮູບນີ້ຈະສະແດງເປັນໂລໂກ້ໂຮງໝໍ ໃນເມນູ, ໜ້າເຂົ້າສູ່ລະບົບ ແລະ ເອກະສານທີ່ພິມ. ຮູບສີ່ຫຼ່ຽມຈະເໝາະທີ່ສຸດ.",
    "noPhotoYet": "ຍັງບໍ່ມີຮູບ: ລະບົບສະແດງເຄື່ອງໝາຍ HMS ເປັນໂລໂກ້.",
    "removePhotoMessage": "ລະບົບຈະສະແດງເຄື່ອງໝາຍ HMS ເປັນໂລໂກ້ຄືນ.",
    "photoSaved": "ບັນທຶກຮູບໂຮງໝໍແລ້ວ",
    "photoRemoved": "ລຶບຮູບໂຮງໝໍແລ້ວ",
    "hospitalNameLo": "ຊື່ໂຮງໝໍ (ລາວ)",
    "hospitalNameEn": "ຊື່ໂຮງໝໍ (ອັງກິດ)",
    "hospitalNameEnHint": "ສະແດງເມື່ອໃຊ້ພາສາອື່ນທີ່ບໍ່ແມ່ນລາວ ແລະ ໃນເອກະສານທີ່ພິມ"
  },
  "translations": {
    "title": "ການແປພາສາ",
    "subtitle": "ປັບແຕ່ງຂໍ້ຄວາມທຸກຢ່າງໃນລະບົບ. ການປ່ຽນແປງມີຜົນທັນທີທັງເວັບ ແລະ ມືຖື.",
    "locale": "ພາສາ",
    "scope": "ນຳໃຊ້ກັບ",
    "scopeUSER": "ສະເພາະຂ້ອຍ",
    "scopeHOSPITAL": "ໂຮງໝໍນີ້",
    "scopeGLOBAL": "ທຸກໂຮງໝໍ",
    "scopeHelpUSER": "ຄຳສັບສ່ວນຕົວທີ່ສະເພາະທ່ານເຫັນ.",
    "scopeHelpHOSPITAL": "ທຸກຄົນໃນໂຮງໝໍນີ້ຈະເຫັນຄຳສັບນີ້.",
    "scopeHelpGLOBAL": "ຄຳສັບເລີ່ມຕົ້ນສຳລັບທຸກໂຮງໝໍ (ຜູ້ດູແລລະບົບສູງສຸດ).",
    "key": "ລະຫັດຂໍ້ຄວາມ",
    "reference": "ຕົ້ນສະບັບພາສາອັງກິດ",
    "baseValue": "ຂໍ້ຄວາມເລີ່ມຕົ້ນ",
    "override": "ຂໍ້ຄວາມທີ່ປັບແຕ່ງ",
    "effective": "ທີ່ສະແດງຢູ່",
    "searchPlaceholder": "ຄົ້ນຫາລະຫັດ ຫຼື ຂໍ້ຄວາມ",
    "onlyCustomized": "ສະເພາະທີ່ປັບແຕ່ງ",
    "onlyMissing": "ທີ່ຍັງບໍ່ໄດ້ແປ",
    "resetKey": "ກັບຄືນຄ່າເລີ່ມຕົ້ນ",
    "resetAll": "ກັບຄືນຄ່າເລີ່ມຕົ້ນທັງໝົດ",
    "resetAllConfirm": "ລຶບຂໍ້ຄວາມທີ່ປັບແຕ່ງທັງໝົດໃນພາສາ ແລະ ຂອບເຂດນີ້ບໍ?",
    "importDone": "ນຳເຂົ້າ {{count}} ຂໍ້ຄວາມແລ້ວ",
    "importInvalid": "ໄຟລ໌ນີ້ບໍ່ແມ່ນໄຟລ໌ການແປ JSON ທີ່ຖືກຕ້ອງ.",
    "saveAll": "ບັນທຶກການປ່ຽນແປງ",
    "unsaved": "{{count}} ການປ່ຽນແປງທີ່ຍັງບໍ່ບັນທຶກ",
    "stats": "ປັບແຕ່ງ {{customized}} · ທັງໝົດ {{total}} ຂໍ້ຄວາມ",
    "missing": "ຍັງບໍ່ໄດ້ແປ",
    "inheritedFrom": "ຈາກ: {{layer}}",
    "layerBundled": "ຄ່າເລີ່ມຕົ້ນ",
    "saved": "ບັນທຶກການແປແລ້ວ"
  },
  "languages": {
    "title": "ພາສາ",
    "add": "ເພີ່ມພາສາ",
    "code": "ລະຫັດພາສາ",
    "codeHelp": "ລະຫັດ ISO ເຊັ່ນ km ຫຼື zh-Hant",
    "name": "ຊື່ພາສາອັງກິດ",
    "nativeName": "ຊື່ໃນພາສາຕົ້ນສະບັບ",
    "fallback": "ພາສາສຳຮອງ",
    "enabled": "ເປີດໃຊ້",
    "builtin": "ມີມາກັບລະບົບ",
    "custom": "ເພີ່ມເອງ",
    "added": "ເພີ່ມພາສາແລ້ວ. ໄປແປໄດ້ທີ່ໜ້າການແປພາສາ."
  },
  "settings": {
    "title": "ການຕັ້ງຄ່າ",
    "appearance": "ຮູບແບບການສະແດງ",
    "theme": "ຮູບແບບສີ",
    "themeHelp": "ເລືອກຮູບແບບສີ. “ຕາມລະບົບ” ຈະປ່ຽນຕາມໂໝດສະຫວ່າງ ຫຼື ມືດຂອງອຸປະກອນ.",
    "accent": "ສີຫຼັກ",
    "accentDefault": "ຕາມຮູບແບບສີ",
    "density": "ຄວາມໜາແໜ້ນ",
    "densityCompact": "ກະທັດຮັດ",
    "densityComfortable": "ສະບາຍຕາ",
    "language": "ພາສາ",
    "languageHelp": "ເລືອກພາສາສຳລັບເມນູ ແລະ ຂໍ້ຄວາມ.",
    "account": "ບັນຊີ",
    "myTranslations": "ຄຳສັບຂອງຂ້ອຍ",
    "myTranslationsHelp": "ປ່ຽນຊື່ຂໍ້ຄວາມສະເພາະຕົວທ່ານ — ເຊັ່ນ ປ່ຽນ “ການກວດປິ່ນປົວ” ເປັນ “ການມາກວດ”.",
    "savedOnServer": "ການຕັ້ງຄ່າຖືກບັນທຶກໄວ້ໃນບັນຊີ ແລະ ໃຊ້ໄດ້ໃນແອັບມືຖືນຳ."
  },
  "themes": {
    "system": "ຕາມລະບົບ",
    "clinical": "ຟ້າຄລີນິກ",
    "night": "ກາງຄືນ",
    "ocean": "ມະຫາສະໝຸດ",
    "forest": "ປ່າໄມ້",
    "lotus": "ດອກບົວ",
    "midnight": "ທ່ຽງຄືນ",
    "contrast": "ຄວາມຄົມຊັດສູງ",
    "gold": "ສີຄຳ",
    "oph": "ສູນຕາ OPH"
  },
  "notifications": {
    "title": "ການແຈ້ງເຕືອນ",
    "empty": "ບໍ່ມີການແຈ້ງເຕືອນໃໝ່.",
    "markAllRead": "ໝາຍວ່າອ່ານແລ້ວທັງໝົດ",
    "unread": "ຍັງບໍ່ອ່ານ {{count}}",
    "prescriptionIssued": "ໃບສັ່ງຢາໃໝ່ລໍຖ້າຈ່າຍ: {{ref}}",
    "labOrdered": "ຄຳສັ່ງວິເຄາະໃໝ່: {{ref}}",
    "labResultVerified": "ຜົນວິເຄາະອອກແລ້ວ: {{ref}}",
    "patientCheckedIn": "ຄົນເຈັບມາຮອດແລ້ວ: {{ref}}",
    "highIop": "ຄວາມດັນຕາສູງ: {{ref}}",
    "eyeSurgeryScheduled": "ນັດຜ່າຕັດຕາ: {{ref}}",
    "lowStock": "ສິນຄ້າໃກ້ໝົດ",
    "prSubmitted": "ໃບສະເໜີຊື້ລໍຖ້າອະນຸມັດ",
    "prApproved": "ໃບສະເໜີຊື້ຂອງທ່ານໄດ້ຮັບອະນຸມັດ",
    "prRejected": "ໃບສະເໜີຊື້ຂອງທ່ານຖືກປະຕິເສດ",
    "poApproval": "ໃບສັ່ງຊື້ລໍຖ້າອະນຸມັດ",
    "stockDocSubmitted": "ເອກະສານສາງລໍຖ້າກວດ: {{ref}}",
    "patientAdmitted": "ຮັບຄົນເຈັບເຂົ້ານອນ: {{ref}}",
    "patientDischarged": "ອອກໂຮງໝໍແລ້ວ, ພ້ອມອອກບິນ: {{ref}}",
    "serviceOrdered": "ມີຄຳສັ່ງບໍລິການພິເສດໃໝ່: {{ref}}",
    "serviceReported": "ຜົນລໍຖ້າຢັ້ງຢືນ: {{ref}}",
    "serviceVerified": "ຜົນອອກແລ້ວ: {{ref}}",
    "expenseSubmitted": "ລາຍຈ່າຍລໍຖ້າອະນຸມັດ: {{ref}}",
    "cashSessionClosed": "ລິ້ນຊັກເງິນລໍຖ້າກວດ: {{ref}}",
    "posRefillSubmitted": "ຄຳຂໍເຕີມສິນຄ້າ POS ລໍຖ້າກະກຽມ: {{ref}}",
    "posRefillSent": "ສິນຄ້າເຕີມ POS ກຳລັງມາ — ກະລຸນາຢືນຢັນການຮັບ: {{ref}}"
  },
  "time": {
    "justNow": "ຫາກໍ່ນີ້",
    "minutesAgo": "{{count}} ນາທີກ່ອນ",
    "hoursAgo": "{{count}} ຊົ່ວໂມງກ່ອນ",
    "daysAgo": "{{count}} ມື້ກ່ອນ"
  },
  "mobile": {
    "serverUrl": "ທີ່ຢູ່ເຊີບເວີ",
    "serverUrlHelp": "URL ຂອງເຊີບເວີ HMS ເຊັ່ນ https://hms.example.org ຫຼື http://192.168.1.10:8090"
  },
  "months": {
    "1": "ມ.ກ.",
    "2": "ກ.ພ.",
    "3": "ມ.ນ.",
    "4": "ເມ.ສ.",
    "5": "ພ.ພ.",
    "6": "ມິ.ຖ.",
    "7": "ກ.ລ.",
    "8": "ສ.ຫ.",
    "9": "ກ.ຍ.",
    "10": "ຕ.ລ.",
    "11": "ພ.ຈ.",
    "12": "ທ.ວ."
  },
  "analytics": {
    "title": "ການວິເຄາະຂໍ້ມູນ",
    "year": "ປີ",
    "today": "ມື້ນີ້",
    "periodYtd": "{{from}} – {{to}} ທຽບກັບໄລຍະດຽວກັນຂອງປີ {{prevYear}}",
    "periodFull": "ທັງປີ {{year}} ທຽບກັບປີ {{prevYear}}",
    "netRevenue": "ລາຍຮັບສຸດທິ",
    "collected": "ເກັບເງິນໄດ້",
    "collectionRate": "ເກັບໄດ້ {{value}}",
    "visits": "ຈຳນວນການກວດ",
    "newPatients": "ຄົນເຈັບໃໝ່",
    "revenuePerVisit": "ລາຍຮັບຕໍ່ການກວດ",
    "vsLastYear": "ທຽບກັບປີກາຍ",
    "noPrevious": "ບໍ່ມີຂໍ້ມູນປີກ່ອນ",
    "revenueByCategory": "ລາຍຮັບຕາມປະເພດບໍລິການ",
    "paymentMethods": "ການຊຳລະຕາມວິທີ",
    "waterfall": "ຈາກຄ່າບໍລິການສູ່ເງິນສົດ",
    "gross": "ຄ່າບໍລິການລວມ",
    "discounts": "ສ່ວນຫຼຸດ",
    "outstanding": "ຄ້າງຊຳລະ",
    "net": "ລາຍຮັບສຸດທິ",
    "revenueByMonth": "ລາຍຮັບສຸດທິລາຍເດືອນ",
    "revenueByQuarter": "ລາຍຮັບລາຍໄຕມາດ",
    "revenueByMonthCategory": "ລາຍຮັບລາຍເດືອນຕາມປະເພດບໍລິການ",
    "revenueByDepartment": "ລາຍຮັບຕາມພະແນກ",
    "statement": "ໃບລາຍງານລາຍຮັບ",
    "item": "ລາຍການ",
    "change": "ການປ່ຽນແປງ",
    "changePct": "ປ່ຽນແປງ %",
    "sectionRevenue": "ລາຍຮັບ",
    "totalGross": "ລາຍຮັບລວມ",
    "sectionOperations": "ການດຳເນີນງານ",
    "invoices": "ໃບແຈ້ງໜີ້",
    "visitsByMonth": "ການກວດລາຍເດືອນ",
    "topDiagnoses": "ພະຍາດທີ່ພົບຫຼາຍ",
    "demographics": "ຄົນເຈັບທີ່ມາກວດ ຕາມກຸ່ມອາຍຸ ແລະ ເພດ",
    "quarter": "ໄຕມາດ {{n}}",
    "noData": "ບໍ່ມີຂໍ້ມູນໃນໄລຍະນີ້",
    "category": {
      "CONSULTATION": "ກວດປິ່ນປົວ",
      "PHARMACY": "ຢາ",
      "LABORATORY": "ວິເຄາະ",
      "PROCEDURE": "ຫັດຖະການ",
      "SERVICE": "ສຸກເສີນ ແລະ ບໍລິການ",
      "ADMINISTRATIVE": "ບໍລິຫານ",
      "OTHER": "ອື່ນໆ",
      "OPHTHALMOLOGY": "ສູນຕາ",
      "SPECIAL_SERVICES": "ບໍລິການພິເສດ",
      "INPATIENT": "ຄ່າຕຽງຄົນເຈັບໃນ",
      "POS_SALES": "ຂາຍໜ້າຮ້ານ"
    }
  },
  "eye": {
    "title": "ສູນຕາ",
    "subtitle": "ພະແນກຕາ: ການກວດ, ຜ່າຕັດ, ສັກຢາ ແລະ ນັດຕິດຕາມ",
    "overview": "ພາບລວມ",
    "eyeRecord": "ແຟ້ມຕາ",
    "generalRecord": "ແຟ້ມທົ່ວໄປ",
    "openPatientRecord": "ເປີດແຟ້ມຕາຂອງຄົນເຈັບ",
    "patient": "ຄົນເຈັບ",
    "eyeSide": "ຕາ",
    "eyes": "ຕາ",
    "side": {
      "OD": "ຕາຂວາ (OD)",
      "OS": "ຕາຊ້າຍ (OS)",
      "OU": "ສອງຕາ (OU)"
    },
    "examinations": "ການກວດ",
    "surgeries": "ການຜ່າຕັດ",
    "injections": "ການສັກຢາເຂົ້າຕາ",
    "followUps": "ນັດຕິດຕາມ",
    "medications": "ຢາຕາ",
    "imaging": "ພາບຖ່າຍ",
    "procedures": "ຫັດຖະການ",
    "biometryIol": "ການວັດແທກຕາ ແລະ ເລນ",
    "trends": "ແນວໂນ້ມ",
    "currentStatus": "ສະຖານະປັດຈຸບັນ (ຄ່າລ່າສຸດແຕ່ລະຕາ)",
    "newExam": "ກວດຕາໃໝ່",
    "startEyeExam": "ເລີ່ມກວດຕາ",
    "openEyeExam": "ການກວດຕາ",
    "useOpenEncounter": "ສືບຕໍ່ໃນການມາກວດທີ່ເປີດຢູ່:",
    "startWithNewEncounter": "ເລີ່ມດ້ວຍການມາກວດໃໝ່",
    "planSurgery": "ວາງແຜນຜ່າຕັດ",
    "injection": "ສັກຢາ",
    "followUp": "ນັດຕິດຕາມ",
    "recordInjection": "ບັນທຶກການສັກຢາເຂົ້າວຸ້ນຕາ",
    "prescribeDrops": "ສັ່ງຢາຢອດຕາ",
    "scheduleFollowUp": "ນັດຕິດຕາມ",
    "visualAcuity": "ລະດັບສາຍຕາ",
    "iop": "ຄວາມດັນຕາ (IOP)",
    "refraction": "ຄ່າສາຍຕາ",
    "slitLamp": "ກວດດ້ວຍກ້ອງສລິດແລມ",
    "fundus": "ກວດຈໍຕາ",
    "diagnoses": "ການບົ່ງມະຕິຕາ",
    "historyAndPlan": "ປະຫວັດ, ບັນທຶກ ແລະ ແຜນການ",
    "addVisualAcuity": "ບັນທຶກລະດັບສາຍຕາ",
    "addPressure": "ບັນທຶກຄວາມດັນຕາ",
    "addRefraction": "ບັນທຶກຄ່າສາຍຕາ",
    "addDiagnosis": "ເພີ່ມການບົ່ງມະຕິ",
    "measurementType": "ປະເພດການວັດ",
    "chartType": "ແຜ່ນວັດສາຍຕາ",
    "acuity": "ສາຍຕາ",
    "acuityHint": "Snellen (6/12, 20/40), ທົດສະນິຍົມ, logMAR, CF, HM, LP, NLP",
    "correction": "ການແກ້ໄຂສາຍຕາ",
    "correctionPlaceholder": "ເຊັ່ນ ແວ່ນຕາ, ຄອນແທັກເລນ",
    "pressure": "ຄວາມດັນ",
    "method": "ວິທີ",
    "measuredAt": "ເວລາວັດ",
    "refractionType": "ປະເພດ",
    "sphere": "ສະເຟຍ (SPH)",
    "cylinder": "ສາຍຕາອຽງ (CYL)",
    "axis": "ແກນ",
    "add": "ຄ່າເພີ່ມ (ADD)",
    "pd": "ໄລຍະຫ່າງຮູມ່ານຕາ (PD)",
    "acuityWithRx": "ສາຍຕາເມື່ອໃສ່ຄ່ານີ້",
    "vaType": {
      "UNAIDED": "ຕາເປົ່າ",
      "CORRECTED": "ໃສ່ແວ່ນ",
      "PINHOLE": "ຮູເຂັມ (Pinhole)",
      "BEST_CORRECTED": "ສາຍຕາທີ່ດີທີ່ສຸດເມື່ອແກ້ໄຂ (BCVA)",
      "NEAR": "ໃກ້"
    },
    "chart": {
      "SNELLEN": "Snellen",
      "LOGMAR": "LogMAR",
      "DECIMAL": "ທົດສະນິຍົມ",
      "TUMBLING_E": "ຕົວ E",
      "LEA": "ສັນຍາລັກ LEA",
      "JAEGER": "Jaeger (ໃກ້)",
      "OTHER": "ອື່ນໆ"
    },
    "refractionTypes": {
      "AUTO": "ວັດດ້ວຍເຄື່ອງອັດຕະໂນມັດ",
      "RETINOSCOPY": "ສ່ອງໄຟວັດສາຍຕາ (Retinoscopy)",
      "SUBJECTIVE": "ວັດແບບຖາມຕອບ",
      "FINAL_PRESCRIPTION": "ຄ່າສາຍຕາສຸດທ້າຍ"
    },
    "iopMethod": {
      "GOLDMANN": "Goldmann",
      "NON_CONTACT": "ບໍ່ສຳຜັດ (ເປົ່າລົມ)",
      "TONOPEN": "Tono-Pen",
      "REBOUND": "Rebound (iCare)",
      "OTHER": "ອື່ນໆ"
    },
    "iopLevel": {
      "LOW": "ຕ່ຳ",
      "NORMAL": "ປົກກະຕິ",
      "ELEVATED": "ສູງ",
      "CRITICAL": "ສູງອັນຕະລາຍ"
    },
    "dxType": {
      "PRIMARY": "ຫຼັກ",
      "SECONDARY": "ຮອງ",
      "DIFFERENTIAL": "ແຍກພະຍາດ",
      "COMPLICATION": "ອາການແຊກຊ້ອນ"
    },
    "severity": "ຄວາມຮຸນແຮງ",
    "severities": {
      "MILD": "ເລັກນ້ອຍ",
      "MODERATE": "ປານກາງ",
      "SEVERE": "ຮຸນແຮງ",
      "EARLY": "ໄລຍະຕົ້ນ",
      "ADVANCED": "ໄລຍະລຸກລາມ",
      "END_STAGE": "ໄລຍະສຸດທ້າຍ",
      "NON_PROLIFERATIVE": "ບໍ່ມີເສັ້ນເລືອດງອກໃໝ່",
      "PROLIFERATIVE": "ມີເສັ້ນເລືອດງອກໃໝ່"
    },
    "icdCode": "ລະຫັດ ICD-10",
    "diagnosis": "ການບົ່ງມະຕິ",
    "dx": {
      "H25_1": "ຕາຕໍ້ກະຈົກແກ່ນຕາມອາຍຸ",
      "H26_9": "ຕາຕໍ້ກະຈົກ, ບໍ່ລະບຸ",
      "H40_1": "ຕ້ອຫິນມຸມເປີດປະຖົມພູມ",
      "H40_2": "ຕ້ອຫິນມຸມປິດປະຖົມພູມ",
      "E11_3": "ຈໍຕາເສື່ອມຈາກເບົາຫວານ",
      "H35_3": "ຈຸດຮັບພາບເສື່ອມຕາມອາຍຸ",
      "H33_0": "ຈໍຕາລອກມີຮອຍຂາດ",
      "H34_8": "ເສັ້ນເລືອດດຳຈໍຕາອຸດຕັນ",
      "H10_0": "ເຍື່ອບຸຕາອັກເສບຈາກເຊື້ອແບັກທີເຣຍ",
      "H16_0": "ແຜກະຈົກຕາ",
      "H11_0": "ຕໍ້ເນື້ອ",
      "H04_1": "ຕາແຫ້ງ",
      "H52_1": "ສາຍຕາສັ້ນ",
      "H52_0": "ສາຍຕາຍາວ",
      "H52_4": "ສາຍຕາຍາວຕາມອາຍຸ",
      "H50_0": "ຕາເຂເຂົ້າໃນ",
      "H53_0": "ຕາຂີ້ຄ້ານ",
      "H20_0": "ມ່ານຕາອັກເສບສ່ວນໜ້າແບບສ້ວຍແຫຼມ",
      "H00_0": "ຕາກຸ້ງຍິງ",
      "H57_1": "ເຈັບຕາ"
    },
    "field": {
      "chiefComplaint": "ອາການສຳຄັນ",
      "historyOfPresentIllness": "ປະຫວັດການເຈັບປ່ວຍປັດຈຸບັນ",
      "pastOcularHistory": "ປະຫວັດພະຍາດຕາໃນອະດີດ",
      "familyOcularHistory": "ປະຫວັດພະຍາດຕາໃນຄອບຄົວ",
      "systemicHistory": "ປະຫວັດພະຍາດທົ່ວໄປ",
      "clinicalNotes": "ບັນທຶກທາງຄລີນິກ",
      "plan": "ແຜນການປິ່ນປົວ",
      "lids": "ໜັງຕາ",
      "lashes": "ຂົນຕາ",
      "conjunctiva": "ເຍື່ອບຸຕາ",
      "sclera": "ຕາຂາວ",
      "cornea": "ກະຈົກຕາ",
      "anteriorChamber": "ຊ່ອງໜ້າມ່ານຕາ",
      "iris": "ມ່ານຕາ",
      "pupil": "ຮູມ່ານຕາ",
      "lens": "ແກ້ວຕາ",
      "vitreous": "ວຸ້ນຕາ",
      "opticDisc": "ຂົ້ວປະສາດຕາ",
      "cupDiscRatio": "ອັດຕາສ່ວນ ຖ້ວຍ/ຂົ້ວປະສາດຕາ (C/D)",
      "macula": "ຈຸດຮັບພາບ",
      "vessels": "ເສັ້ນເລືອດ",
      "retina": "ຈໍຕາ",
      "peripheralRetina": "ຈໍຕາສ່ວນນອກ",
      "notes": "ໝາຍເຫດ"
    },
    "fillNormal": "ຕື່ມຜົນປົກກະຕິ",
    "notRecorded": "ບໍ່ໄດ້ບັນທຶກ",
    "noDiagnoses": "ຍັງບໍ່ມີການບົ່ງມະຕິ",
    "cdrSuspicious": "C/D ຕັ້ງແຕ່ 0.6 ສົງໄສຕ້ອຫິນ",
    "worse": "ແຍ່ລົງ",
    "better": "ດີຂຶ້ນ",
    "previousValue": "ຄັ້ງກ່ອນ: {{value}}",
    "sign": "ລົງນາມການກວດ",
    "signConfirm": "ການລົງນາມຈະລັອກການກວດນີ້. ການແກ້ໄຂພາຍຫຼັງຈະເຮັດເປັນສະບັບແກ້ໄຂ. ລົງນາມດຽວນີ້ບໍ?",
    "signed": "ລົງນາມການກວດແລ້ວ",
    "amend": "ແກ້ໄຂ",
    "amendHelp": "ລະບົບຈະສ້າງສຳເນົາເພື່ອແກ້ໄຂ; ສະບັບເດີມຍັງຢູ່ໃນແຟ້ມໂດຍບໍ່ປ່ຽນແປງ.",
    "amendReason": "ເຫດຜົນການແກ້ໄຂ",
    "amendmentOf": "ນີ້ແມ່ນສະບັບແກ້ໄຂຂອງ",
    "originalExam": "ການກວດສະບັບເດີມ",
    "supersededBy": "ການກວດນີ້ຖືກແກ້ໄຂແລ້ວ. ເບິ່ງ",
    "latestAmendment": "ສະບັບແກ້ໄຂລ່າສຸດ",
    "signedBanner": "ລົງນາມໂດຍ {{name}} ເມື່ອ {{date}}",
    "comparedWith": "ທຽບກັບການກວດຄັ້ງກ່ອນ {{date}}",
    "cancelExam": "ຍົກເລີກການກວດ",
    "logmarHelp": "LogMAR: 0.0 = 6/6, 0.3 = 6/12, 1.0 = 6/60. ຄ່າຍິ່ງຕ່ຳຍິ່ງດີ; ແກນຖືກປີ້ນໃຫ້ຂຶ້ນເທິງໝາຍເຖິງດີຂຶ້ນ.",
    "drivingStandard": "6/12 (ມາດຕະຖານຂັບຂີ່)",
    "iopUpperNormal": "21 mmHg ຂີດສູງສຸດປົກກະຕິ",
    "cstThreshold": "300 µm",
    "mdModerate": "−6 dB",
    "centralThickness": "ຄວາມໜາຈຸດຮັບພາບສ່ວນກາງ",
    "rnfl": "ຄວາມໜາຊັ້ນເສັ້ນໃຍປະສາດ (RNFL)",
    "sphericalEquivalent": "ຄ່າສາຍຕາສະເລ່ຍ (SE)",
    "visualField": "ລານສາຍຕາ",
    "noTrendData": "ຍັງບໍ່ມີຂໍ້ມູນ",
    "treatments": "ການປິ່ນປົວ",
    "bcva": "ສາຍຕາດີສຸດເມື່ອແກ້ໄຂ",
    "frequencies": {
      "qd": "ມື້ລະເທື່ອ",
      "bid": "ມື້ລະ 2 ເທື່ອ",
      "tid": "ມື້ລະ 3 ເທື່ອ",
      "qid": "ມື້ລະ 4 ເທື່ອ",
      "q2h": "ທຸກ 2 ຊົ່ວໂມງ",
      "qhs": "ກ່ອນນອນ"
    },
    "medication": "ຢາ",
    "medicationName": "ຊື່ຢາ",
    "otherMedication": "ອື່ນໆ (ພິມຊື່)",
    "dose": "ຂະໜາດ",
    "frequency": "ຄວາມຖີ່",
    "duration": "ໄລຍະເວລາ",
    "startDate": "ວັນເລີ່ມ",
    "endDate": "ວັນສິ້ນສຸດ",
    "instructions": "ຄຳແນະນຳ",
    "stop": "ຢຸດ",
    "stopMedication": "ຢຸດຢາຕາ",
    "noMedications": "ບໍ່ມີຢາຕາ",
    "lotNumber": "ເລກລັອດ",
    "expiryDate": "ວັນໝົດອາຍຸ",
    "indication": "ຂໍ້ບົ່ງຊີ້",
    "complications": "ອາການແຊກຊ້ອນ",
    "confirmEyeStatement": "ຂ້ອຍໄດ້ຢືນຢັນ {{eye}} ກັບຄົນເຈັບ ແລະ ຈຸດທີ່ໝາຍໄວ້, ແລະ ກວດຢາ, ຂະໜາດ ແລະ ວັນໝົດອາຍຸແລ້ວ.",
    "noInjections": "ບໍ່ມີການສັກຢາ",
    "by": "ໂດຍ",
    "modality": "ປະເພດການກວດ",
    "results": "ຜົນ",
    "device": "ເຄື່ອງ",
    "noImaging": "ບໍ່ມີພາບຖ່າຍ",
    "modalities": {
      "FUNDUS_PHOTO": "ຖ່າຍພາບຈໍຕາ",
      "OCT": "OCT",
      "OCT_ANGIOGRAPHY": "OCT ເສັ້ນເລືອດ",
      "VISUAL_FIELD": "ລານສາຍຕາ",
      "CORNEAL_TOPOGRAPHY": "ແຜນທີ່ກະຈົກຕາ",
      "PACHYMETRY": "ວັດຄວາມໜາກະຈົກຕາ",
      "B_SCAN": "ອັນຕຣາຊາວ B-scan",
      "BIOMETRY": "ການວັດແທກຕາ",
      "OTHER": "ອື່ນໆ"
    },
    "procedure": "ຫັດຖະການ",
    "outcome": "ຜົນລັບ",
    "noExams": "ບໍ່ມີການກວດຕາ",
    "noSurgeries": "ບໍ່ມີການຜ່າຕັດ",
    "noFollowUps": "ບໍ່ມີນັດຕິດຕາມ",
    "postOp": "ກວດຫຼັງຜ່າຕັດ",
    "caseNumber": "ເລກກໍລະນີ",
    "biometry": "ການວັດແທກຕາ",
    "biometryHelp": "ການວັດແທກຕາແຕ່ລະຂ້າງ. ເລືອກຜົນວັດເພື່ອວາງແຜນເລນແກ້ວຕາທຽມ.",
    "addBiometry": "ເພີ່ມການວັດແທກຕາ",
    "noBiometry": "ບໍ່ມີການວັດແທກຕາ",
    "axialLength": "ຄວາມຍາວລູກຕາ",
    "lensThickness": "ຄວາມໜາແກ້ວຕາ",
    "axialAsymmetry": "ຄວາມຍາວລູກຕາສອງຂ້າງຕ່າງກັນ {{diff}} mm. ກະລຸນາວັດຄືນກ່ອນເລືອກເລນ.",
    "toricHint": "ສາຍຕາອຽງຂອງກະຈົກຕາ {{cyl}} D. ພິຈາລະນາເລນ toric.",
    "formula": "ສູດ",
    "formulas": {
      "SRK_T": "SRK/T",
      "BARRETT_UNIVERSAL_II": "Barrett Universal II",
      "HAIGIS": "Haigis",
      "HOFFER_Q": "Hoffer Q",
      "HOLLADAY": "Holladay",
      "KANE": "Kane",
      "OTHER": "ອື່ນໆ"
    },
    "aConstant": "ຄ່າຄົງທີ A",
    "targetRefraction": "ຄ່າສາຍຕາເປົ້າໝາຍ",
    "iolModel": "ລຸ້ນເລນ",
    "iolPower": "ກຳລັງເລນ",
    "iolPowerAuto": "ປ່ອຍວ່າງເພື່ອໃຊ້ຄ່າທີ່ແນະນຳ",
    "fromBiometer": "ຈາກໃບພິມຂອງເຄື່ອງວັດ",
    "predictedRefraction": "ຄ່າສາຍຕາທີ່ຄາດໄວ້",
    "saveCalculation": "ບັນທຶກການຄິດໄລ່",
    "suggestedPower": "ກຳລັງເລນທີ່ແນະນຳ",
    "emmetropicPower": "ກຳລັງເລນສຳລັບສາຍຕາປົກກະຕິ",
    "noCalculations": "ຍັງບໍ່ມີການຄິດໄລ່ເລນ",
    "selected": "ເລືອກແລ້ວ",
    "select": "ເລືອກ",
    "iolSelected": "ເລືອກເລນສຳລັບຜ່າຕັດແລ້ວ",
    "operativeEye": "ຕາທີ່ຈະຜ່າຕັດ",
    "surgeryType": "ປະເພດການຜ່າຕັດ",
    "surgeryTypes": {
      "CATARACT": "ຕາຕໍ້ກະຈົກ",
      "GLAUCOMA": "ຕ້ອຫິນ",
      "RETINA": "ຈໍຕາ",
      "VITRECTOMY": "ຜ່າຕັດວຸ້ນຕາ",
      "CORNEA": "ກະຈົກຕາ",
      "REFRACTIVE": "ແກ້ໄຂສາຍຕາ",
      "OCULOPLASTIC": "ສັນຍະກຳຕົກແຕ່ງຕາ",
      "STRABISMUS": "ຕາເຂ",
      "PTERYGIUM": "ຕໍ້ເນື້ອ",
      "LASER": "ເລເຊີ",
      "OTHER": "ອື່ນໆ"
    },
    "procedureExample": {
      "CATARACT": "ສະຫຼາຍຕໍ້ດ້ວຍຄື້ນສຽງ + ໃສ່ເລນ",
      "GLAUCOMA": "ຜ່າຕັດລະບາຍນ້ຳໃນຕາ",
      "RETINA": "ໃສ່ສາຍຮັດຕາຂາວ",
      "VITRECTOMY": "ຜ່າຕັດວຸ້ນຕາ (PPV)",
      "CORNEA": "ປ່ຽນກະຈົກຕາ",
      "REFRACTIVE": "LASIK",
      "OCULOPLASTIC": "ຜ່າຕັດໜັງຕາ",
      "STRABISMUS": "ຜ່າຕັດກ້າມເນື້ອຕາ",
      "PTERYGIUM": "ລອກຕໍ້ເນື້ອ ແລະ ປູເຍື່ອບຸຕາ",
      "LASER": "ເລເຊີ YAG",
      "OTHER": "ອະທິບາຍຫັດຖະການ"
    },
    "anesthesia": "ການລະງັບຄວາມຮູ້ສຶກ",
    "anesthesiaTypes": {
      "TOPICAL": "ຢອດຢາຊາ",
      "LOCAL": "ສັກຢາຊາ",
      "PERIBULBAR": "ສັກຢາຊາຮອບລູກຕາ",
      "RETROBULBAR": "ສັກຢາຊາຫຼັງລູກຕາ",
      "SUB_TENON": "ສັກຢາຊາໃຕ້ເຍື່ອ Tenon",
      "GENERAL": "ດົມຢາສະລົບ"
    },
    "scheduledAt": "ນັດເວລາ",
    "preopDiagnosis": "ການບົ່ງມະຕິກ່ອນຜ່າຕັດ",
    "noBiometryForEye": "ບໍ່ມີການວັດແທກສຳລັບຕານີ້",
    "chooseEyeFirst": "ກະລຸນາເລືອກຕາກ່ອນ",
    "cataractNeedsBiometry": "ການຜ່າຕັດຕາຕໍ້ຕ້ອງມີການວັດແທກ ແລະ ເລືອກເລນຂອງຕານີ້ກ່ອນເຮັດລາຍການກວດກ່ອນຜ່າຕັດ.",
    "safetyChecklist": "ລາຍການກວດຄວາມປອດໄພກ່ອນຜ່າຕັດ",
    "checklistHelp": "ເຮັດໃນຂະນະທີ່ຄົນເຈັບຕື່ນ ແລະ ທີມຢູ່ພ້ອມ. ທີມຕ້ອງລະບຸຕາເອງ, ບໍ່ສຳເນົາຈາກແຜນ.",
    "teamStatesEye": "ຕາທີ່ທີມລະບຸ",
    "eyeMismatchTitle": "ຜິດຕາ!",
    "eyeMismatchBody": "ແຜນແມ່ນ {{planned}} ແຕ່ທີມລະບຸ {{stated}}. ຢຸດ ແລະ ກວດສອບຄືນ.",
    "check": {
      "patientIdentityConfirmed": "ຢືນຢັນຕົວຕົນຄົນເຈັບ (ຊື່ + ວັນເກີດ)",
      "procedureConfirmed": "ຢືນຢັນຫັດຖະການກັບຄົນເຈັບ ແລະ ໃບຍິນຍອມ",
      "eyeSideConfirmed": "ຢືນຢັນຕາທີ່ຈະຜ່າແລ້ວ",
      "consentConfirmed": "ມີໃບຍິນຍອມທີ່ລົງນາມແລ້ວ",
      "siteMarked": "ໝາຍຈຸດຜ່າຕັດແລ້ວ"
    },
    "confirmChecklist": "ຢືນຢັນລາຍການກວດ",
    "checklistConfirmed": "ຢືນຢັນລາຍການກວດຄວາມປອດໄພແລ້ວ",
    "confirmedBy": "ຢືນຢັນໂດຍ {{name}} ເວລາ {{date}}",
    "startSurgery": "ເລີ່ມຜ່າຕັດ",
    "startConfirm": "ເລີ່ມ {{procedure}} ທີ່ {{eye}} ບໍ?",
    "cancelSurgery": "ຍົກເລີກການຜ່າຕັດ",
    "cancelledBecause": "ຍົກເລີກ: {{reason}}",
    "surgicalPlan": "ແຜນການຜ່າຕັດ",
    "surgeon": "ແພດຜ່າຕັດ",
    "startedAt": "ເລີ່ມ",
    "completedAt": "ສຳເລັດ",
    "lensPlan": "ແຜນເລນ",
    "openBiometry": "ເປີດການວັດແທກ",
    "noBiometryLinked": "ບໍ່ໄດ້ເຊື່ອມໂຍງການວັດແທກ",
    "selectedLens": "ເລນທີ່ເລືອກ",
    "noLensSelected": "ຍັງບໍ່ໄດ້ເລືອກເລນ",
    "operativeRecord": "ບັນທຶກການຜ່າຕັດ",
    "operativeFindings": "ສິ່ງທີ່ພົບລະຫວ່າງຜ່າຕັດ",
    "operativeNotes": "ລາຍລະອຽດການຜ່າຕັດ",
    "postopNotes": "ຄຳສັ່ງຫຼັງຜ່າຕັດ",
    "noneIfBlank": "ປ່ອຍວ່າງຖ້າບໍ່ມີ",
    "implants": "ອຸປະກອນຝັງ",
    "implantTypes": {
      "IOL": "ເລນແກ້ວຕາທຽມ",
      "CAPSULAR_TENSION_RING": "ວົງຮັດຖົງແກ້ວຕາ",
      "GLAUCOMA_DRAINAGE_DEVICE": "ອຸປະກອນລະບາຍຕ້ອຫິນ",
      "STENT": "ທໍ່ຄ້ຳ",
      "SILICONE_OIL": "ນ້ຳມັນຊິລິໂຄນ",
      "GAS": "ອາຍແກັສກົດຈໍຕາ",
      "OTHER": "ອື່ນໆ"
    },
    "model": "ລຸ້ນ",
    "manufacturer": "ຜູ້ຜະລິດ",
    "serialNumber": "ເລກຊີຣີ",
    "powerMismatchTitle": "ກຳລັງເລນບໍ່ກົງກັບແຜນ.",
    "powerMismatchBody": "ເລນທີ່ເລືອກແມ່ນ {{planned}} D. ກວດກ່ອງເລນທຽບກັບແຜນ.",
    "powerOverride": "ຂ້ອຍໄດ້ຢືນຢັນກຳລັງເລນນີ້ກັບແພດຜ່າຕັດແລ້ວ (ບັນທຶກການຍົກເວັ້ນ)",
    "firstPostOpVisit": "ນັດກວດຫຼັງຜ່າຕັດຄັ້ງທຳອິດ",
    "completeSurgery": "ສຳເລັດການຜ່າຕັດ",
    "surgeryCompleted": "ຜ່າຕັດສຳເລັດ",
    "followUpDate": "ວັນນັດ",
    "inDays": "ອີກ {{count}} ມື້",
    "examsToday": "ການກວດມື້ນີ້",
    "openExams": "ການກວດທີ່ຍັງເປີດ",
    "surgeriesUpcoming": "ການຜ່າຕັດທີ່ກຳລັງຈະມາ",
    "surgeriesMonth": "ການຜ່າຕັດເດືອນນີ້",
    "injectionsMonth": "ການສັກຢາເດືອນນີ້",
    "followUpsToday": "ນັດຕິດຕາມມື້ນີ້",
    "followUpsOverdue": "ນັດທີ່ເກີນກຳນົດ",
    "highIopPatients": "ຄົນເຈັບຄວາມດັນຕາເກີນ 21",
    "activityByMonth": "ກິດຈະກຳສູນຕາ (12 ເດືອນທີ່ຄົບຖ້ວນລ່າສຸດ)",
    "activity": {
      "exams": "ການກວດ",
      "injections": "ການສັກຢາ",
      "surgeries": "ການຜ່າຕັດ"
    },
    "surgeriesByType": "ການຜ່າຕັດຕາມປະເພດ (12 ເດືອນທີ່ຄົບຖ້ວນລ່າສຸດ)",
    "topEyeDiagnoses": "ການບົ່ງມະຕິຕາສູງສຸດ (12 ເດືອນ)",
    "iopControl": "ການຄວບຄຸມຄວາມດັນຕາ (ລ່າສຸດແຕ່ລະຕາ, 12 ເດືອນ)",
    "iopControlHelp": "ປົກກະຕິ 10 ຫາ 21 mmHg. ຕາທີ່ສູງ ແລະ ສູງອັນຕະລາຍຕ້ອງທົບທວນ.",
    "cataractOutcome": "ຜົນການຜ່າຕັດຕາຕໍ້",
    "cataractOutcomeHelp": "{{good}} ຈາກ {{measured}} ຕາທີ່ວັດໄດ້ ມີສາຍຕາ 6/12 ຫຼື ດີກວ່າພາຍໃນ 90 ມື້ ({{operated}} ການຜ່າຕັດໃນ 12 ເດືອນ).",
    "upcomingSurgeries": "ການຜ່າຕັດທີ່ກຳລັງຈະມາ",
    "anyDate": "ທຸກວັນທີ",
    "myCases": "ກໍລະນີຂອງຂ້ອຍ",
    "due": {
      "overdue": "ເກີນກຳນົດ",
      "today": "ມື້ນີ້",
      "week": "7 ມື້ຂ້າງໜ້າ"
    },
    "phone": "ເບີໂທ",
    "doctor": "ທ່ານໝໍ",
    "markSeen": "ມາແລ້ວ",
    "markMissed": "ບໍ່ມາ"
  },
  "pathways": {
    "title": "ວົງຈອນການປິ່ນປົວ",
    "subtitle": "ວົງຈອນການດູແລແຕ່ລະພະຍາດ ເທື່ອລະຂັ້ນ ສຳລັບແພດ, ພະຍາບານ ແລະ ຄົນເຈັບ",
    "cycles": "ວົງຈອນ",
    "dueReviews": "ຕ້ອງທົບທວນ",
    "new": "ວົງຈອນໃໝ່",
    "searchPlaceholder": "ຄົ້ນຫາພະຍາດ, ລະຫັດ ຫຼື ວົງຈອນ…",
    "categoryLabel": "ໝວດ",
    "category": {
      "EYE": "ຕາ",
      "CHRONIC": "ພະຍາດຊຳເຮື້ອ",
      "INFECTIOUS": "ພະຍາດຕິດຕໍ່",
      "MATERNAL": "ແມ່ ແລະ ເດັກ",
      "SURGICAL": "ສັນຍະກຳ",
      "PEDIATRIC": "ເດັກ",
      "MENTAL": "ສຸຂະພາບຈິດ",
      "GENERAL": "ທົ່ວໄປ"
    },
    "shared": "ໃຊ້ຮ່ວມກັນ",
    "sharedTemplate": "ແມ່ແບບໃຊ້ຮ່ວມກັນ",
    "sharedReadOnly": "ນີ້ແມ່ນແມ່ແບບໃຊ້ຮ່ວມກັນ. ສຳເນົາໄປໂຮງໝໍຂອງທ່ານເພື່ອປັບຂັ້ນຕອນ.",
    "hospital": "ໂຮງໝໍນີ້",
    "scope": "ຂອບເຂດ",
    "cyclic": "ວົງຈອນຊ້ຳ",
    "linear": "ເສັ້ນທາງດຽວ",
    "stageCount": "{{count}} ຂັ້ນຕອນ",
    "activePatients": "ຄົນເຈັບປັດຈຸບັນ {{count}}",
    "disease": "ພະຍາດ",
    "diseaseCode": "ລະຫັດ ICD-10",
    "stages": "ຂັ້ນຕອນ",
    "stage": "ຂັ້ນຕອນ",
    "patients": "ຄົນເຈັບ",
    "pathway": "ວົງຈອນການປິ່ນປົວ",
    "currentStage": "ຂັ້ນຕອນປັດຈຸບັນ",
    "cycle": "ຮອບ",
    "cycleN": "ຮອບ {{n}}",
    "daysShort": "{{count}} ມື້",
    "nextReview": "ທົບທວນຄັ້ງຕໍ່ໄປ",
    "nextReviewHint": "ປ່ອຍວ່າງເພື່ອໃຊ້ໄລຍະຂອງຂັ້ນຕອນ",
    "nextReviewOn": "ທົບທວນ {{date}}",
    "dueToday": "ມື້ນີ້",
    "dueWeek": "7 ມື້",
    "dueMonth": "30 ມື້",
    "noneDue": "ບໍ່ມີການທົບທວນ",
    "details": "ລາຍລະອຽດ",
    "autoCode": "ສ້າງອັດຕະໂນມັດຖ້າວ່າງ",
    "color": "ສີ",
    "inherit": "ຕາມວົງຈອນ",
    "isCyclicHelp": "ຊ້ຳ: ຫຼັງຂັ້ນຕອນສຸດທ້າຍ ຄົນເຈັບເລີ່ມຮອບໃໝ່",
    "translations": "ພາສາອື່ນ",
    "addStage": "ເພີ່ມຂັ້ນຕອນ",
    "untitled": "ບໍ່ມີຊື່",
    "moveUp": "ຍ້າຍຂຶ້ນ",
    "moveDown": "ຍ້າຍລົງ",
    "stageName": "ຊື່ຂັ້ນຕອນ",
    "durationDays": "ໄລຍະ (ມື້)",
    "icon": "ໄອຄອນ",
    "actions": "ສິ່ງທີ່ທີມຕ້ອງເຮັດ",
    "actionsHint": "ລາຍການສຳລັບແພດ ແລະ ພະຍາບານ",
    "patientInstructions": "ຄຳແນະນຳສຳລັບຄົນເຈັບ",
    "patientInstructionsHint": "ສະແດງໃນແອັບຄົນເຈັບ",
    "preview": "ຕົວຢ່າງ",
    "previewCyclic": "ກົດຂັ້ນຕອນເພື່ອແກ້ໄຂ. ລູກສອນສະແດງວົງຈອນຊ້ຳ.",
    "previewLinear": "ກົດຂັ້ນຕອນເພື່ອແກ້ໄຂ. ເສັ້ນທາງສິ້ນສຸດຫຼັງຂັ້ນຕອນສຸດທ້າຍ.",
    "copyToHospital": "ສຳເນົາໄປໂຮງໝໍຂອງຂ້ອຍ",
    "copied": "ສຳເນົາແລ້ວ — ແກ້ໄຂໄດ້ແລ້ວ",
    "archive": "ເກັບ",
    "restore": "ກູ້ຄືນ",
    "archived": "ເກັບແລ້ວ",
    "lastUpdated": "ອັບເດດ {{date}} ໂດຍ {{name}}",
    "patientCycles": "ວົງຈອນການປິ່ນປົວ",
    "enroll": "ເລີ່ມວົງຈອນການປິ່ນປົວ",
    "enrolled": "ເລີ່ມວົງຈອນແລ້ວ",
    "pickStartStage": "ກົດຂັ້ນຕອນເພື່ອເລີ່ມ (ຄ່າເລີ່ມຕົ້ນ: ຂັ້ນຕອນທຳອິດ)",
    "noPlans": "ຍັງບໍ່ມີວົງຈອນ",
    "showEnded": "ສະແດງທີ່ສິ້ນສຸດ ({{count}})",
    "hideEnded": "ເຊື່ອງທີ່ສິ້ນສຸດ",
    "startedOn": "ເລີ່ມ {{date}}",
    "since": "ຕັ້ງແຕ່ {{date}}",
    "advance": "ຂັ້ນຕອນຕໍ່ໄປ",
    "advanceTo": "ຍ້າຍຄົນເຈັບໄປ",
    "startsCycle": "ເລີ່ມຮອບ {{n}}",
    "completesPlan": "ນີ້ແມ່ນຂັ້ນຕອນສຸດທ້າຍ: ວົງຈອນຈະສຳເລັດ.",
    "moveTo": "ຍ້າຍໄປຂັ້ນຕອນ",
    "addNote": "ບັນທຶກ",
    "stop": "ຢຸດວົງຈອນ",
    "history": "ປະຫວັດ",
    "event": {
      "STARTED": "ເລີ່ມ",
      "ADVANCED": "ຂັ້ນຕໍ່ໄປ",
      "MOVED": "ຍ້າຍ",
      "NEW_CYCLE": "ຮອບໃໝ່",
      "COMPLETED": "ສຳເລັດ",
      "STOPPED": "ຢຸດ",
      "NOTE": "ບັນທຶກ"
    }
  },
  "portal": {
    "cardTitle": "ແອັບຄົນເຈັບ",
    "noAccount": "ຍັງບໍ່ໄດ້ໃຊ້ແອັບຄົນເຈັບ.",
    "contact": "ເບີໂທ / ອີເມວ",
    "createdVia": "ລົງທະບຽນໂດຍ",
    "via": {
      "SELF_REGISTRATION": "ລົງທະບຽນເອງ (ຄົນເຈັບໃໝ່)",
      "SELF_LINKED": "ລົງທະບຽນເອງ (ກົງກັບແຟ້ມ)",
      "STAFF_ACTIVATION": "ລະຫັດເປີດໃຊ້ຈາກໂຕະ"
    },
    "lastLogin": "ເຂົ້າລະບົບລ່າສຸດ",
    "verifiedBy": "ກວດບັດໂດຍ",
    "pendingHelp": "ລົງທະບຽນຈາກແອັບ. ກວດບັດປະຈຳຕົວ ແລ້ວກົດຢືນຢັນຕົວຕົນ.",
    "activeCode": "ລະຫັດເປີດໃຊ້ໃຊ້ໄດ້ຮອດ {{date}}",
    "issueActivation": "ໃຫ້ສິດໃຊ້ແອັບ",
    "newActivation": "ລະຫັດເປີດໃຊ້ໃໝ່",
    "verifyIdentity": "ຢືນຢັນຕົວຕົນ",
    "verified": "ຢືນຢັນຕົວຕົນແລ້ວ",
    "disable": "ປິດການໃຊ້ແອັບ",
    "enable": "ເປີດການໃຊ້ແອັບ",
    "disableConfirm": "ຄົນເຈັບຈະຖືກອອກຈາກທຸກໂທລະສັບ ແລະ ເຂົ້າບໍ່ໄດ້ຈົນກວ່າຈະເປີດຄືນ.",
    "activationTitle": "ການເປີດໃຊ້ແອັບຄົນເຈັບ",
    "activationFor": "ເປີດໃຊ້ສຳລັບ",
    "activationExpires": "ໃຊ້ໄດ້ຮອດ {{date}}",
    "step1": "ຕິດຕັ້ງແອັບ HMS ແລະ ເລືອກ \"ຂ້ອຍເປັນຄົນເຈັບ\".",
    "step2": "ກົດ \"ສ້າງບັນຊີ\", ໃສ່ເບີໂທ ຫຼື ອີເມວ ແລະ ລະຫັດນີ້.",
    "step3": "ໃສ່ລະຫັດ OTP ທີ່ສົ່ງໃຫ້ເພື່ອສຳເລັດ.",
    "activationOnce": "ລະຫັດສະແດງເທື່ອດຽວ. ພິມ ຫຼື ໃຫ້ຄົນເຈັບສະແກນດຽວນີ້.",
    "identifyTitle": "ລະບຸຄົນເຈັບດ້ວຍ QR",
    "identifyHelp": "ໃຫ້ຄົນເຈັບເປີດ \"ບັດສຸຂະພາບຂອງຂ້ອຍ\" ໃນແອັບ ແລ້ວສະແກນ QR.",
    "pasteCode": "ຫຼື ວາງລະຫັດຈາກເຄື່ອງສະແກນ",
    "identify": "ລະບຸ",
    "cameraUnavailable": "ໃຊ້ກ້ອງບໍ່ໄດ້. ໃຊ້ເຄື່ອງສະແກນ ຫຼື ວາງລະຫັດ.",
    "stopCamera": "ປິດກ້ອງ",
    "startCamera": "ເປີດກ້ອງ",
    "hasAllergies": "ມີປະຫວັດແພ້ {{count}} ລາຍການ — ກວດກ່ອນປິ່ນປົວ.",
    "checkIdCard": "ລົງທະບຽນຈາກແອັບ: ກວດບັດປະຈຳຕົວກ່ອນປິ່ນປົວ.",
    "appointmentsToday": "ນັດໝາຍມື້ນີ້",
    "checkedIn": "ລົງທະບຽນມາແລ້ວ",
    "openRecord": "ເປີດແຟ້ມ",
    "giveTicket": "ອອກບັດຄິວ",
    "scanAnother": "ສະແກນອີກ",
    "adminTitle": "ແອັບຄົນເຈັບ",
    "adminSubtitle": "ວິທີທີ່ຄົນເຈັບເຂົ້າໃຊ້ ແລະ ຂໍ້ຄວາມທີ່ສົ່ງໂດຍລະບົບທົດລອງ",
    "flowActivation": "ລົງທະບຽນຢູ່ໂຮງໝໍແລ້ວ",
    "flowActivationText": "ເປີດແຟ້ມຄົນເຈັບ ແລະ ກົດ \"ໃຫ້ສິດໃຊ້ແອັບ\". ຄົນເຈັບສະແກນ QR ໃນແອັບ ແລະ ຢືນຢັນດ້ວຍລະຫັດ OTP.",
    "flowSelf": "ລົງທະບຽນຈາກໂທລະສັບ",
    "flowSelfText": "ຄົນເຈັບໃສ່ເບີໂທ ຫຼື ອີເມວ, ຊື່ ແລະ ວັນເກີດ ແລ້ວຢືນຢັນ OTP. ຖ້າກົງກັບແຟ້ມຈະເຊື່ອມໂຍງ; ບໍ່ດັ່ງນັ້ນແຟ້ມໃໝ່ຈະລໍຖ້າກວດບັດໃນການມາຄັ້ງທຳອິດ.",
    "flowVisit": "ການມາຄັ້ງຕໍ່ໄປ",
    "flowVisitText": "ຄົນເຈັບສະແດງ QR. ພະນັກງານສະແກນໃນໜ້າຄົນເຈັບ ຫຼື ຄິວ ເພື່ອເປີດແຟ້ມ, ລົງທະບຽນ ຫຼື ອອກບັດຄິວ. ຄົນເຈັບຍັງຮັບບັດຄິວໃນແອັບໄດ້.",
    "dummyGateway": "ໂໝດທົດລອງ: SMS/ອີເມວ ແລະ ການຈ່າຍເງິນທະນາຄານແມ່ນການຈຳລອງ. ລະຫັດ OTP ບັນທຶກໄວ້ດ້ານລຸ່ມ (ປິດບັງ) ແລະ ສະແດງໃນແອັບ; ບໍ່ມີການຕັດເງິນ.",
    "outbox": "ກ່ອງຂໍ້ຄວາມສົ່ງອອກ (ຈຳລອງ)",
    "outboxEmpty": "ຍັງບໍ່ມີຂໍ້ຄວາມ",
    "destination": "ເຖິງ",
    "message": "ຂໍ້ຄວາມ",
    "msgStatus": {
      "SIMULATED": "ຈຳລອງ"
    },
    "appStatus": {
      "VERIFIED": "ແອັບ · ຢືນຢັນແລ້ວ",
      "PENDING_VERIFICATION": "ແອັບ · ລໍຖ້າກວດບັດ",
      "DISABLED": "ແອັບ · ປິດໃຊ້"
    },
    "appStatusHelp": {
      "VERIFIED": "ລົງທະບຽນໃນແອັບຄົນເຈັບແລ້ວ ແລະ ກວດບັດແລ້ວ",
      "PENDING_VERIFICATION": "ລົງທະບຽນຜ່ານແອັບ; ກວດບັດປະຈຳຕົວໃນການມາຄັ້ງຕໍ່ໄປ",
      "DISABLED": "ການເຂົ້າໃຊ້ແອັບຖືກປິດ"
    },
    "appFilter": "ແອັບຄົນເຈັບ",
    "appFilterRegistered": "ລົງທະບຽນໃນແອັບແລ້ວ",
    "appFilterNone": "ຍັງບໍ່ໄດ້ລົງທະບຽນໃນແອັບ"
  },
  "patientApp": {
    "iAmPatient": "ຂ້ອຍເປັນຄົນເຈັບ",
    "iAmStaff": "ພະນັກງານໂຮງໝໍ",
    "welcome": "ສຸຂະພາບຂອງທ່ານ ໃນມືຖືຂອງທ່ານ",
    "welcomeSub": "ເບິ່ງການກວດ, ຜົນ ແລະ ໃບບິນ, ຮັບບັດຄິວ ແລະ ສະແດງບັດສຸຂະພາບ.",
    "signIn": "ເຂົ້າສູ່ລະບົບ",
    "register": "ສ້າງບັນຊີ",
    "hospital": "ໂຮງໝໍ",
    "usePhone": "ເບີໂທ",
    "useEmail": "ອີເມວ",
    "phone": "ເບີມືຖື",
    "email": "ທີ່ຢູ່ອີເມວ",
    "sendCode": "ສົ່ງລະຫັດ",
    "codeSentTo": "ໃສ່ລະຫັດ 6 ຕົວທີ່ສົ່ງໄປ {{destination}}",
    "code": "ລະຫັດຢືນຢັນ",
    "verify": "ຢືນຢັນ",
    "resend": "ສົ່ງລະຫັດໃໝ່",
    "demoCode": "ທົດລອງ — ລະຫັດຂອງທ່ານແມ່ນ {{code}}",
    "loginHint": "ຖ້າທ່ານມີບັນຊີ, ລະຫັດຈະຖືກສົ່ງໃຫ້.",
    "haveActivation": "ຂ້ອຍມີລະຫັດເປີດໃຊ້ຈາກໂຮງໝໍ",
    "activationCode": "ລະຫັດເປີດໃຊ້",
    "firstName": "ຊື່",
    "lastName": "ນາມສະກຸນ",
    "dateOfBirth": "ວັນເດືອນປີເກີດ",
    "sex": "ເພດ",
    "newHere": "ໃໝ່ບໍ? ສ້າງບັນຊີ",
    "haveAccount": "ມີບັນຊີແລ້ວ? ເຂົ້າສູ່ລະບົບ",
    "pendingBanner": "ສະແດງບັດປະຈຳຕົວຢູ່ໂຕະລົງທະບຽນໃນຄັ້ງທຳອິດ ເພື່ອໃຊ້ທຸກຄຸນສົມບັດ.",
    "home": "ໜ້າຫຼັກ",
    "records": "ປະຫວັດ",
    "queue": "ຄິວ",
    "payments": "ການຈ່າຍເງິນ",
    "profile": "ໂປຣໄຟລ໌",
    "hello": "ສະບາຍດີ, {{name}}",
    "myId": "ບັດສຸຂະພາບຂອງຂ້ອຍ",
    "idHelp": "ສະແດງ QR ນີ້ທີ່ໂຕະໂຮງໝໍ ຫຼື ທ່ານໝໍ.",
    "refreshesIn": "ໂຫຼດໃໝ່ໃນ {{s}} ວິ",
    "nextAppointment": "ນັດໝາຍຕໍ່ໄປ",
    "noAppointment": "ບໍ່ມີນັດໝາຍ",
    "yourTicket": "ບັດຄິວຂອງທ່ານ",
    "position": "ລຳດັບທີ {{n}}",
    "eta": "ປະມານ {{min}} ນາທີ",
    "calledNow": "ເຖິງຄິວທ່ານແລ້ວ — {{counter}}",
    "takeTicket": "ຮັບບັດຄິວ",
    "chooseDepartment": "ເລືອກພະແນກ",
    "waitingCount": "ລໍຖ້າ {{count}} ຄົນ",
    "noTicket": "ມື້ນີ້ບໍ່ມີບັດຄິວ. ຮັບເມື່ອມາຮອດໂຮງໝໍ.",
    "visits": "ການມາກວດ",
    "diagnoses": "ການບົ່ງມະຕິ",
    "prescriptions": "ຢາ",
    "labResults": "ຜົນກວດ",
    "eyeHealth": "ສຸຂະພາບຕາ",
    "treatmentCycles": "ການປິ່ນປົວຂອງຂ້ອຍ",
    "noRecords": "ຍັງບໍ່ມີການມາກວດ",
    "outstanding": "ຕ້ອງຈ່າຍ",
    "pay": "ຈ່າຍ",
    "choosePayment": "ທ່ານຕ້ອງການຈ່າຍແນວໃດ?",
    "method": {
      "QR": "ຈ່າຍດ້ວຍ QR",
      "CARD": "ບັດ",
      "BANK_TRANSFER": "ໂອນເງິນ",
      "MOBILE_MONEY": "ເງິນມືຖື"
    },
    "dummyCheckout": "ການຈ່າຍທົດລອງ — ບໍ່ມີການຕັດເງິນ. ເລືອກຜົນຈາກທະນາຄານເພື່ອຈຳລອງ.",
    "approve": "ຈຳລອງ: ທະນາຄານອະນຸມັດ",
    "decline": "ຈຳລອງ: ທະນາຄານປະຕິເສດ",
    "paymentApproved": "ຈ່າຍເງິນສຳເລັດ. ຂອບໃຈ!",
    "paymentDeclined": "ການຈ່າຍຖືກປະຕິເສດ. ລອງໃໝ່ ຫຼື ຈ່າຍທີ່ແຄຊເຊຍ.",
    "bills": "ໃບບິນ",
    "paymentHistory": "ປະຫວັດການຈ່າຍ",
    "noInvoices": "ບໍ່ມີໃບບິນ",
    "noPayments": "ຍັງບໍ່ມີການຈ່າຍ",
    "balance": "ຍອດຄ້າງ",
    "total": "ລວມ",
    "notifications": "ຂໍ້ຄວາມ",
    "noNotifications": "ບໍ່ມີຂໍ້ຄວາມ",
    "notify": {
      "DIAGNOSIS": "ທ່ານໝໍບັນທຶກການບົ່ງມະຕິ ({{ref}})",
      "QUEUE_CALLED": "ກຳລັງເອີ້ນເລກ {{ref}} ຂອງທ່ານ",
      "EncounterCompleted": "ສະຫຼຸບການມາກວດ {{ref}} ພ້ອມແລ້ວ",
      "PrescriptionIssued": "ໃບສັ່ງຢາໃໝ່ {{ref}}",
      "LabResultVerified": "ຜົນກວດພ້ອມແລ້ວ ({{ref}})",
      "InvoiceCreated": "ໃບບິນໃໝ່ {{ref}}",
      "PaymentCompleted": "ໄດ້ຮັບການຈ່າຍ {{ref}}",
      "EyeExaminationSigned": "ຜົນກວດຕາຂອງທ່ານພ້ອມແລ້ວ",
      "EyeSurgeryScheduled": "ນັດຜ່າຕັດຕາ ({{ref}})",
      "AppointmentBooked": "ນັດໝາຍແລ້ວ ({{ref}})"
    },
    "allergies": "ການແພ້",
    "bloodGroup": "ກຸ່ມເລືອດ",
    "stageNow": "ປັດຈຸບັນ: {{stage}}",
    "instructions": "ສິ່ງທີ່ຕ້ອງເຮັດ",
    "signOut": "ອອກຈາກລະບົບ",
    "settings": "ພາສາ ແລະ ຮູບແບບ",
    "verifiedAccount": "ຢືນຢັນຕົວຕົນແລ້ວ",
    "pendingAccount": "ລໍຖ້າກວດບັດ",
    "patientNumber": "ລະຫັດຄົນເຈັບ",
    "continue": "ສືບຕໍ່",
    "sexAge": "ເພດ · ອາຍຸ",
    "address": "ທີ່ຢູ່",
    "registeredOn": "ລົງທະບຽນທີ່ໂຮງໝໍ",
    "myInformation": "ຂໍ້ມູນຂອງຂ້ອຍ",
    "infoHelp": "ຫາກຕ້ອງການແກ້ໄຂຂໍ້ມູນ, ກະລຸນາແຈ້ງຫ້ອງລົງທະບຽນ.",
    "outcome": {
      "ALREADY_REGISTERED": {
        "title": "ທ່ານລົງທະບຽນແລ້ວ",
        "text": "ເບີໂທ ຫຼື ອີເມວນີ້ມີບັນຊີແລ້ວ ({{mrn}}). ທ່ານໄດ້ເຂົ້າສູ່ລະບົບແລ້ວ."
      },
      "LINKED": {
        "title": "ສ້າງບັນຊີສຳເລັດ",
        "text": "ພົບປະຫວັດຂອງທ່ານໃນໂຮງໝໍ {{mrn}} ແລະ ເຊື່ອມກັບບັນຊີແລ້ວ. ທ່ານສາມາດເບິ່ງການກວດ, ຜົນ ແລະ ໃບບິນໄດ້."
      },
      "CREATED": {
        "title": "ສ້າງບັນຊີສຳເລັດ",
        "text": "ຍິນດີຕ້ອນຮັບ! ລະຫັດຄົນເຈັບໃໝ່ຂອງທ່ານແມ່ນ {{mrn}}."
      },
      "ACTIVATED": {
        "title": "ເປີດໃຊ້ແອັບແລ້ວ",
        "text": "ບັນຊີຂອງທ່ານເຊື່ອມກັບປະຫວັດໂຮງໝໍ {{mrn}} ແລ້ວ."
      }
    },
    "appName": "HMS ຄົນເຈັບ"
  },
  "print": {
    "eyeCenterName": "ສູນປິ່ນປົວ ແລະ ຮັກສາສຸຂະພາບຕາ",
    "eyeRegistration": "ພິມໃບລົງທະບຽນຕາ",
    "patientCode": "ລະຫັດຄົນເຈັບ",
    "queueNo": "ເລກຄິວ",
    "fullName": "ຊື່ ແລະ ນາມສະກຸນ",
    "dateOfBirth": "ວັນເດືອນປີເກີດ",
    "sex": "ເພດ",
    "age": "ອາຍຸ",
    "years": "{{count}} ປີ",
    "occupation": "ອາຊີບ",
    "disability": "ຄົນເຈັບພິການ",
    "village": "ບ້ານ",
    "district": "ເມືອງ",
    "province": "ແຂວງ",
    "phone": "ເບີໂທ",
    "registeredOn": "ວັນທີລົງທະບຽນ",
    "registeredBy": "ຜູ້ລົງທະບຽນ",
    "patientInfo": "ຂໍ້ມູນຄົນເຈັບ",
    "newPatient": "ຄົນເຈັບໃໝ່",
    "returningPatient": "ຄົນເຈັບເກົ່າ",
    "examDetails": "ລາຍລະອຽດການກວດ",
    "titleFemale": "ນ.",
    "titleMale": "ທ.",
    "downloadPdf": "ດາວໂຫຼດ PDF (A4)"
  },
  "reports": {
    "title": "ລາຍງານ",
    "subtitle": "ສ້າງ, ພິມ ແລະ ສົ່ງອອກລາຍງານທັງໝົດຂອງໂຮງໝໍ",
    "catalog": "ລາຍການລາຍງານ",
    "total": "ລວມ",
    "run": "ສ້າງລາຍງານ",
    "exportCsv": "ສົ່ງອອກ CSV",
    "quickRange": "ຊ່ວງເວລາດ່ວນ",
    "thisMonth": "ເດືອນນີ້",
    "lastMonth": "ເດືອນແລ້ວ",
    "thisYear": "ປີນີ້",
    "pickReport": "ເລືອກລາຍງານຈາກລາຍການ",
    "pressRun": "ກຳນົດຊ່ວງເວລາ ແລ້ວກົດ “ສ້າງລາຍງານ”",
    "period": "ໄລຍະ",
    "rows": "ແຖວ",
    "truncated": "ສະແດງພຽງ 5,000 ແຖວທຳອິດ; ກະລຸນາຫຍໍ້ຊ່ວງເວລາ.",
    "printedAt": "ພິມເມື່ອ",
    "noRows": "ບໍ່ມີຂໍ້ມູນໃນຊ່ວງນີ້",
    "category": {
      "PATIENTS": "ຄົນເຈັບ",
      "CLINICAL": "ການປິ່ນປົວ",
      "SERVICES": "ການບໍລິການ",
      "FINANCE": "ການເງິນ",
      "OPERATIONS": "ການດຳເນີນງານ",
      "EYE": "ສູນຕາ",
      "INVENTORY": "ຄັງຢາ ແລະ ວັດສະດຸ",
      "PROCUREMENT": "ການຈັດຊື້",
      "EQUIPMENT": "ອຸປະກອນການແພດ",
      "INPATIENT": "ຄົນເຈັບນອນໂຮງໝໍ",
      "SALES": "ຮ້ານຂາຍຢາ"
    },
    "r": {
      "patients-registered": {
        "title": "ຄົນເຈັບລົງທະບຽນ",
        "desc": "ຄົນເຈັບທີ່ລົງທະບຽນໃນໄລຍະ ພ້ອມທີ່ຢູ່"
      },
      "patients-by-address": {
        "title": "ຄົນເຈັບຕາມທີ່ຢູ່",
        "desc": "ຈຳນວນຄົນເຈັບຕາມແຂວງ ແລະ ເມືອງ"
      },
      "demographics": {
        "title": "ປະຊາກອນ",
        "desc": "ຄົນເຈັບມາກວດ ຕາມກຸ່ມອາຍຸ ແລະ ເພດ"
      },
      "appointments": {
        "title": "ການນັດໝາຍ",
        "desc": "ການນັດໝາຍທັງໝົດໃນໄລຍະ"
      },
      "visits-by-department": {
        "title": "ການມາກວດຕາມພະແນກ",
        "desc": "ການມາກວດປະຈຳວັນ ຕາມພະແນກ ແລະ ປະເພດ"
      },
      "visits": {
        "title": "ທະບຽນການມາກວດ",
        "desc": "ທຸກການມາກວດ ພ້ອມການບົ່ງມະຕິ"
      },
      "morbidity": {
        "title": "ພະຍາດ (ICD-10)",
        "desc": "ກໍລະນີບົ່ງມະຕິ ຕາມລະຫັດ, ເພດ ແລະ ກຸ່ມອາຍຸ"
      },
      "medications": {
        "title": "ການໃຊ້ຢາ",
        "desc": "ຈຳນວນຢາທີ່ສັ່ງ ແລະ ຈ່າຍ"
      },
      "laboratory": {
        "title": "ວຽກຫ້ອງວິເຄາະ",
        "desc": "ການກວດທີ່ສັ່ງ, ຢືນຢັນ ແລະ ຜິດປົກກະຕິ"
      },
      "revenue-daily": {
        "title": "ລາຍຮັບປະຈຳວັນ",
        "desc": "ຍອດອອກໃບແຈ້ງໜີ້, ສ່ວນຫຼຸດ ແລະ ເກັບໄດ້ ຕໍ່ວັນ"
      },
      "revenue-by-service": {
        "title": "ລາຍຮັບຕາມການບໍລິການ",
        "desc": "ຍອດເງິນຕາມປະເພດການບໍລິການ"
      },
      "payments": {
        "title": "ການຮັບເງິນ",
        "desc": "ທຸກການຊຳລະ ພ້ອມວິທີ ແລະ ຜູ້ຮັບເງິນ"
      },
      "outstanding": {
        "title": "ໜີ້ຄ້າງຊຳລະ",
        "desc": "ໃບແຈ້ງໜີ້ທີ່ຍັງບໍ່ຈ່າຍ ພ້ອມອາຍຸໜີ້"
      },
      "queue-performance": {
        "title": "ປະສິດທິພາບຄິວ",
        "desc": "ບັດຄິວ, ເວລາລໍຖ້າ ແລະ ເວລາບໍລິການ"
      },
      "care-plans": {
        "title": "ຮອບການປິ່ນປົວ",
        "desc": "ຄົນເຈັບຕາມແຜນ ແລະ ຂັ້ນຕອນ"
      },
      "patient-app": {
        "title": "ການໃຊ້ແອັບຄົນເຈັບ",
        "desc": "ບັນຊີ, ການເປີດໃຊ້, ບັດຄິວ ແລະ ການຊຳລະ"
      },
      "staff-activity": {
        "title": "ການເຄື່ອນໄຫວຂອງພະນັກງານ",
        "desc": "ການກະທຳທີ່ບັນທຶກ ຕໍ່ພະນັກງານ"
      },
      "eye-exams": {
        "title": "ການກວດຕາ",
        "desc": "ການກວດ ພ້ອມ VA, IOP ແລະ ການບົ່ງມະຕິ"
      },
      "eye-surgeries": {
        "title": "ການຜ່າຕັດຕາ",
        "desc": "ການຜ່າຕັດ ພ້ອມໝໍຜ່າ, IOL ແລະ ຜົນ"
      },
      "eye-injections": {
        "title": "ການສັກຢາເຂົ້າຕາ",
        "desc": "ການສັກ ພ້ອມຢາ ແລະ ເລກລັອດ"
      },
      "eye-high-iop": {
        "title": "ຄວາມດັນຕາສູງ",
        "desc": "IOP ລ່າສຸດ ສູງກວ່າ 21 mmHg"
      },
      "eye-follow-ups": {
        "title": "ການນັດຕິດຕາມຕາ",
        "desc": "ການນັດກວດຄືນ ແລະ ທີ່ເລີຍກຳນົດ"
      },
      "inventory-stock": {
        "title": "ສິນຄ້າຄົງຄັງ",
        "desc": "ຈຳນວນ, ຕົ້ນທຶນ ແລະ ມູນຄ່າ ຕາມລາຍການ ແລະ ຄັງ"
      },
      "inventory-low-stock": {
        "title": "ສິນຄ້າໃກ້ໝົດ ແລະ ການສັ່ງຊື້ຄືນ",
        "desc": "ລາຍການທີ່ຫຼຸດເຖິງລະດັບສັ່ງຄືນ ພ້ອມຈຳນວນແນະນຳ"
      },
      "inventory-expiry": {
        "title": "ລາຍງານວັນໝົດອາຍຸ",
        "desc": "ລັອດທີ່ໝົດອາຍຸ ຫຼື ຈະໝົດອາຍຸຮອດວັນສິ້ນສຸດ"
      },
      "inventory-movements": {
        "title": "ບັນຊີເຄື່ອນໄຫວສິນຄ້າ",
        "desc": "ທຸກການເຄື່ອນໄຫວສິນຄ້າໃນໄລຍະ"
      },
      "inventory-consumption": {
        "title": "ການໃຊ້ຕາມລາຍການ",
        "desc": "ຈຳນວນທີ່ຈ່າຍ ແລະ ເບີກ, ມູນຄ່າ ແລະ ພໍໃຊ້ຈັກມື້"
      },
      "inventory-consumption-department": {
        "title": "ການໃຊ້ຕາມພະແນກ",
        "desc": "ມູນຄ່າທີ່ໃຊ້ຕາມໃບສັ່ງຢາ ແລະ ແຕ່ລະພະແນກ"
      },
      "inventory-valuation": {
        "title": "ການປະເມີນມູນຄ່າສິນຄ້າ",
        "desc": "ມູນຄ່າສິນຄ້າຕາມປະເພດ ແລະ ໝວດ"
      },
      "inventory-adjustments": {
        "title": "ການປັບປຸງ ແລະ ຕັດຈຳໜ່າຍ",
        "desc": "ຍອດຍົກມາ, ການແກ້ໄຂ, ຕັດຈຳໜ່າຍ ແລະ ສົ່ງຄືນ"
      },
      "inventory-abc": {
        "title": "ການວິເຄາະ ABC",
        "desc": "ລາຍການຈັດລຳດັບຕາມມູນຄ່າການໃຊ້ (A = 80% ທຳອິດ)"
      },
      "purchase-requests": {
        "title": "ໃບສະເໜີຊື້",
        "desc": "ໃບສະເໜີທີ່ສ້າງໃນໄລຍະ ພ້ອມສະຖານະ ແລະ ມູນຄ່າ"
      },
      "purchase-orders": {
        "title": "ໃບສັ່ງຊື້",
        "desc": "ໃບສັ່ງຊື້ໃນໄລຍະ, ມູນຄ່າທີ່ຮັບ ແລະ ຄ້າງຮັບ"
      },
      "goods-receipts": {
        "title": "ການຮັບສິນຄ້າ",
        "desc": "ທຸກລາຍການທີ່ຮັບ ພ້ອມລັອດ, ວັນໝົດອາຍຸ ແລະ ຕົ້ນທຶນ"
      },
      "supplier-performance": {
        "title": "ຜົນງານຜູ້ສະໜອງ",
        "desc": "ມູນຄ່າສັ່ງຊື້, ການສົ່ງທັນເວລາ ແລະ ໄລຍະສົ່ງ ຕາມຜູ້ສະໜອງ"
      },
      "equipment-register": {
        "title": "ທະບຽນອຸປະກອນ",
        "desc": "ອຸປະກອນການແພດທັງໝົດ ພ້ອມສະຖານທີ່, ການຮັບປະກັນ ແລະ ການບຳລຸງຮັກສາ"
      },
      "equipment-maintenance": {
        "title": "ບັນທຶກການບຳລຸງຮັກສາ",
        "desc": "ການບຳລຸງຮັກສາ, ປັບທຽບ ແລະ ສ້ອມແປງ ໃນໄລຍະ"
      },
      "equipment-due": {
        "title": "ອຸປະກອນຮອດກຳນົດບຳລຸງຮັກສາ",
        "desc": "ອຸປະກອນທີ່ຮອດ ຫຼື ເລີຍກຳນົດບຳລຸງຮັກສາ ຮອດວັນສິ້ນສຸດ"
      },
      "ipd-census": {
        "title": "ຄົນເຈັບທີ່ນອນຢູ່ປັດຈຸບັນ",
        "desc": "ຄົນເຈັບທີ່ນອນໂຮງໝໍທຸກຄົນ ພ້ອມຕຽງ, ຈຳນວນວັນ ແລະ ວັນຄາດອອກ"
      },
      "ipd-admissions": {
        "title": "ການເຂົ້ານອນໂຮງໝໍ",
        "desc": "ການເຂົ້ານອນໃນຊ່ວງເວລາ ພ້ອມປະເພດ, ຫວອດ ແລະ ຜົນ"
      },
      "ipd-discharges": {
        "title": "ການອອກໂຮງໝໍ",
        "desc": "ຄົນເຈັບທີ່ອອກໂຮງໝໍໃນຊ່ວງເວລາ, ຈຳນວນວັນນອນ ແລະ ນັດກວດຄືນ"
      },
      "ipd-occupancy": {
        "title": "ອັດຕາການໃຊ້ຕຽງ",
        "desc": "ຕຽງຕໍ່ຫວອດ, ວັນນອນທີ່ໃຊ້ ແລະ ອັດຕາການໃຊ້ຕຽງ"
      },
      "ipd-length-of-stay": {
        "title": "ຈຳນວນວັນນອນ",
        "desc": "ວັນນອນສະເລ່ຍ, ສັ້ນສຸດ ແລະ ຍາວສຸດຕໍ່ຫວອດ ແລະ ການອອກໂຮງໝໍ"
      },
      "special-services": {
        "title": "ບໍລິການພິເສດ",
        "desc": "ທຸກເອັກສະເຣ, ອັລຕຣາຊາວ, ຄື້ນໄຟຟ້າຫົວໃຈ ... ທີ່ສັ່ງ ພ້ອມສະຖານະ ແລະ ເວລາອອກຜົນ"
      },
      "special-services-summary": {
        "title": "ບໍລິການພິເສດຕາມປະເພດ",
        "desc": "ຈຳນວນສັ່ງ, ສຳເລັດ, ຄ້າງ ແລະ ລາຍຮັບຕໍ່ບໍລິການ"
      },
      "sales-daily": {
        "title": "ການຂາຍໜ້າຮ້ານລາຍວັນ",
        "desc": "ຍອດຂາຍ, ສ່ວນຫຼຸດ, ເງິນຄືນ, ເງິນສົດ ແລະ ກຳໄລຕໍ່ວັນ"
      },
      "sales-items": {
        "title": "ສິນຄ້າຂາຍດີ",
        "desc": "ຈຳນວນຂາຍ, ສົ່ງຄືນ, ລາຍຮັບ, ຕົ້ນທຶນ ແລະ ກຳໄລຕໍ່ລາຍການ"
      },
      "sales-transactions": {
        "title": "ໃບບິນຂາຍ",
        "desc": "ທຸກການຂາຍໜ້າຮ້ານ ພ້ອມພະນັກງານ, ການຊຳລະ ແລະ ການສົ່ງຄືນ"
      },
      "finance-profit-loss": {
        "title": "ກຳໄລ ແລະ ຂາດທຶນ",
        "desc": "ລາຍຮັບ, ຕົ້ນທຶນສິນຄ້າ, ລາຍຈ່າຍ ແລະ ກຳໄລສຸດທິ"
      },
      "finance-revenue-sources": {
        "title": "ລາຍຮັບຕາມແຫຼ່ງ",
        "desc": "ບິນຕາມພະແນກ ແລະ ການຂາຍໜ້າຮ້ານ"
      },
      "finance-discounts": {
        "title": "ສ່ວນຫຼຸດທີ່ໃຫ້",
        "desc": "ທຸກສ່ວນຫຼຸດໃນບິນ ແລະ ທີ່ຮ້ານ ພ້ອມເຫດຜົນ"
      },
      "finance-expenses": {
        "title": "ລາຍຈ່າຍ",
        "desc": "ລາຍຈ່າຍ ພ້ອມຜູ້ບັນທຶກ ແລະ ຜູ້ອະນຸມັດ"
      },
      "finance-cash-sessions": {
        "title": "ລິ້ນຊັກເງິນ",
        "desc": "ເງິນສົດທີ່ຄວນມີ ແລະ ນັບໄດ້, ສ່ວນຕ່າງ ແລະ ການກວດ"
      },
      "finance-price-list": {
        "title": "ລາຍການລາຄາ",
        "desc": "ທຸກຄ່າທຳນຽມ, ຢາ, ການກວດ, ບໍລິການ, ຄ່າຕຽງ ແລະ ສິນຄ້າ"
      },
      "finance-price-changes": {
        "title": "ການປ່ຽນລາຄາ",
        "desc": "ລາຄາເກົ່າ ແລະ ໃໝ່, ເຫດຜົນ ແລະ ຜູ້ປ່ຽນ"
      },
      "stock-documents": {
        "title": "ເອກະສານສາງ",
        "desc": "ຮັບເຂົ້າ, ເບີກອອກ ແລະ ໂອນຍ້າຍ ພ້ອມຜູ້ສ້າງ ແລະ ຜູ້ກວດ"
      },
      "morbidity-by-type": {
        "title": "ອັດຕາການເປັນພະຍາດຕາມປະເພດ",
        "desc": "ກໍລະນີທີ່ບົ່ງມະຕິ ຈັດກຸ່ມຕາມປະເພດພະຍາດ ພ້ອມກໍລະນີທີ່ຕ້ອງລາຍງານ, ເພດ ແລະ ກຸ່ມອາຍຸ"
      }
    },
    "col": {
      "abnormal": "ຜິດປົກກະຕິ",
      "abnormalRate": "% ຜິດປົກກະຕິ",
      "actions": "ການກະທຳ",
      "activationCodes": "ລະຫັດເປີດໃຊ້",
      "activePatients": "ຄົນເຈັບທີ່ກຳລັງປິ່ນປົວ",
      "administeredBy": "ຜູ້ສັກ",
      "age": "ອາຍຸ",
      "age15to49": "15–49",
      "age50plus": "50+",
      "age5to14": "5–14",
      "ageGroup": "ກຸ່ມອາຍຸ",
      "ageing": "ອາຍຸໜີ້",
      "amount": "ຈຳນວນເງິນ",
      "appPaid": "ຈ່າຍຜ່ານແອັບ",
      "appPayments": "ການຊຳລະຜ່ານແອັບ",
      "appTickets": "ບັດຄິວຈາກແອັບ",
      "appointmentNumber": "ເລກນັດໝາຍ",
      "avgServiceMinutes": "ເວລາບໍລິການສະເລ່ຍ (ນາທີ)",
      "avgTurnaroundMinutes": "ເວລາອອກຜົນສະເລ່ຍ (ນາທີ)",
      "avgWaitMinutes": "ເວລາລໍຖ້າສະເລ່ຍ (ນາທີ)",
      "balance": "ຍອດຄົງເຫຼືອ",
      "caseNumber": "ເລກກໍລະນີ",
      "cases": "ກໍລະນີ",
      "category": "ປະເພດ",
      "code": "ລະຫັດ",
      "collected": "ເກັບໄດ້",
      "completedInRange": "ສຳເລັດ",
      "complications": "ອາການແຊກຊ້ອນ",
      "creates": "ສ້າງ",
      "date": "ວັນທີ",
      "dateOfBirth": "ວັນເກີດ",
      "daysOverdue": "ມື້ເລີຍກຳນົດ",
      "department": "ພະແນກ",
      "diagnoses": "ການບົ່ງມະຕິ",
      "diagnosis": "ການບົ່ງມະຕິ",
      "discount": "ສ່ວນຫຼຸດ",
      "district": "ເມືອງ",
      "doctor": "ທ່ານໝໍ",
      "emergency": "ສຸກເສີນ",
      "encounterNumber": "ເລກການມາກວດ",
      "examinedBy": "ຜູ້ກວດ",
      "eye": "ຕາ",
      "female": "ຍິງ",
      "form": "ຮູບແບບ",
      "fromApp": "ຈາກແອັບ",
      "gross": "ລວມກ່ອນຫຼຸດ",
      "indication": "ຂໍ້ບົ່ງຊີ້",
      "invoiceNumber": "ເລກໃບແຈ້ງໜີ້",
      "invoices": "ໃບແຈ້ງໜີ້",
      "iol": "IOL",
      "iop": "IOP (mmHg)",
      "iopOd": "IOP OD",
      "iopOs": "IOP OS",
      "issuedAt": "ວັນທີອອກ",
      "lastActivity": "ເຄື່ອນໄຫວລ່າສຸດ",
      "lines": "ລາຍການ",
      "lotNumber": "ເລກລັອດ",
      "male": "ຊາຍ",
      "maxWaitMinutes": "ລໍຖ້າສູງສຸດ (ນາທີ)",
      "measuredAt": "ວັນທີວັດ",
      "medication": "ຢາ",
      "method": "ວິທີຊຳລະ",
      "mrn": "ລະຫັດຄົນເຈັບ",
      "net": "ສຸດທິ",
      "newAccounts": "ບັນຊີໃໝ່",
      "newInRange": "ໃໝ່ໃນໄລຍະ",
      "newPatients": "ຄົນເຈັບໃໝ່",
      "nextFollowUp": "ນັດຄັ້ງຕໍ່ໄປ",
      "opd": "ຄົນເຈັບນອກ",
      "ordered": "ສັ່ງ",
      "other": "ອື່ນໆ",
      "outstanding": "ຄ້າງຊຳລະ",
      "overdueReviews": "ເລີຍນັດ",
      "paidAt": "ເວລາຊຳລະ",
      "pathway": "ແຜນການປິ່ນປົວ",
      "patientName": "ຄົນເຈັບ",
      "patients": "ຄົນເຈັບ",
      "paymentNumber": "ເລກໃບຮັບເງິນ",
      "phone": "ເບີໂທ",
      "postOpVa": "VA ຫຼັງຜ່າ",
      "practitioner": "ທ່ານໝໍ",
      "prescriptions": "ໃບສັ່ງຢາ",
      "procedureName": "ການຜ່າຕັດ",
      "province": "ແຂວງ",
      "quantity": "ຈຳນວນ",
      "quantityDispensed": "ຈ່າຍແລ້ວ",
      "quantityPrescribed": "ສັ່ງ",
      "reason": "ເຫດຜົນ",
      "receivedBy": "ຜູ້ຮັບເງິນ",
      "registeredAt": "ວັນທີລົງທະບຽນ",
      "registeredBy": "ຜູ້ລົງທະບຽນ",
      "scheduledStart": "ເວລານັດ",
      "selfRegistered": "ລົງທະບຽນເອງ",
      "served": "ບໍລິການແລ້ວ",
      "sex": "ເພດ",
      "share": "ສັດສ່ວນ",
      "signatures": "ລາຍເຊັນ",
      "skipped": "ຂ້າມ",
      "staff": "ພະນັກງານ",
      "stage": "ຂັ້ນຕອນ",
      "startedAt": "ເລີ່ມ",
      "startedInRange": "ເລີ່ມໃນໄລຍະ",
      "status": "ສະຖານະ",
      "surgeon": "ໝໍຜ່າຕັດ",
      "test": "ການກວດ",
      "tickets": "ບັດຄິວ",
      "total": "ລວມ",
      "type": "ປະເພດ",
      "under5": "ຕ່ຳກວ່າ 5",
      "updates": "ແກ້ໄຂ",
      "vaOd": "VA OD",
      "vaOs": "VA OS",
      "value": "ມູນຄ່າ",
      "verified": "ຢືນຢັນແລ້ວ",
      "views": "ເບິ່ງ",
      "village": "ບ້ານ",
      "itemCode": "ລະຫັດ",
      "item": "ລາຍການ",
      "itemType": "ປະເພດ",
      "store": "ຄັງ",
      "unit": "ຫົວໜ່ວຍ",
      "onHand": "ມີໃນຄັງ",
      "usable": "ໃຊ້ໄດ້",
      "unitCost": "ລາຄາ/ຫົວໜ່ວຍ",
      "stockValue": "ມູນຄ່າ",
      "reorderLevel": "ລະດັບສັ່ງຄືນ",
      "nextExpiry": "ໝົດອາຍຸໄວສຸດ",
      "onOrder": "ກຳລັງສັ່ງ",
      "avgDailyUse": "ສະເລ່ຍ/ມື້",
      "daysOfCover": "ພໍໃຊ້ (ມື້)",
      "suggestedQuantity": "ແນະນຳໃຫ້ສັ່ງ",
      "estimatedCost": "ຄ່າໃຊ້ຈ່າຍຄາດຄະເນ",
      "expiryDate": "ວັນໝົດອາຍຸ",
      "daysLeft": "ເຫຼືອ (ມື້)",
      "expiryStatus": "ສະຖານະ",
      "performedAt": "ວັນທີ / ເວລາ",
      "movementType": "ການເຄື່ອນໄຫວ",
      "balanceAfter": "ຄົງເຫຼືອ",
      "reference": "ອ້າງອີງ",
      "performedBy": "ໂດຍ",
      "dispensed": "ຈ່າຍຕາມໃບສັ່ງ",
      "issued": "ເບີກໃຫ້ພະແນກ",
      "totalUsed": "ໃຊ້ທັງໝົດ",
      "items": "ລາຍການ",
      "expiredValue": "ມູນຄ່າໝົດອາຍຸ",
      "abcClass": "ກຸ່ມ ABC",
      "cumulativeShare": "ສັດສ່ວນສະສົມ",
      "prNumber": "ເລກທີ PR",
      "createdAt": "ວັນທີສ້າງ",
      "requestedBy": "ຜູ້ສະເໜີ",
      "priority": "ຄວາມຮີບດ່ວນ",
      "estimatedTotal": "ມູນຄ່າຄາດຄະເນ",
      "decidedBy": "ຜູ້ພິຈາລະນາ",
      "decidedAt": "ວັນທີພິຈາລະນາ",
      "orders": "ໃບສັ່ງຊື້",
      "poNumber": "ເລກທີ PO",
      "orderDate": "ວັນທີສັ່ງ",
      "supplier": "ຜູ້ສະໜອງ",
      "expectedDate": "ກຳນົດສົ່ງ",
      "receivedValue": "ມູນຄ່າທີ່ຮັບ",
      "outstandingValue": "ມູນຄ່າຄ້າງຮັບ",
      "approvedBy": "ຜູ້ອະນຸມັດ",
      "receivedAt": "ວັນທີຮັບ",
      "grnNumber": "ເລກທີໃບຮັບສິນຄ້າ",
      "orderedValue": "ມູນຄ່າສັ່ງຊື້",
      "onTimeRate": "ສົ່ງທັນກຳນົດ",
      "avgLeadDays": "ໄລຍະສົ່ງສະເລ່ຍ (ມື້)",
      "lateOrders": "ສົ່ງຊ້າ",
      "assetTag": "ເລກຊັບສິນ",
      "serialNumber": "ເລກເຄື່ອງ",
      "model": "ລຸ້ນ",
      "location": "ສະຖານທີ່",
      "purchaseDate": "ວັນທີຊື້",
      "purchaseCost": "ລາຄາຊື້",
      "warrantyExpiry": "ຮັບປະກັນຮອດ",
      "nextMaintenance": "ບຳລຸງຮັກສາຄັ້ງຕໍ່ໄປ",
      "maintenanceStatus": "ການບຳລຸງຮັກສາ",
      "eventType": "ປະເພດ",
      "cost": "ຄ່າໃຊ້ຈ່າຍ",
      "statusAfter": "ສະຖານະຫຼັງ",
      "nextDueDate": "ກຳນົດຕໍ່ໄປ",
      "notes": "ໝາຍເຫດ",
      "dueDate": "ວັນກຳນົດ",
      "admissionNumber": "ເລກທີເຂົ້ານອນ",
      "admissionType": "ປະເພດ",
      "admissions": "ການເຂົ້ານອນ",
      "admittedAt": "ວັນເຂົ້ານອນ",
      "againstAdvice": "ອອກເອງ",
      "attending": "ແພດຜູ້ຮັບຜິດຊອບ",
      "available": "ຫວ່າງ",
      "averageDays": "ວັນສະເລ່ຍ",
      "bed": "ຕຽງ",
      "bedDays": "ວັນນອນ",
      "beds": "ຕຽງ",
      "cancelled": "ຍົກເລີກ",
      "cash": "ເງິນສົດ",
      "cashier": "ພະນັກງານເກັບເງິນ",
      "changeRate": "ປ່ຽນ %",
      "changedAt": "ວັນທີປ່ຽນ",
      "changedBy": "ປ່ຽນໂດຍ",
      "checkedAt": "ວັນທີກວດ",
      "checkedBy": "ກວດໂດຍ",
      "cleaning": "ທຳຄວາມສະອາດ",
      "closedAt": "ວັນທີປິດ",
      "completed": "ສຳເລັດ",
      "countedCash": "ນັບໄດ້",
      "customer": "ລູກຄ້າ",
      "days": "ວັນ",
      "deceased": "ເສຍຊີວິດ",
      "description": "ລາຍລະອຽດ",
      "destination": "ໄປຫາ",
      "dischargeType": "ອອກໄປ",
      "dischargedAt": "ວັນອອກ",
      "dischargedBy": "ອອກໂດຍ",
      "discharges": "ການອອກໂຮງໝໍ",
      "discountType": "ຫຼຸດເປັນ",
      "discountValue": "ຄ່າ",
      "docNumber": "ເລກທີເອກະສານ",
      "docType": "ປະເພດ",
      "entityType": "ປະເພດ",
      "expectedCash": "ຄວນມີ",
      "expectedDischarge": "ຄາດອອກ",
      "expenseDate": "ວັນທີ",
      "expenseNumber": "ເລກທີລາຍຈ່າຍ",
      "followUpDate": "ນັດກວດຄືນ",
      "home": "ກັບບ້ານ",
      "line": "ລາຍການ",
      "margin": "ກຳໄລ",
      "marginRate": "ກຳໄລ %",
      "maxDays": "ຍາວສຸດ",
      "minDays": "ສັ້ນສຸດ",
      "name": "ຊື່",
      "newPrice": "ລາຄາໃໝ່",
      "nonCash": "ບໍ່ແມ່ນເງິນສົດ",
      "occupancyRate": "ການໃຊ້ຕຽງ %",
      "occupied": "ມີຄົນເຈັບ",
      "oldPrice": "ລາຄາເກົ່າ",
      "openedAt": "ວັນທີເປີດ",
      "openingFloat": "ເງິນເລີ່ມຕົ້ນ",
      "orderNumber": "ເລກທີຄຳສັ່ງ",
      "orderedAt": "ວັນທີສັ່ງ",
      "outOfService": "ບໍ່ພ້ອມໃຊ້",
      "payee": "ຈ່າຍໃຫ້",
      "paymentMethod": "ການຊຳລະ",
      "pending": "ຄ້າງ",
      "preparedBy": "ຜູ້ສ້າງ",
      "price": "ລາຄາ",
      "recordedBy": "ບັນທຶກໂດຍ",
      "referred": "ສົ່ງຕໍ່",
      "refunded": "ຄືນເງິນ",
      "refunds": "ເງິນຄືນ",
      "reportedBy": "ລາຍງານໂດຍ",
      "returned": "ສົ່ງຄືນ",
      "revenue": "ລາຍຮັບ",
      "saleNumber": "ເລກທີບິນ",
      "sales": "ການຂາຍ",
      "section": "ພາກ",
      "service": "ບໍລິການ",
      "sessionNumber": "ລິ້ນຊັກ",
      "sold": "ຂາຍ",
      "soldAt": "ເວລາຂາຍ",
      "source": "ແຫຼ່ງ",
      "turnaroundMinutes": "ເວລາອອກຜົນ (ນາທີ)",
      "variance": "ສ່ວນຕ່າງ",
      "verifiedBy": "ຢັ້ງຢືນໂດຍ",
      "ward": "ຫວອດ",
      "diseaseType": "ປະເພດພະຍາດ",
      "notifiableCases": "ກໍລະນີຕ້ອງລາຍງານ"
    },
    "from": "ຈາກ",
    "to": "ເຖິງ"
  },
  "locations": {
    "title": "ສະຖານທີ່",
    "subtitle": "ແຂວງ, ເມືອງ, ກຸ່ມບ້ານ ແລະ ບ້ານ ຂອງ ສປປ ລາວ",
    "counts": "{{provinces}} ແຂວງ · {{districts}} ເມືອງ · {{villages}} ບ້ານ",
    "pickDistrict": "ເລືອກເມືອງ ເພື່ອຈັດການກຸ່ມບ້ານ ແລະ ບ້ານ",
    "addSubdistrict": "ເພີ່ມກຸ່ມບ້ານ",
    "editSubdistrict": "ແກ້ໄຂກຸ່ມບ້ານ",
    "noSubdistricts": "ຍັງບໍ່ມີກຸ່ມບ້ານ. ເພີ່ມ ແລ້ວມອບບ້ານໃຫ້.",
    "villageCount": "{{count}} ບ້ານ",
    "assignVillages": "ມອບບ້ານ",
    "searchVillage": "ຊອກຫາບ້ານ",
    "nameLa": "ຊື່ (ລາວ)",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "inOtherSubdistrict": "ຢູ່ໃນ {{name}}"
  },
  "inventory": {
    "title": "ຄັງຢາ, ຮ້ານຢາ ແລະ ອຸປະກອນການແພດ",
    "subtitle": "ສິນຄ້າໃນຄັງ, ລັອດ ແລະ ວັນໝົດອາຍຸ, ໃບສະເໜີຊື້ ແລະ ໃບສັ່ງຊື້, ຜູ້ສະໜອງ ແລະ ອຸປະກອນການແພດ",
    "item": "ລາຍການ",
    "items": "ລາຍການ",
    "name": "ຊື່",
    "itemType": "ປະເພດ",
    "category": "ໝວດ",
    "unit": "ຫົວໜ່ວຍ",
    "manufacturer": "ຜູ້ຜະລິດ",
    "unitCost": "ລາຄາຕົ້ນທຶນ/ຫົວໜ່ວຍ",
    "unitCostShort": "ຕົ້ນທຶນ {{value}} / ຫົວໜ່ວຍ",
    "reorderLevel": "ລະດັບສັ່ງຊື້ຄືນ",
    "reorderLevelHint": "ແຈ້ງເຕືອນ ແລະ ແນະນຳໃຫ້ສັ່ງຊື້ ເມື່ອສິນຄ້າທີ່ໃຊ້ໄດ້ຫຼຸດລົງເຖິງລະດັບນີ້",
    "reorderQuantity": "ຈຳນວນສັ່ງຊື້ຄືນ",
    "maxLevel": "ລະດັບສູງສຸດ",
    "maxLevelHint": "ເກີນລະດັບນີ້ຖືວ່າມີສິນຄ້າຫຼາຍເກີນ",
    "maxShort": "ສູງສຸດ {{value}}",
    "trackExpiry": "ຕິດຕາມລັອດ ແລະ ວັນໝົດອາຍຸ",
    "controlled": "ຢາຄວບຄຸມພິເສດ",
    "controlledShort": "ຄວບຄຸມ",
    "storageCondition": "ເງື່ອນໄຂການເກັບຮັກສາ",
    "linkMedication": "ຢາ (ລາຍການຢາຂອງຮ້ານຢາ)",
    "linkMedicationHint": "ຢາທີ່ເຊື່ອມໄວ້ຈະຖືກຕັດອອກຈາກຄັງເມື່ອຈ່າຍຢາຕາມໃບສັ່ງ",
    "noMedicationLink": "ບໍ່ເຊື່ອມ (ບໍ່ຈ່າຍຕາມໃບສັ່ງຢາ)",
    "fromMedication": "ເອົາຈາກຂໍ້ມູນຢາ",
    "newItem": "ເພີ່ມລາຍການ",
    "editItem": "ແກ້ໄຂລາຍການ",
    "searchItem": "ຄົ້ນຫາຢາ, ວັດສະດຸ ຫຼື ອຸປະກອນ…",
    "noItems": "ບໍ່ພົບລາຍການ",
    "usable": "ສິນຄ້າທີ່ໃຊ້ໄດ້",
    "onHand": "ມີໃນຄັງ",
    "onOrder": "ກຳລັງສັ່ງຊື້",
    "stockValue": "ມູນຄ່າສິນຄ້າ",
    "stockStatus": "ສະຖານະສິນຄ້າ",
    "daysOfCover": "ພໍໃຊ້ (ມື້)",
    "days": "{{count}} ມື້",
    "daysLeft": "ເຫຼືອ {{count}} ມື້",
    "expiredAgo": "ໝົດອາຍຸແລ້ວ {{count}} ມື້",
    "overdueDays": "ເລີຍກຳນົດ {{count}} ມື້",
    "nextExpiry": "ໝົດອາຍຸໄວສຸດ",
    "assetsCount": "{{count}} ເຄື່ອງ",
    "allStores": "ທຸກຄັງ",
    "allSuppliers": "ທຸກຜູ້ສະໜອງ",
    "store": "ຄັງ",
    "storeType": "ປະເພດຄັງ",
    "newStore": "ເພີ່ມຄັງ",
    "editStore": "ແກ້ໄຂຄັງ",
    "dispensing": "ຈ່າຍຢາ",
    "dispensingStore": "ຈ່າຍຢາຕາມໃບສັ່ງຈາກຄັງນີ້",
    "dispensingStoreHint": "ສິນຄ້າຂອງຢາທີ່ເຊື່ອມໄວ້ຈະຖືກຫຼຸດຈາກຄັງນີ້ເມື່ອຮ້ານຢາຈ່າຍຢາ.",
    "fromStore": "ຈາກຄັງ",
    "toStore": "ໄປຄັງ",
    "toDepartment": "ໃຫ້ພະແນກ",
    "department": "ພະແນກ",
    "deliverTo": "ສົ່ງເຖິງ",
    "supplier": "ຜູ້ສະໜອງ",
    "newSupplier": "ເພີ່ມຜູ້ສະໜອງ",
    "editSupplier": "ແກ້ໄຂຜູ້ສະໜອງ",
    "noSuppliers": "ຍັງບໍ່ມີຜູ້ສະໜອງ",
    "contact": "ຕິດຕໍ່",
    "contactPerson": "ຜູ້ຕິດຕໍ່",
    "phone": "ເບີໂທ",
    "email": "ອີເມວ",
    "address": "ທີ່ຢູ່",
    "taxId": "ເລກປະຈຳຕົວຜູ້ເສຍອາກອນ",
    "paymentTerms": "ເງື່ອນໄຂການຊຳລະ",
    "leadTimeDays": "ໄລຍະສົ່ງ (ມື້)",
    "leadDays": "ສົ່ງພາຍໃນ {{count}} ມື້",
    "orders": "ໃບສັ່ງຊື້",
    "receivedValueShort": "ມູນຄ່າທີ່ຮັບແລ້ວ",
    "lots": "ລັອດ",
    "lotNumber": "ເລກລັອດ",
    "expiryDate": "ວັນໝົດອາຍຸ",
    "noLots": "ບໍ່ມີລັອດສິນຄ້າ",
    "lotsAndExpiry": "ລັອດ ແລະ ວັນໝົດອາຍຸ",
    "ledger": "ບັນຊີເຄື່ອນໄຫວສິນຄ້າ",
    "allLots": "ທຸກລັອດ",
    "expiredOnly": "ໝົດອາຍຸແລ້ວ",
    "within": "≤ {{count}} ມື້",
    "lotsTotal": "{{count}} ລັອດ · {{value}}",
    "lotsCount": "{{count}} ລັອດ",
    "lotSummary": "ລັອດ {{lot}} ໃນ {{store}}: {{quantity}}",
    "receivedAt": "ວັນທີຮັບ",
    "movementType": "ການເຄື່ອນໄຫວ",
    "quantity": "ຈຳນວນ",
    "balanceAfter": "ຍອດຄົງເຫຼືອ",
    "reference": "ອ້າງອີງ",
    "performedAt": "ວັນທີ / ເວລາ",
    "performedBy": "ໂດຍ",
    "noMovements": "ບໍ່ມີການເຄື່ອນໄຫວສິນຄ້າ",
    "recentMovements": "ການເຄື່ອນໄຫວລ່າສຸດ",
    "clearItemFilter": "ສະແດງທຸກລາຍການ",
    "byStore": "ສິນຄ້າຕາມຄັງ",
    "usageByMonth": "ຮັບເຂົ້າ ແລະ ໃຊ້ອອກ ຕໍ່ເດືອນ",
    "avgDailyUse": "ໃຊ້ສະເລ່ຍຕໍ່ມື້",
    "coverDays": "ພໍໃຊ້ປະມານ {{count}} ມື້",
    "noUse": "ບໍ່ມີການໃຊ້ໃນ 90 ມື້ຜ່ານມາ",
    "expiredQty": "ສິນຄ້າໝົດອາຍຸ",
    "equipmentHint": "ອຸປະກອນຖືກຕິດຕາມເປັນລາຍເຄື່ອງ (ລົງທະບຽນ {{count}} ເຄື່ອງ).",
    "openEquipment": "ເປີດທະບຽນອຸປະກອນ",
    "addStock": "ເພີ່ມສິນຄ້າເຂົ້າຄັງ",
    "stockAdded": "ເພີ່ມສິນຄ້າແລ້ວ",
    "adjustmentType": "ປະເພດ",
    "reason": "ເຫດຜົນ",
    "removeFromLot": "ຕັດອອກ",
    "stockRemoved": "ຕັດສິນຄ້າອອກແລ້ວ",
    "issue": "ເບີກຈ່າຍ",
    "issueStock": "ເບີກຈ່າຍໃຫ້ພະແນກ",
    "issued": "ເບີກຈ່າຍແລ້ວ {{number}}",
    "transfer": "ໂອນຍ້າຍ",
    "transferStock": "ໂອນຍ້າຍລະຫວ່າງຄັງ",
    "transferred": "ໂອນຍ້າຍແລ້ວ {{number}}",
    "fefoHint": "ຕັດສິນຄ້າຈາກລັອດທີ່ໝົດອາຍຸກ່ອນ (FEFO).",
    "requestPurchase": "ສະເໜີຊື້",
    "warnings": "ການແຈ້ງເຕືອນ",
    "noWarnings": "ບໍ່ມີການແຈ້ງເຕືອນ — ສິນຄ້າ, ວັນໝົດອາຍຸ ແລະ ອຸປະກອນ ປົກກະຕິ",
    "seeAll": "ເບິ່ງທັງໝົດ",
    "uncategorized": "ບໍ່ມີໝວດ",
    "updatedAt": "ອັບເດດ {{time}}",
    "requestOnlyHint": "ທ່ານສາມາດສ້າງໃບສະເໜີຊື້ໄດ້ທີ່ແຖບ ໃບສະເໜີຊື້.",
    "purchaseRequest": "ໃບສະເໜີຊື້",
    "purchaseOrder": "ໃບສັ່ງຊື້",
    "prNumber": "ເລກທີ PR",
    "poNumber": "ເລກທີ PO",
    "newRequest": "ສ້າງໃບສະເໜີຊື້",
    "editRequest": "ແກ້ໄຂໃບສະເໜີຊື້ {{number}}",
    "newOrder": "ສ້າງໃບສັ່ງຊື້",
    "editOrder": "ແກ້ໄຂໃບສັ່ງຊື້ {{number}}",
    "noRequests": "ບໍ່ມີໃບສະເໜີຊື້",
    "noOrders": "ບໍ່ມີໃບສັ່ງຊື້",
    "mineOnly": "ສະເພາະຂອງຂ້ອຍ",
    "createdAt": "ວັນທີສ້າງ",
    "created": "ສ້າງ",
    "requestedBy": "ຜູ້ສະເໜີ",
    "requestedByOn": "ສະເໜີໂດຍ {{name}} ວັນທີ {{date}}",
    "requestingDepartment": "ພະແນກທີ່ສະເໜີ",
    "priority": "ຄວາມຮີບດ່ວນ",
    "neededBy": "ຕ້ອງການພາຍໃນ",
    "reasonForRequest": "ເຫດຜົນ / ຄວາມຈຳເປັນ",
    "estimatedUnitCost": "ລາຄາຄາດຄະເນ/ຫົວໜ່ວຍ",
    "estimatedTotal": "ມູນຄ່າຄາດຄະເນ",
    "lineTotal": "ລວມ",
    "saveDraft": "ບັນທຶກສະບັບຮ່າງ",
    "saveAndSubmit": "ບັນທຶກ ແລະ ສົ່ງຂໍອະນຸມັດ",
    "submit": "ສົ່ງຂໍອະນຸມັດ",
    "approve": "ອະນຸມັດ",
    "reject": "ປະຕິເສດ",
    "approveRequest": "ອະນຸມັດ {{number}}",
    "rejectRequest": "ປະຕິເສດ {{number}}",
    "approveHint": "ອະນຸມັດຈຳນວນແຕ່ລະລາຍການ; 0 ຄືຕັດລາຍການນັ້ນອອກ.",
    "requested": "ສະເໜີ",
    "approvedQty": "ອະນຸມັດ",
    "decisionNote": "ໝາຍເຫດການພິຈາລະນາ",
    "cancelRequest": "ຍົກເລີກໃບສະເໜີ",
    "cancelRequestConfirm": "ໃບສະເໜີຈະຖືກຍົກເລີກ ແລະ ບໍ່ສາມາດສັ່ງຊື້ໄດ້ອີກ.",
    "selfApprovalHint": "ທ່ານເປັນຜູ້ສະເໜີ, ຈຶ່ງຕ້ອງໃຫ້ຜູ້ອະນຸມັດຄົນອື່ນພິຈາລະນາ.",
    "selfApprovalPoHint": "ທ່ານເປັນຜູ້ກະກຽມໃບສັ່ງຊື້ນີ້, ຈຶ່ງຕ້ອງໃຫ້ຜູ້ອື່ນອະນຸມັດ.",
    "awaitingApproval": "ລໍຖ້າການອະນຸມັດຈາກຜູ້ອະນຸມັດການຈັດຊື້.",
    "prSubmitted": "ສົ່ງໃບສະເໜີຊື້ຂໍອະນຸມັດແລ້ວ",
    "prApproved": "ອະນຸມັດໃບສະເໜີຊື້ແລ້ວ",
    "prRejected": "ປະຕິເສດໃບສະເໜີຊື້ແລ້ວ",
    "prCancelled": "ຍົກເລີກໃບສະເໜີຊື້ແລ້ວ",
    "createPo": "ສ້າງໃບສັ່ງຊື້",
    "poCreated": "ສ້າງໃບສັ່ງຊື້ {{number}} ແລ້ວ",
    "history": "ປະຫວັດ",
    "details": "ລາຍລະອຽດ",
    "reorderSuggestions": "ແນະນຳການສັ່ງຊື້",
    "suggestionsHint": "ລາຍການທີ່ຫຼຸດເຖິງ ຫຼື ຕ່ຳກວ່າລະດັບສັ່ງຊື້ຄືນ (ຫັກຈຳນວນທີ່ກຳລັງສັ່ງແລ້ວ). ຈຳນວນແນະນຳຈະເຕີມໃຫ້ເຖິງລະດັບສູງສຸດ.",
    "noSuggestions": "ຕອນນີ້ບໍ່ມີລາຍການທີ່ຕ້ອງສັ່ງຊື້",
    "createPrFromSelection": "ສ້າງໃບສະເໜີ ({{count}} ລາຍການ)",
    "reorderReason": "ເຕີມສິນຄ້າທີ່ຫຼຸດເຖິງລະດັບສັ່ງຊື້ຄືນ",
    "orderDate": "ວັນທີສັ່ງຊື້",
    "orderedOn": "ສັ່ງວັນທີ {{date}}",
    "expectedDate": "ກຳນົດສົ່ງ",
    "expectedDateHint": "ວ່າງໄວ້: ມື້ນີ້ + ໄລຍະສົ່ງຂອງຜູ້ສະໜອງ",
    "overdue": "ເລີຍກຳນົດ",
    "total": "ລວມ",
    "ordered": "ສັ່ງ",
    "received": "ຮັບແລ້ວ",
    "receivedValue": "ຮັບແລ້ວ {{value}}",
    "outstanding": "ຍັງຄ້າງຮັບ",
    "saveOrder": "ບັນທຶກໃບສັ່ງຊື້",
    "markSent": "ສົ່ງໃຫ້ຜູ້ສະໜອງແລ້ວ",
    "receive": "ຮັບສິນຄ້າ",
    "receiveGoods": "ຮັບສິນຄ້າ — {{number}}",
    "receiveHint": "ໃສ່ຈຳນວນທີ່ໄດ້ຮັບ. ຢາ ແລະ ສິນຄ້າທີ່ມີວັນໝົດອາຍຸ ຕ້ອງມີເລກລັອດ ແລະ ວັນໝົດອາຍຸ; ບໍ່ຮັບສິນຄ້າທີ່ໝົດອາຍຸແລ້ວ.",
    "receiveQty": "ຮັບຄັ້ງນີ້",
    "required": "ຈຳເປັນ",
    "deliveryNote": "ເລກໃບສົ່ງສິນຄ້າ",
    "confirmReceipt": "ຢືນຢັນການຮັບ",
    "goodsReceived": "ຮັບສິນຄ້າເຂົ້າຄັງແລ້ວ",
    "goodsReceipts": "ການຮັບສິນຄ້າ",
    "noReceipts": "ຍັງບໍ່ໄດ້ຮັບສິນຄ້າ",
    "closeShort": "ປິດ (ສ່ວນທີ່ເຫຼືອບໍ່ມາ)",
    "closeShortConfirm": "ໃບສັ່ງຊື້ຈະຖືກປິດຕາມຈຳນວນທີ່ໄດ້ຮັບແລ້ວ.",
    "cancelOrder": "ຍົກເລີກໃບສັ່ງຊື້",
    "poApproved": "ອະນຸມັດໃບສັ່ງຊື້ແລ້ວ",
    "poSent": "ສົ່ງໃບສັ່ງຊື້ແລ້ວ",
    "poCancelled": "ຍົກເລີກໃບສັ່ງຊື້ແລ້ວ",
    "poClosed": "ປິດໃບສັ່ງຊື້ແລ້ວ",
    "preparedBy": "ຜູ້ກະກຽມ",
    "approvedBy": "ຜູ້ອະນຸມັດ",
    "supplierAcknowledgement": "ຜູ້ສະໜອງຮັບຊາບ",
    "description": "ລາຍລະອຽດ",
    "equipment": "ອຸປະກອນ",
    "newAsset": "ລົງທະບຽນອຸປະກອນ",
    "editAsset": "ແກ້ໄຂອຸປະກອນ",
    "noAssets": "ຍັງບໍ່ມີອຸປະກອນທີ່ລົງທະບຽນ",
    "equipmentType": "ປະເພດອຸປະກອນ",
    "equipmentTypeHint": "ລາຍການປະເພດ ອຸປະກອນ (ສ້າງທີ່ແຖບ ລາຍການ ກ່ອນ).",
    "searchEquipment": "ຄົ້ນຫາອຸປະກອນ, ເລກຊັບສິນ, ເລກເຄື່ອງ ຫຼື ສະຖານທີ່…",
    "assetTag": "ເລກຊັບສິນ",
    "assetTagHint": "ວ່າງໄວ້: ອອກເລກອັດຕະໂນມັດ",
    "serialNumber": "ເລກເຄື່ອງ",
    "model": "ລຸ້ນ",
    "location": "ສະຖານທີ່",
    "purchaseDate": "ວັນທີຊື້",
    "purchaseCost": "ລາຄາຊື້",
    "purchasedFor": "ຊື້ໃນລາຄາ {{value}} ວັນທີ {{date}}",
    "warrantyExpiry": "ຮັບປະກັນຮອດ",
    "underWarranty": "ຢູ່ໃນການຮັບປະກັນ",
    "warrantyEnded": "ໝົດການຮັບປະກັນ",
    "maintenanceInterval": "ບຳລຸງຮັກສາທຸກ (ມື້)",
    "lastMaintenance": "ບຳລຸງຮັກສາຄັ້ງລ່າສຸດ",
    "lastOn": "ຄັ້ງລ່າສຸດ {{date}}",
    "nextMaintenance": "ບຳລຸງຮັກສາຄັ້ງຕໍ່ໄປ",
    "nextMaintenanceHint": "ວ່າງໄວ້: ຄັ້ງລ່າສຸດ + ໄລຍະ",
    "maintenanceDueOnly": "ຮອດກຳນົດບຳລຸງຮັກສາ",
    "maintenanceCost": "ຄ່າບຳລຸງຮັກສາ",
    "serviceHistory": "ປະຫວັດການບຳລຸງຮັກສາ ແລະ ສ້ອມແປງ",
    "noEvents": "ຍັງບໍ່ມີການບັນທຶກການບຳລຸງຮັກສາ",
    "logEvent": "ບັນທຶກການບໍລິການ — {{tag}}",
    "logEventShort": "ບັນທຶກການບຳລຸງຮັກສາ",
    "eventType": "ປະເພດ",
    "eventDate": "ວັນທີ",
    "cost": "ຄ່າໃຊ້ຈ່າຍ",
    "statusAfter": "ສະຖານະຫຼັງຈາກ",
    "noChange": "ບໍ່ປ່ຽນ",
    "nextDueDate": "ກຳນົດຄັ້ງຕໍ່ໄປ",
    "nextDueHint": "ວ່າງໄວ້: ມື້ນີ້ + ໄລຍະບຳລຸງຮັກສາ",
    "recordedBy": "ຜູ້ບັນທຶກ",
    "tab": {
      "dashboard": "ສະຖິຕິ",
      "items": "ລາຍການ",
      "stock": "ສິນຄ້າໃນຄັງ",
      "requests": "ໃບສະເໜີຊື້",
      "orders": "ໃບສັ່ງຊື້",
      "suppliers": "ຜູ້ສະໜອງ",
      "equipment": "ອຸປະກອນການແພດ",
      "alerts": "ແຈ້ງເຕືອນ",
      "stores": "ຄັງ",
      "stockIn": "ຮັບເຂົ້າສາງ",
      "stockOut": "ເບີກອອກສາງ",
      "transfers": "ໂອນຍ້າຍ",
      "toCheck": "ລໍຖ້າກວດ",
      "posRefills": "ຄຳຂໍເຕີມສິນຄ້າ POS"
    },
    "kpi": {
      "stockValue": "ມູນຄ່າສິນຄ້າໃນຄັງ",
      "itemsCount": "{{count}} ລາຍການ",
      "outOfStock": "ໝົດສະຕັອກ",
      "lowCount": "ໃກ້ໝົດ {{count}}",
      "lowStock": "ໃກ້ໝົດ",
      "overCount": "ເກີນ {{count}}",
      "expiring30": "ໃກ້ໝົດອາຍຸ ≤ 30 ມື້",
      "expiredLots": "ໝົດອາຍຸ {{count}} ລັອດ · {{value}}",
      "prPending": "ໃບສະເໜີລໍຖ້າອະນຸມັດ",
      "prApproved": "ອະນຸມັດແລ້ວ ຍັງບໍ່ສັ່ງ {{count}}",
      "poOpen": "ໃບສັ່ງຊື້ທີ່ຍັງເປີດ",
      "poOverdue": "ເລີຍກຳນົດ {{count}} · ຄ້າງ {{value}}",
      "equipment": "ອຸປະກອນການແພດ",
      "maintenance": "ຮອດກຳນົດ {{due}} · ເລີຍ {{overdue}}"
    },
    "chart": {
      "flowByMonth": "ຮັບເຂົ້າ, ໃຊ້ອອກ ແລະ ຕັດຈຳໜ່າຍ ຕໍ່ເດືອນ",
      "received": "ຮັບເຂົ້າ",
      "consumed": "ໃຊ້ອອກ",
      "writtenOff": "ຕັດຈຳໜ່າຍ",
      "valueByCategory": "ມູນຄ່າສິນຄ້າຕາມໝວດ",
      "topConsumed": "ໃຊ້ຫຼາຍທີ່ສຸດ (90 ມື້, ຕາມມູນຄ່າ)",
      "expiryTimeline": "ມູນຄ່າສິນຄ້າທີ່ຈະໝົດອາຍຸ ຕໍ່ເດືອນ",
      "expiringValue": "ຈະໝົດອາຍຸ",
      "spendBySupplier": "ການຈັດຊື້ຕາມຜູ້ສະໜອງ (12 ເດືອນ)"
    },
    "severity": {
      "danger": "ດ່ວນ {{count}}",
      "warning": "ເຕືອນ {{count}}",
      "info": "ແຈ້ງໃຫ້ຊາບ {{count}}"
    },
    "alert": {
      "OUT_OF_STOCK": "ໝົດສະຕັອກ",
      "LOW_STOCK": "ໃກ້ໝົດ",
      "OVERSTOCK": "ສິນຄ້າເກີນ",
      "EXPIRED": "ໝົດອາຍຸ",
      "EXPIRING": "ໃກ້ໝົດອາຍຸ",
      "PO_OVERDUE": "ສົ່ງຊ້າ",
      "PO_APPROVAL": "ໃບສັ່ງຊື້ລໍຖ້າອະນຸມັດ",
      "PR_PENDING": "ໃບສະເໜີລໍຖ້າອະນຸມັດ",
      "MAINTENANCE_OVERDUE": "ເລີຍກຳນົດບຳລຸງຮັກສາ",
      "MAINTENANCE_DUE": "ຮອດກຳນົດບຳລຸງຮັກສາ",
      "WARRANTY_EXPIRING": "ການຮັບປະກັນໃກ້ໝົດ",
      "ASSET_OUT_OF_SERVICE": "ອຸປະກອນບໍ່ພ້ອມໃຊ້",
      "stockDetail": "ໃຊ້ໄດ້ {{usable}} · ສັ່ງຄືນທີ່ {{reorder}} · ກຳລັງສັ່ງ {{onOrder}}",
      "overDetail": "ໃຊ້ໄດ້ {{usable}} · ສູງສຸດ {{max}}",
      "lotDetail": "ລັອດ {{lot}} · {{store}} · {{quantity}} · {{date}} · {{value}}",
      "poOverdueDetail": "{{supplier}} · ກຳນົດ {{date}} (ຊ້າ {{count}} ມື້)",
      "prDetail": "ໂດຍ {{by}} · {{priority}}"
    },
    "barcode": "ບາໂຄດ",
    "grnNumber": "ໃບຮັບສິນຄ້າ",
    "margin": "ກຳໄລ {{value}}%",
    "noPictures": "ຍັງບໍ່ມີຮູບ. ເພີ່ມຮູບສິນຄ້າໜຶ່ງ ຫຼື ຫຼາຍຮູບ.",
    "notForSale": "ບໍ່ຂາຍ",
    "pictures": "ຮູບ ແລະ ລາຄາຂາຍ",
    "salePrice": "ລາຄາຂາຍ",
    "salePriceDrugHint": "ລາຄາດຽວກັນໃຊ້ທັງໃບສັ່ງຢາ ແລະ ຂາຍໜ້າຮ້ານ",
    "salePriceHint": "ລາຄາທີ່ຮ້ານຂາຍຢາ",
    "sellable": "ຂາຍໜ້າຮ້ານໄດ້",
    "docs": {
      "availableNow": "ມີໃນປັດຈຸບັນ",
      "cancelConfirm": "ເອກະສານຈະຖືກຍົກເລີກ. ຈຳນວນສິນຄ້າບໍ່ປ່ຽນແປງ.",
      "cancelTitle": "ຍົກເລີກເອກະສານ",
      "cancelled": "ຍົກເລີກເອກະສານແລ້ວ",
      "checkNote": "ໝາຍເຫດຜູ້ກວດ",
      "checkedBy": "ກວດໂດຍ",
      "destination": "ໄປຫາ",
      "fefo": "ໝົດອາຍຸກ່ອນ ອອກກ່ອນ",
      "lineCount": "{{count}} ລາຍການ",
      "newRequisition": "ສ້າງໃບເບີກ",
      "newStockIn": "ຮັບເຂົ້າສາງໃໝ່",
      "newWriteOff": "ຕັດຈຳໜ່າຍ / ສົ່ງຄືນ",
      "none": "ບໍ່ມີເອກະສານ",
      "nothingToCheck": "ບໍ່ມີເອກະສານລໍຖ້າທ່ານກວດ",
      "number": "ເລກທີເອກະສານ",
      "pendingCheck": "ລໍຖ້າກວດ",
      "pickItem": "ເລືອກລາຍການທີ່ຈະຮັບເຂົ້າ",
      "pickLotHint": "ການຕັດຈຳໜ່າຍ ແລະ ສົ່ງຄືນແມ່ນເອົາອອກຈາກລັອດດຽວ. ເລືອກລາຍການ ແລ້ວກົດ \"ຕັດອອກ\" ທີ່ລັອດ.",
      "post": "ກວດ ແລະ ລົງບັນຊີ",
      "postConfirm": "ຈຳນວນສິນຄ້າຈະປ່ຽນທັນທີ. ກວດຈຳນວນ, ລັອດ ແລະ ວັນໝົດອາຍຸກັບສິນຄ້າຕົວຈິງ.",
      "postTitle": "ລົງບັນຊີ {{number}}",
      "posted": "ລົງບັນຊີ {{number}} ແລ້ວ, ສາງຖືກປັບປຸງ",
      "receiptDocuments": "ໃບຮັບສິນຄ້າ ແລະ ການກວດ",
      "receiptHint": "ໃບຮັບຈະລໍຖ້າຜູ້ທີສອງກວດສິນຄ້າ ແລະ ລົງບັນຊີ.",
      "receiveFromPo": "ຮັບຈາກໃບສັ່ງຊື້",
      "receivedBy": "ຜູ້ຮັບ",
      "reference": "ອ້າງອີງ",
      "reject": "ປະຕິເສດ",
      "rejectReason": "ເຫດຜົນທີ່ປະຕິເສດ",
      "rejected": "ປະຕິເສດເອກະສານແລ້ວ",
      "rejectedBecause": "ຖືກປະຕິເສດ: {{note}}",
      "shortNow": "ບາງລາຍການມີສິນຄ້າບໍ່ພໍ; ການລົງບັນຊີຈະບໍ່ສຳເລັດ.",
      "storeKeeper": "ຜູ້ຮັກສາສາງ",
      "submitForCheck": "ສົ່ງໃຫ້ກວດ",
      "submitRequisition": "ສົ່ງໃບເບີກ",
      "submitted": "ສົ່ງ {{number}} ໃຫ້ກວດແລ້ວ",
      "type": "ປະເພດ",
      "value": "ມູນຄ່າ",
      "waitingForChecker": "ລໍຖ້າຜູ້ກວດຄົນທີສອງລົງບັນຊີ.",
      "inHint": "ຮັບເຂົ້າ: ສິນຄ້າຈາກໃບສັ່ງຊື້, ຍອດຍົກມາ ແລະ ການປັບຈຳນວນ. ທຸກເອກະສານຕ້ອງໃຫ້ຜູ້ທີສອງກວດ ແລະ ລົງບັນຊີ.",
      "outHint": "ເບີກອອກ: ໃບເບີກຂອງພະແນກ, ຕັດຈຳໜ່າຍ, ປັບຫຼຸດ ແລະ ສົ່ງຄືນຜູ້ສະໜອງ. ສິນຄ້າອອກເມື່ອຜູ້ທີສອງລົງບັນຊີເທົ່ານັ້ນ.",
      "transferHint": "ການໂອນຍ້າຍສິນຄ້າລະຫວ່າງສາງ ໂດຍຮັກສາລັອດ ແລະ ວັນໝົດອາຍຸ. ຜູ້ທີສອງເປັນຜູ້ລົງບັນຊີ.",
      "checkHint": "ເອກະສານທີ່ຜູ້ອື່ນສ້າງ ລໍຖ້າທ່ານກວດກັບສິນຄ້າ ແລະ ລົງບັນຊີ ຫຼື ປະຕິເສດ."
    }
  },
  "gallery": {
    "add": "ເພີ່ມຮູບ",
    "main": "ຫຼັກ",
    "makeMain": "ຕັ້ງເປັນຮູບຫຼັກ",
    "next": "ຖັດໄປ",
    "previous": "ກ່ອນໜ້າ",
    "none": "ຍັງບໍ່ມີຮູບ",
    "open": "ເປີດຮູບ"
  },
  "inpatient": {
    "title": "ການດູແລຄົນເຈັບນອນໂຮງໝໍ",
    "subtitle": "ຮັບເຂົ້ານອນ, ຍ້າຍຕຽງ ແລະ ອອກໂຮງໝໍ ພ້ອມຄິດຄ່າຕຽງລາຍວັນ",
    "addBed": "ເພີ່ມຕຽງ",
    "addRoom": "ເພີ່ມຫ້ອງ",
    "admissionNumber": "ເລກທີເຂົ້ານອນ",
    "admissionType": "ປະເພດການເຂົ້ານອນ",
    "admit": "ຮັບເຂົ້ານອນ",
    "admitPatient": "ຮັບຄົນເຈັບເຂົ້ານອນ",
    "admitted": "ຮັບເຂົ້ານອນແລ້ວ: {{number}}",
    "admittedAt": "ວັນເຂົ້ານອນ",
    "admittingDiagnosis": "ການວິນິດໄສແຮກເຂົ້າ",
    "allWards": "ທຸກຫວອດ",
    "attending": "ແພດຜູ້ຮັບຜິດຊອບ",
    "attendingDefault": "ຍັງບໍ່ກຳນົດ",
    "bed": "ຕຽງ",
    "bedCharges": "ຄ່າຕຽງ",
    "bedChargesSoFar": "ຄ່າຕຽງເຖິງປັດຈຸບັນ",
    "bedDayRule": "ນັບວັນນອນຕາມຄືນ (ທ່ຽງຄືນ) ຕາມລາຄາຂອງຕຽງ; ນອນພາຍໃນມື້ດຽວນັບເປັນໜຶ່ງວັນ.",
    "bedNumber": "ເລກຕຽງ",
    "bedStays": "ຕຽງທີ່ໃຊ້",
    "bedType": "ປະເພດຕຽງ",
    "beds": "ຕຽງ",
    "billAfterDischarge": "ຄ່າຕຽງອອກບິນຫຼັງອອກໂຮງໝໍ",
    "billed": "ອອກບິນແລ້ວ",
    "by": "ໂດຍ {{name}}",
    "cancelAdmission": "ຍົກເລີກການເຂົ້ານອນ",
    "cancelHint": "ສຳລັບການຮັບເຂົ້ານອນທີ່ຜິດພາດເທົ່ານັ້ນ. ຕຽງຈະຫວ່າງ ແລະ ບໍ່ມີການຄິດເງິນ.",
    "cancelled": "ຍົກເລີກການເຂົ້ານອນແລ້ວ",
    "cancelledBecause": "ຍົກເລີກ: {{reason}}",
    "capacity": "ຈຳນວນຕຽງ",
    "clinical": "ຂໍ້ມູນທາງການແພດ",
    "createBill": "ອອກບິນ",
    "dailyRate": "ລາຄາຕໍ່ວັນ",
    "dailyRateHint": "ຄິດຕໍ່ຄືນສຳລັບແຕ່ລະຕຽງໃນຫ້ອງນີ້",
    "day": "ວັນ",
    "dayN": "ວັນທີ {{count}}",
    "discharge": "ອອກໂຮງໝໍ",
    "dischargeAnyway": "ໃຫ້ອອກໂຮງໝໍເຖິງຢ່າງໃດກໍຕາມ",
    "dischargeDiagnosis": "ການວິນິດໄສສຸດທ້າຍ",
    "dischargeHint": "ຕຽງຈະໄປທຳຄວາມສະອາດ ແລະ ຄ່າຕຽງພ້ອມອອກບິນ.",
    "dischargeMedications": "ຢາກັບບ້ານ",
    "dischargeSummary": "ສະຫຼຸບການອອກໂຮງໝໍ",
    "dischargeTitle": "ໃຫ້ {{name}} ອອກໂຮງໝໍ",
    "dischargeType": "ອອກໄປ",
    "discharged": "ຄົນເຈັບອອກໂຮງໝໍແລ້ວ",
    "dischargedAt": "ວັນອອກໂຮງໝໍ",
    "editRoom": "ແກ້ໄຂຫ້ອງ",
    "editWard": "ແກ້ໄຂຫວອດ",
    "expectedDischarge": "ຄາດວ່າຈະອອກ",
    "expectedShort": "ຄາດອອກ {{date}}",
    "floor": "ຊັ້ນ {{floor}}",
    "floorLabel": "ຊັ້ນ",
    "followUpDate": "ວັນນັດກວດຄືນ",
    "followUpInstructions": "ຄຳແນະນຳຫຼັງອອກໂຮງໝໍ",
    "from": "ຈາກ",
    "lengthOfStay": "ຈຳນວນວັນນອນ",
    "markClean": "ສະອາດແລ້ວ",
    "moveReason": "ເຫດຜົນ",
    "newBed": "ຕຽງໃໝ່",
    "newWard": "ສ້າງຫວອດໃໝ່",
    "nights": "{{count}} ຄືນ",
    "nightsHeader": "ຄືນ",
    "noAdmissions": "ບໍ່ມີການເຂົ້ານອນ",
    "noFreeBeds": "ບໍ່ມີຕຽງຫວ່າງ",
    "noRooms": "ຍັງບໍ່ມີຫ້ອງ",
    "noWards": "ຍັງບໍ່ມີຫວອດ. ກະລຸນາຕັ້ງຄ່າຫວອດ, ຫ້ອງ ແລະ ຕຽງກ່ອນ.",
    "notBilledYet": "ຍັງບໍ່ອອກບິນ",
    "now": "ປັດຈຸບັນ",
    "occupancy": "ອັດຕາການໃຊ້ຕຽງ",
    "occupiedOf": "{{occupied}} ຈາກ {{total}} ຕຽງ",
    "openChart": "ເປີດແຟ້ມການປິ່ນປົວ",
    "patient": "ຄົນເຈັບ",
    "patientOrRelative": "ຄົນເຈັບ ຫຼື ຍາດພີ່ນ້ອງ",
    "pendingWork": "ຍັງມີວຽກທີ່ບໍ່ສຳເລັດ",
    "pending": {
      "serviceOrders": "ບໍລິການພິເສດ {{count}} ລາຍການຍັງບໍ່ແລ້ວ",
      "labOrders": "ການກວດວິເຄາະ {{count}} ລາຍການຍັງບໍ່ແລ້ວ",
      "prescriptions": "ໃບສັ່ງຢາ {{count}} ໃບຍັງບໍ່ຈ່າຍ",
      "draftNotes": "ບັນທຶກ {{count}} ລາຍການຍັງບໍ່ລົງນາມ"
    },
    "printNote": "ກະລຸນາເກັບໃບສະຫຼຸບນີ້ ແລະ ນຳມາເວລານັດກວດຄືນ.",
    "reason": "ເຫດຜົນທີ່ເຂົ້ານອນ",
    "release": "ໃຫ້ຫວ່າງ",
    "room": "ຫ້ອງ",
    "roomN": "ຫ້ອງ {{room}}",
    "roomType": "ປະເພດຫ້ອງ",
    "searchAdmissions": "ຊື່, HN ຫຼື ເລກທີເຂົ້ານອນ",
    "to": "ເຖິງ",
    "transfer": "ຍ້າຍ",
    "transferBed": "ຍ້າຍຕຽງ",
    "transferHint": "ປັດຈຸບັນຢູ່ {{bed}}. ຕຽງເກົ່າຈະໄປທຳຄວາມສະອາດ.",
    "transferred": "ຍ້າຍໄປ {{bed}} ແລ້ວ",
    "visit": "ການມາກວດ",
    "ward": "ຫວອດ",
    "wardType": "ປະເພດຫວອດ",
    "searchBeds": "ຄົນເຈັບ, HN, ຫ້ອງ ຫຼື ຕຽງ",
    "admittedToday": "ເຂົ້າໂຮງໝໍມື້ນີ້",
    "dueOutToday": "ກຳນົດອອກມື້ນີ້",
    "overdueOut": "ກາຍກຳນົດອອກ {{date}}",
    "noBedsMatch": "ບໍ່ມີຕຽງທີ່ກົງກັບການກັ່ນຕອງ",
    "wardOccupied": "ໃຊ້ {{occupied}} ຈາກ {{total}} ຕຽງ",
    "admittedAtField": "ວັນ ແລະ ເວລາເຂົ້າໂຮງໝໍ",
    "admittedAtHint": "ຄ່າເລີ່ມຕົ້ນແມ່ນຕອນນີ້; ປ່ຽນຄືນຫຼັງໄດ້ຖ້າບັນທຶກຊ້າ (ບໍ່ເກີນ 30 ວັນ)",
    "dischargedAtField": "ວັນ ແລະ ເວລາອອກໂຮງໝໍ",
    "dischargedAtHint": "ຄ່າເລີ່ມຕົ້ນແມ່ນຕອນນີ້; ບໍ່ກ່ອນເວລາເຂົ້າ ({{at}})",
    "admittedShort": "ເຂົ້າ {{at}}"
  },
  "services": {
    "title": "ບໍລິການພິເສດ",
    "subtitle": "ເອັກສະເຣ, ຊີທີ, ອັລຕຣາຊາວ, ຄື້ນໄຟຟ້າຫົວໃຈ, ສ່ອງກ້ອງ, ກາຍະພາບບຳບັດ ແລະ ຫັດຖະການ",
    "allCategories": "ທຸກປະເພດ",
    "billedWithVisit": "ອອກບິນພ້ອມການມາກວດ",
    "cancelItem": "ຍົກເລີກ {{name}}",
    "cancelOrder": "ຍົກເລີກຄຳສັ່ງ",
    "category": "ປະເພດ",
    "clinicalInfo": "ຂໍ້ມູນທາງຄລີນິກ",
    "complete": "ສຳເລັດ",
    "duration": "ໄລຍະເວລາ",
    "durationMinutes": "ໄລຍະເວລາ (ນາທີ)",
    "editReport": "ແກ້ໄຂລາຍງານ",
    "editService": "ແກ້ໄຂບໍລິການ",
    "findings": "ສິ່ງທີ່ພົບ",
    "impression": "ສະຫຼຸບ",
    "inpatient": "ຄົນເຈັບໃນ",
    "itemCancelled": "ຍົກເລີກບໍລິການແລ້ວ",
    "markDone": "ສຳເລັດ {{name}}",
    "minutes": "{{count}} ນາທີ",
    "newService": "ເພີ່ມບໍລິການ",
    "noImages": "ບໍ່ມີຮູບ",
    "noOrders": "ບໍ່ມີຄຳສັ່ງບໍລິການພິເສດ",
    "noReport": "ບໍ່ຕ້ອງມີລາຍງານ",
    "open": "ລໍຖ້າເຮັດ",
    "order": "ສັ່ງບໍລິການພິເສດ",
    "orderCancelled": "ຍົກເລີກຄຳສັ່ງແລ້ວ",
    "orderFor": "ບໍລິການພິເສດສຳລັບ {{name}}",
    "orderNumber": "ເລກທີຄຳສັ່ງ",
    "ordered": "ສັ່ງແລ້ວ: {{number}}",
    "orderedAt": "ວັນທີສັ່ງ",
    "orderedBy": "ສັ່ງໂດຍ",
    "performedBy": "ເຮັດໂດຍ {{name}} {{at}}",
    "preparation": "ການກະກຽມຄົນເຈັບ",
    "preparationHint": "ສະແດງເວລາສັ່ງ ເຊັ່ນ: ງົດອາຫານ",
    "prepareNote": "ການກະກຽມ: {{text}}",
    "printReport": "ພິມລາຍງານ",
    "priority": "ຄວາມດ່ວນ",
    "recommendation": "ຂໍ້ແນະນຳ",
    "report": "ລາຍງານ",
    "reportHint": "ຫຼັງສົ່ງ, ຜູ້ອື່ນຈະຢັ້ງຢືນລາຍງານກ່ອນເປັນຜົນສຸດທ້າຍໃຫ້ແພດ.",
    "reportTitle": "ລາຍງານຜົນການກວດ",
    "reportVerified": "ລາຍງານ ແລະ ຢັ້ງຢືນໂດຍຜູ້ທີສອງ",
    "reported": "ສົ່ງລາຍງານໃຫ້ຢັ້ງຢືນແລ້ວ",
    "done": "ບໍລິການສຳເລັດ",
    "reportedBy": "ລາຍງານໂດຍ {{name}} {{at}}",
    "reporter": "ຜູ້ລາຍງານ",
    "requiresReport": "ຕ້ອງມີລາຍງານ (ຢັ້ງຢືນໂດຍຜູ້ທີສອງ)",
    "searchCatalog": "ຄົ້ນຫາບໍລິການ",
    "searchOrders": "ຊື່, HN ຫຼື ເລກທີຄຳສັ່ງ",
    "service": "ບໍລິການ",
    "services": "ບໍລິການ",
    "start": "ເລີ່ມ",
    "started": "ເລີ່ມແລ້ວ",
    "submitReport": "ສົ່ງລາຍງານ",
    "verified": "ຢັ້ງຢືນຜົນແລ້ວ",
    "verifiedBy": "ຢັ້ງຢືນໂດຍ {{name}} {{at}}",
    "verifier": "ຜູ້ຢັ້ງຢືນ",
    "verify": "ຢັ້ງຢືນ",
    "waitingMin": "ລໍຖ້າ {{count}} ນາທີ",
    "waitingVerify": "ລໍຖ້າຜູ້ອື່ນຢັ້ງຢືນລາຍງານຂອງທ່ານ.",
    "writeReport": "ລາຍງານ: {{name}}",
    "writeReportShort": "ຂຽນລາຍງານ"
  },
  "pos": {
    "title": "ຮ້ານຂາຍຢາ",
    "subtitle": "ຂາຍຢາ, ວັດສະດຸ ແລະ ອຸປະກອນການແພດ",
    "alreadyReturned": "ສົ່ງຄືນແລ້ວ",
    "cart": "ກະຕ່າ",
    "cartEmpty": "ກົດສິນຄ້າເພື່ອເພີ່ມ",
    "cashReceived": "ເງິນທີ່ຮັບ",
    "cashier": "ພະນັກງານເກັບເງິນ",
    "change": "ເງິນທອນ",
    "charge": "ຮັບເງິນ {{total}}",
    "controlledNeedsPatient": "ຢາຄວບຄຸມຂາຍໄດ້ສະເພາະຄົນເຈັບທີ່ລົງທະບຽນ",
    "customer": "ລູກຄ້າ",
    "customerName": "ຊື່ລູກຄ້າ",
    "giveChange": "ທອນເງິນ: {{value}}",
    "inStock": "ມີ {{qty}}",
    "netTotal": "{{count}} ລາຍການຂາຍ · ສຸດທິ {{value}}",
    "nextCustomer": "ລູກຄ້າຕໍ່ໄປ",
    "noCashRight": "ທ່ານບໍ່ມີສິດຮັບເງິນສົດ. ເລືອກວິທີຊຳລະອື່ນ.",
    "noProducts": "ບໍ່ມີສິນຄ້າຂາຍໃນສາງນີ້",
    "noReturns": "ບໍ່ມີການສົ່ງຄືນ",
    "noSales": "ບໍ່ມີການຂາຍໃນຊ່ວງນີ້",
    "openDrawerFirst": "ເປີດລິ້ນຊັກເງິນກ່ອນຮັບເງິນສົດ",
    "patientOptional": "ຄົນເຈັບ (ຖ້າມີ)",
    "purchases": "ການຊື້",
    "receipt": "ໃບບິນຮັບເງິນ",
    "recordReturn": "ຮັບສິນຄ້າຄືນ",
    "refundMethod": "ຄືນເງິນດ້ວຍ",
    "refunded": "ຄືນເງິນແລ້ວ",
    "returnHint": "ສິນຄ້າທີ່ສົ່ງຄືນຈະກັບເຂົ້າລັອດເດີມ.",
    "returnQty": "ຈຳນວນຄືນ",
    "returnTitle": "ສົ່ງຄືນຈາກ {{number}}",
    "returned": "ບັນທຶກການສົ່ງຄືນແລ້ວ; ສິນຄ້າກັບເຂົ້າສາງ",
    "returns": "ການສົ່ງຄືນ",
    "saleDiscount": "ສ່ວນຫຼຸດທັງບິນ",
    "saleDone": "ຂາຍ {{number}} ສຳເລັດ",
    "saleNumber": "ເລກທີບິນ",
    "salesTitle": "ການຂາຍໜ້າຮ້ານ",
    "searchOrScan": "ຄົ້ນຫາ ຫຼື ສະແກນບາໂຄດ",
    "searchSales": "ເລກບິນ, ລູກຄ້າ, ເບີໂທ ຫຼື HN",
    "sold": "ຂາຍ",
    "soldAt": "ເວລາຂາຍ",
    "supervisorHint": "ການສົ່ງຄືນ ແລະ ຍົກເລີກແມ່ນເຮັດໂດຍຫົວໜ້າ (ຜູ້ອື່ນ).",
    "suppliesDevices": "ວັດສະດຸ ແລະ ອຸປະກອນ",
    "void": "ຍົກເລີກການຂາຍ",
    "voidHint": "ສິນຄ້າທັງໝົດກັບເຂົ້າສາງ ແລະ ການຂາຍບໍ່ນັບໃນລິ້ນຊັກເງິນ. ເຮັດໄດ້ເມື່ອລິ້ນຊັກຍັງເປີດຢູ່ເທົ່ານັ້ນ.",
    "voided": "ຍົກເລີກການຂາຍແລ້ວ",
    "voidedBecause": "ຍົກເລີກໂດຍ {{name}}: {{reason}}",
    "outlet": "ຈຸດຂາຍ POS",
    "noOutlet": "ຍັງບໍ່ມີຈຸດຂາຍ POS ທີ່ໃຊ້ງານ.",
    "catalog": {
      "title": "ລາຍການສິນຄ້າ POS",
      "subtitle": "ສິນຄ້າທີ່ຂາຍຢູ່ໜ້າຮ້ານ ແລະ ລາຄາ. ສິນຄ້າມາຈາກລາຍການໃນສາງ.",
      "tab": "ລາຍການສິນຄ້າ",
      "search": "ຊື່, ລະຫັດ, ບາໂຄດ ຫຼື ໝວດ",
      "addFromWarehouse": "ເພີ່ມຈາກສາງ",
      "addHint": "ເລືອກສິນຄ້າໃນສາງເພື່ອຂາຍຢູ່ POS. ລາຄາເລີ່ມຕົ້ນແມ່ນລາຄາຂາຍທີ່ແນະນຳ; ປ່ຽນລາຄາໄດ້ພາຍຫຼັງ.",
      "allPublished": "ສິນຄ້າໃນສາງທັງໝົດຢູ່ໃນລາຍການ POS ແລ້ວ.",
      "publishCount": "ເພີ່ມ {{count}} ລາຍການເຂົ້າ POS",
      "published": "ເພີ່ມ {{count}} ລາຍການເຂົ້າ POS ແລ້ວ",
      "empty": "ບໍ່ມີສິນຄ້າໃນລາຍການ POS",
      "product": "ສິນຄ້າ",
      "price": "ລາຄາ POS",
      "posStock": "ສິນຄ້າຢູ່ POS",
      "warehouseStock": "ໃນສາງ",
      "levels": "ເຕີມເມື່ອ → ເຕີມເຖິງ",
      "hide": "ເຊື່ອງຈາກ POS",
      "show": "ສະແດງຢູ່ POS",
      "editTitle": "ສິນຄ້າ POS: {{name}}",
      "warehouseItem": "ສິນຄ້າໃນສາງ",
      "displayName": "ຊື່ທີ່ສະແດງຢູ່ POS",
      "displayNameHint": "ປ່ອຍວ່າງ = ໃຊ້ຊື່ໃນສາງ",
      "suggested": "ລາຄາແນະນຳ: {{price}}",
      "sortOrder": "ລຳດັບໃນໜ້າຈໍ",
      "minLevel": "ເຕີມເມື່ອເຫຼືອ ຫຼື ໜ້ອຍກວ່າ",
      "minLevelHint": "ລວມສິນຄ້າທີ່ກຳລັງຂົນສົ່ງ",
      "parLevel": "ເຕີມໃຫ້ເຖິງ",
      "parLevelHint": "0 = ບໍ່ແນະນຳອັດຕະໂນມັດ",
      "parBelowMin": "ຕ້ອງບໍ່ຕ່ຳກວ່າຈຸດເຕີມ",
      "posPicture": "ຮູບສຳລັບ POS",
      "useWarehousePicture": "ໃຊ້ຮູບຈາກສາງ",
      "publishedHint": "ສະແດງ ແລະ ຂາຍຢູ່ POS"
    },
    "outlets": {
      "title": "ຈຸດຂາຍ",
      "add": "ຈຸດຂາຍໃໝ່",
      "edit": "ແກ້ໄຂຈຸດຂາຍ",
      "empty": "ຍັງບໍ່ມີຈຸດຂາຍ",
      "hint": "ແຕ່ລະຈຸດຂາຍມີສິນຄ້າຂອງຕົນເອງ. ສິນຄ້າຈະເຂົ້າມາເມື່ອສາງສົ່ງຕາມຄຳຂໍເຕີມ ແລະ ຈຸດຂາຍຢືນຢັນການຮັບແລ້ວເທົ່ານັ້ນ.",
      "codeHint": "ລະຫັດສັ້ນ, ເຊັ່ນ POS2",
      "inUse": "ກຳລັງໃຊ້",
      "products": "ສິນຄ້າທີ່ມີ",
      "incoming": "ກຳລັງມາ"
    },
    "stock": {
      "title": "ສິນຄ້າຢູ່ POS ແລະ ການເຕີມ",
      "subtitle": "ສິນຄ້າຢູ່ຈຸດຂາຍ, ສິນຄ້າທີ່ກຳລັງມາ ແລະ ຄຳຂໍເຕີມສິນຄ້າຈາກສາງ",
      "products": "ສິນຄ້າ",
      "inTransit": "ກຳລັງມາ",
      "onHand": "ຢູ່ POS",
      "nextExpiry": "ໝົດອາຍຸຕໍ່ໄປ",
      "expired": "ໝົດອາຍຸແລ້ວ",
      "empty": "ບໍ່ມີຂໍ້ມູນ"
    },
    "refill": {
      "request": "ຂໍເຕີມສິນຄ້າ",
      "requestHint": "ຕື່ມໃຫ້ອັດຕະໂນມັດດ້ວຍສິນຄ້າທີ່ເຖິງຈຸດເຕີມ, ເຕີມໃຫ້ເຖິງລະດັບເປົ້າໝາຍ. ປ່ຽນຈຳນວນໄດ້.",
      "fromStore": "ຈາກສາງ",
      "nothingLow": "ບໍ່ມີສິນຄ້າໃດຕ່ຳກວ່າຈຸດເຕີມ. ເພີ່ມສິນຄ້າຂ້າງລຸ່ມໄດ້ຖ້າຕ້ອງການ.",
      "quantity": "ຈຳນວນ",
      "addProduct": "ເພີ່ມສິນຄ້າ",
      "saveDraft": "ບັນທຶກເປັນຮ່າງ",
      "send": "ສົ່ງໃຫ້ສາງ",
      "created": "ສ້າງຄຳຂໍເຕີມ {{number}} ແລ້ວ",
      "submitted": "ສົ່ງໃຫ້ສາງແລ້ວ",
      "listTitle": "ຄຳຂໍເຕີມສິນຄ້າ",
      "inboxTitle": "ຄຳຂໍເຕີມສິນຄ້າຈາກ POS",
      "open": "ກຳລັງດຳເນີນ",
      "empty": "ບໍ່ມີຄຳຂໍເຕີມສິນຄ້າ",
      "number": "ຄຳຂໍ",
      "route": "ຈາກ → ໄປ",
      "lines": "ສິນຄ້າ",
      "requestedBy": "ຜູ້ຂໍ",
      "preparedBy": "ຜູ້ກະກຽມ (ສາງ)",
      "sentAt": "ສົ່ງເມື່ອ",
      "receivedBy": "ຜູ້ຮັບ",
      "transfer": "ໃບໂອນຈາກສາງ",
      "requested": "ຂໍ",
      "inStore": "ຢູ່ {{store}}",
      "sent": "ສົ່ງ",
      "received": "ຮັບ",
      "short": "ຂາດ",
      "toSend": "ຈະສົ່ງ",
      "prepare": "ກະກຽມໃບໂອນ",
      "prepareTitle": "ກະກຽມການເຕີມ {{number}}",
      "prepareHint": "POS ກຳລັງລໍຖ້າສິນຄ້າເຫຼົ່ານີ້. ກະກຽມໃບໂອນ; ພະນັກງານສາງອີກຄົນໜຶ່ງກວດ ແລະ ສົ່ງ.",
      "prepareDialogHint": "ຈຳນວນເລີ່ມຕົ້ນຕາມທີ່ຂໍ, ບໍ່ເກີນທີ່ສາງມີ. ສິນຄ້າທີ່ເປັນ 0 ຈະບໍ່ຖືກສົ່ງ.",
      "prepared": "ກະກຽມໃບໂອນ {{doc}} ແລ້ວ — ລໍຖ້າຜູ້ກວດສົ່ງ",
      "preparingHint": "ສາງກະກຽມແລ້ວ. ພະນັກງານສາງອີກຄົນໜຶ່ງກວດ ແລະ ສົ່ງຈາກ ສາງ → ລໍຖ້າກວດ:",
      "waitingWarehouse": "ລໍຖ້າສາງກະກຽມ.",
      "sendHint": "ການສົ່ງໃບໂອນນີ້ຈະຕັດສິນຄ້າອອກຈາກສາງ; ສິນຄ້າເຂົ້າຈຸດຂາຍ POS ເມື່ອ POS ຢືນຢັນການຮັບ. ຄຳຂໍເຕີມ",
      "inTransitHint": "ກຳລັງສົ່ງໄປ POS. POS ນັບສິນຄ້າທີ່ມາຮອດ ແລະ ຢືນຢັນການຮັບ. ຄຳຂໍເຕີມ",
      "fromRequest": "ກະກຽມສຳລັບຄຳຂໍເຕີມ POS",
      "receive": "ຮັບສິນຄ້າ",
      "receiveTitle": "ຮັບສິນຄ້າເຕີມ {{number}}",
      "receiveHint": "ສິນຄ້າກຳລັງມາ. ນັບສິນຄ້າທີ່ມາຮອດ ແລະ ຢືນຢັນການຮັບ; ຫຼັງຈາກນັ້ນຈຶ່ງຂາຍໄດ້.",
      "receiveDialogHint": "ປ້ອນຈຳນວນທີ່ມາຮອດແທ້. ສິນຄ້າທີ່ຂາດຈະຖືກບັນທຶກ ແລະ ຕ້ອງມີໝາຍເຫດ.",
      "receiveNote": "ໝາຍເຫດ (ເຫດຜົນທີ່ຂາດ)",
      "confirmReceipt": "ຢືນຢັນການຮັບ",
      "receivedOk": "ຮັບແລ້ວ — ຂາຍສິນຄ້າໄດ້ແລ້ວ",
      "receivedShort": "ຮັບແລ້ວແຕ່ຂາດ: {{note}}",
      "shortValue": "ມູນຄ່າທີ່ຂາດ: {{value}}",
      "moreThanSent": "ຫຼາຍກວ່າທີ່ສົ່ງມາ",
      "moreThanStore": "ຫຼາຍກວ່າທີ່ສາງມີ",
      "reject": "ປະຕິເສດ",
      "rejectTitle": "ປະຕິເສດຄຳຂໍເຕີມ {{number}}",
      "rejectReason": "ເຫດຜົນ",
      "rejected": "ປະຕິເສດຄຳຂໍເຕີມແລ້ວ",
      "rejectedBecause": "ສາງປະຕິເສດ: {{reason}}",
      "cancelTitle": "ຍົກເລີກຄຳຂໍເຕີມ {{number}}",
      "cancelHint": "ສາງຈະບໍ່ກະກຽມຄຳຂໍນີ້."
    }
  },
  "finance": {
    "title": "ການເງິນ ແລະ ບັນຊີ",
    "subtitle": "ລາຄາ ແລະ ຄ່າທຳນຽມ, ລິ້ນຊັກເງິນ, ລາຍຈ່າຍ ແລະ ຜົນປະກອບການ",
    "tab": {
      "dashboard": "ພາບລວມ",
      "prices": "ລາຄາ ແລະ ຄ່າທຳນຽມ",
      "sessions": "ລິ້ນຊັກເງິນ",
      "expenses": "ລາຍຈ່າຍ",
      "history": "ປະຫວັດລາຄາ"
    },
    "allCategories": "ທຸກໝວດ",
    "amount": "ຈຳນວນເງິນ",
    "approveExpense": "ອະນຸມັດ {{number}}",
    "approvedTotal": "ອະນຸມັດແລ້ວ: {{value}}",
    "balanced": "ຍອດກົງກັນ",
    "byMethod": "ການຊຳລະຕາມວິທີ",
    "cashExpenseHint": "ເງິນສົດທີ່ຈ່າຍອອກຈາກລິ້ນຊັກຈະນັບໃນລິ້ນຊັກທີ່ທ່ານເປີດຢູ່.",
    "cashExpenses": "ລາຍຈ່າຍເງິນສົດ",
    "cashPayments": "ຮັບຊຳລະບິນເງິນສົດ",
    "cashRefunds": "ຄືນເງິນສົດ",
    "cashSales": "ຂາຍໜ້າຮ້ານເງິນສົດ",
    "changePrice": "ປ່ຽນລາຄາ",
    "changePriceOf": "ລາຄາຂອງ {{name}}",
    "changeReason": "ເຫດຜົນທີ່ປ່ຽນ",
    "changedAt": "ວັນທີປ່ຽນ",
    "changedBy": "ປ່ຽນໂດຍ",
    "closeDrawer": "ປິດລິ້ນຊັກເງິນ {{number}}",
    "closeDrawerShort": "ປິດລິ້ນຊັກ",
    "closeNote": "ໝາຍເຫດການນັບ",
    "closed": "ປິດ",
    "collected": "ເງິນທີ່ເກັບໄດ້",
    "cost": "ຕົ້ນທຶນ",
    "costOfGoods": "ຕົ້ນທຶນຢາ ແລະ ວັດສະດຸ",
    "countedCash": "ເງິນສົດທີ່ນັບໄດ້",
    "counterSales": "ຂາຍໜ້າຮ້ານ",
    "currentPrice": "ປັດຈຸບັນ {{value}}",
    "dailyCash": "ເງິນເຂົ້າ-ອອກລາຍວັນ",
    "date": "ວັນທີ",
    "decidedBy": "ອະນຸມັດ / ປະຕິເສດໂດຍ",
    "discountReason": "ເຫດຜົນຂອງສ່ວນຫຼຸດ",
    "discountType": "ຫຼຸດເປັນ",
    "discountable": "ໃຫ້ສ່ວນຫຼຸດໄດ້",
    "discountableHint": "ສາມາດໃຫ້ສ່ວນຫຼຸດຄ່າທຳນຽມນີ້ໄດ້",
    "discounts": "ສ່ວນຫຼຸດທີ່ໃຫ້",
    "drawerOpenShort": "ລິ້ນຊັກ {{number}} · {{cash}}",
    "drawers": "ລິ້ນຊັກເງິນທີ່ເປີດຢູ່",
    "editFee": "ແກ້ໄຂຄ່າທຳນຽມ",
    "expectedCash": "ເງິນສົດທີ່ຄວນມີ",
    "expenseApprovalHint": "ຜູ້ອື່ນຕ້ອງອະນຸມັດລາຍຈ່າຍກ່ອນຈະນັບ.",
    "expenseNumber": "ເລກທີລາຍຈ່າຍ",
    "expenseOnlyHint": "ທ່ານສາມາດບັນທຶກລາຍຈ່າຍ; ຝ່າຍການເງິນເປັນຜູ້ອະນຸມັດ.",
    "expenseRecorded": "ສົ່ງລາຍຈ່າຍ {{number}} ໃຫ້ອະນຸມັດແລ້ວ",
    "expenses": "ລາຍຈ່າຍ",
    "expensesByCategory": "ລາຍຈ່າຍຕາມໝວດ",
    "grossProfit": "ກຳໄລຂັ້ນຕົ້ນ {{value}}",
    "item": "ລາຍການ",
    "lastChange": "ປ່ຽນຫຼ້າສຸດ",
    "margin": "ກຳໄລ",
    "myDrawer": "ລິ້ນຊັກເງິນຂອງຂ້ອຍ",
    "netProfit": "ກຳໄລສຸດທິ",
    "newExpense": "ບັນທຶກລາຍຈ່າຍ",
    "newFee": "ເພີ່ມຄ່າທຳນຽມ",
    "newPrice": "ລາຄາໃໝ່",
    "noChanges": "ບໍ່ມີການປ່ຽນລາຄາ",
    "noExpenses": "ບໍ່ມີລາຍຈ່າຍ",
    "noOpenDrawer": "ທ່ານບໍ່ມີລິ້ນຊັກເງິນທີ່ເປີດຢູ່.",
    "noSessions": "ບໍ່ມີລິ້ນຊັກເງິນ",
    "oldPrice": "ລາຄາເກົ່າ",
    "openDrawer": "ເປີດລິ້ນຊັກເງິນ",
    "openDrawerHint": "ນັບເງິນທອນໃນລິ້ນຊັກ ແລະ ປ້ອນເປັນເງິນເລີ່ມຕົ້ນ.",
    "opened": "ເປີດ",
    "openedAt": "ເປີດ {{at}}",
    "openingFloat": "ເງິນເລີ່ມຕົ້ນ",
    "otherVerifies": "ຜູ້ອື່ນຕ້ອງນັບ ແລະ ກວດລິ້ນຊັກນີ້.",
    "outstanding": "ບິນທີ່ຍັງບໍ່ຈ່າຍ",
    "payee": "ຈ່າຍໃຫ້",
    "pendingApproval": "{{count}} ລໍຖ້າອະນຸມັດ",
    "percent": "ເປີເຊັນ",
    "percentValue": "ເປີເຊັນ (%)",
    "price": "ລາຄາ",
    "priceChangeHint": "ບິນໃໝ່ໃຊ້ລາຄາໃໝ່; ບິນເກົ່າຮັກສາລາຄາເດີມ. ທຸກການປ່ຽນແປງຖືກເກັບໄວ້ໃນປະຫວັດລາຄາ.",
    "priceSaved": "ປ່ຽນລາຄາແລ້ວ",
    "pricesHint": "ທຸກຄ່າທຳນຽມ, ຢາ, ການກວດວິເຄາະ, ບໍລິການພິເສດ, ຄ່າຕຽງ ແລະ ສິນຄ້າມີລາຄາຢູ່ນີ້. ສ່ວນຫຼຸດເປັນຈຳນວນເງິນ ຫຼື ເປີເຊັນໃຫ້ໃນບິນ ຫຼື ທີ່ຮ້ານ.",
    "recordedBy": "ບັນທຶກໂດຍ",
    "rejectExpense": "ປະຕິເສດ {{number}}",
    "revenue": "ລາຍຮັບ",
    "revenueBySource": "ລາຍຮັບຕາມແຫຼ່ງ",
    "revenueSplit": "ບິນ {{invoices}} · ໜ້າຮ້ານ {{sales}}",
    "searchPrices": "ຄົ້ນຫາຕາມຊື່ ຫຼື ລະຫັດ",
    "session": "ລິ້ນຊັກເງິນ",
    "sessionClosed": "ປິດລິ້ນຊັກ {{number}} ແລ້ວ; ລໍຖ້າກວດ",
    "sessionOpened": "ເປີດລິ້ນຊັກ {{number}} ແລ້ວ",
    "sessionTitle": "ລິ້ນຊັກ {{number}} · {{name}}",
    "sessionVerified": "ກວດລິ້ນຊັກແລ້ວ",
    "submitExpense": "ສົ່ງໃຫ້ອະນຸມັດ",
    "taxRate": "ອັດຕາອາກອນ (%)",
    "toVerify": "ປິດແລ້ວ {{count}}, ລໍຖ້າກວດ",
    "type": "ປະເພດ",
    "variance": "ສ່ວນຕ່າງ",
    "varianceIs": "ສ່ວນຕ່າງ {{value}}; ກະລຸນາອະທິບາຍ",
    "verifiedBy": "ກວດໂດຍ",
    "verifyCount": "ຢັ້ງຢືນການນັບ"
  },
  "diseases": {
    "title": "ລາຍການພະຍາດ",
    "subtitle": "ລະຫັດ ICD-10, ຊື່ ແລະ ປະເພດພະຍາດ ສຳລັບການບົ່ງມະຕິ ແລະ ລາຍງານ",
    "tabDiseases": "ພະຍາດ",
    "tabTypes": "ປະເພດພະຍາດ",
    "searchPlaceholder": "ຊອກຫາດ້ວຍລະຫັດ ICD-10 ຫຼື ຊື່…",
    "type": "ປະເພດພະຍາດ",
    "allTypes": "ທຸກປະເພດ",
    "notifiableOnly": "ສະເພາະພະຍາດທີ່ຕ້ອງລາຍງານ",
    "newDisease": "ເພີ່ມພະຍາດ",
    "empty": "ບໍ່ພົບພະຍາດ",
    "code": "ລະຫັດ ICD-10",
    "codeHint": "ເຊັ່ນ A90 ຫຼື J06.9; ໃຊ້ຕົວພິມໃຫຍ່",
    "name": "ຊື່",
    "nameLo": "ຊື່ (ລາວ)",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "notifiable": "ຕ້ອງລາຍງານ",
    "notifiableShort": "ລາຍງານ",
    "notifiableHint": "ພະຍາດທີ່ຕ້ອງລາຍງານ: ຕ້ອງລາຍງານກໍລະນີໃຫ້ຂະແໜງສາທາລະນະສຸກ",
    "notifiableWarning": "{{name}} ແມ່ນພະຍາດທີ່ຕ້ອງລາຍງານ. ຢ່າລືມລາຍງານກໍລະນີນີ້.",
    "noType": "— ບໍ່ມີປະເພດ —",
    "activeHint": "ໃຊ້ງານ (ສະແດງເວລາເລືອກການບົ່ງມະຕິ)",
    "activeTypeHint": "ໃຊ້ງານ",
    "deleteDisease": "ລຶບພະຍາດ",
    "deleteDiseaseMessage": "ລຶບ {{code}} ອອກຈາກລາຍການບໍ? ການບົ່ງມະຕິທີ່ບັນທຶກແລ້ວຍັງຄົງລະຫັດ ແລະ ຂໍ້ຄວາມເດີມ.",
    "deleted": "ລຶບແລ້ວ",
    "newType": "ເພີ່ມປະເພດພະຍາດ",
    "noTypes": "ຍັງບໍ່ມີປະເພດພະຍາດ",
    "diseaseCount": "ຈຳນວນພະຍາດ",
    "sortOrder": "ລຳດັບການສະແດງ",
    "color": "ສີ",
    "customColor": "ສີອື່ນ",
    "preview": "ຕົວຢ່າງ",
    "typeInUseHint": "ມີ {{count}} ພະຍາດໃຊ້ປະເພດນີ້ ຈຶ່ງລຶບບໍ່ໄດ້. ຍ້າຍພະຍາດ ຫຼື ປິດການໃຊ້ງານປະເພດນີ້.",
    "deleteType": "ລຶບປະເພດພະຍາດ",
    "deleteTypeMessage": "ລຶບປະເພດພະຍາດ {{code}} ບໍ?",
    "pickFromCatalog": "ຊອກຫາໃນລາຍການພະຍາດ"
  },
  "national": {
    "title": "ລາຍງານລະດັບຊາດ",
    "subtitle": "ຜົນ KPI, ລາຍງານທີ່ອະນຸມັດແລ້ວ ແລະ ການສົ່ງຂໍ້ມູນເຂົ້າ DHIS2",
    "tab": {
      "dashboard": "ພາບລວມ KPI",
      "snapshots": "ສະບັບລາຍງານ",
      "catalog": "ລາຍການ KPI",
      "batches": "ການສົ່ງ DHIS2",
      "mappings": "ການຈັບຄູ່ DHIS2",
      "connections": "ການເຊື່ອມຕໍ່ DHIS2"
    },
    "period": "ໄລຍະເວລາ",
    "calculate": "ຄິດໄລ່ KPI",
    "calculated": "ຄິດໄລ່ KPI ແລ້ວ",
    "lastRun": "ຄິດໄລ່ຫຼ້າສຸດ {{at}} ໂດຍ {{by}}",
    "notCalculatedYet": "ຍັງບໍ່ໄດ້ຄິດໄລ່ KPI ສຳລັບໄລຍະນີ້. ກົດ ຄິດໄລ່ KPI.",
    "notCalculatedReadOnly": "ຍັງບໍ່ໄດ້ຄິດໄລ່ KPI ສຳລັບໄລຍະນີ້.",
    "notCalculated": "ຍັງບໍ່ໄດ້ຄິດໄລ່",
    "noKpis": "ບໍ່ມີ KPI",
    "target": "ເປົ້າໝາຍ",
    "warning": "ລະດັບເຕືອນ",
    "warningAt": "ເຕືອນທີ່ {{value}}",
    "numeratorDenominator": "ຕົວຕັ້ງ / ຕົວຫານ",
    "formulaVersion": "ສູດສະບັບທີ {{n}}",
    "trend": "ຫົກໄລຍະຫຼ້າສຸດ",
    "breakdown": "ແຍກຕາມກຸ່ມ",
    "report": "ລາຍງານ",
    "allReports": "ທຸກລາຍງານ",
    "allStatuses": "ທຸກສະຖານະ",
    "allTypes": "ທຸກປະເພດ",
    "generateSnapshot": "ສ້າງສະບັບລາຍງານ",
    "generate": "ສ້າງ",
    "noSnapshots": "ຍັງບໍ່ມີສະບັບລາຍງານ",
    "version": "ສະບັບ",
    "checks": "ການກວດສອບ",
    "clean": "ບໍ່ມີບັນຫາ",
    "errors": "ຂໍ້ຜິດພາດ: {{count}}",
    "warnings": "ຄຳເຕືອນ: {{count}}",
    "generated": "ສ້າງເມື່ອ",
    "approvedBy": "ອະນຸມັດໂດຍ",
    "includesKpis": "ລາຍງານນີ້ປະກອບມີ:",
    "generateHint": "KPI ຈະຖືກຄິດໄລ່ໃໝ່ ແລະ ບັນທຶກເປັນສະບັບໃໝ່ທີ່ບໍ່ສາມາດແກ້ໄຂໄດ້. ຕ້ອງໃຫ້ຜູ້ອື່ນທີ່ບໍ່ແມ່ນທ່ານອະນຸມັດກ່ອນຈຶ່ງສົ່ງໄດ້.",
    "snapshotGenerated": "ສ້າງສະບັບລາຍງານແລ້ວ",
    "snapshotValidated": "ກວດສອບສະບັບລາຍງານແລ້ວ",
    "snapshotApproved": "ອະນຸມັດສະບັບລາຍງານແລ້ວ",
    "snapshotInvalidated": "ຍົກເລີກສະບັບລາຍງານແລ້ວ",
    "invalidate": "ຍົກເລີກຄວາມຖືກຕ້ອງ",
    "validate": "ກວດສອບ",
    "approve": "ອະນຸມັດ",
    "prepareDhis2": "ສົ່ງເຂົ້າ DHIS2…",
    "cannotApproveOwn": "ທ່ານບໍ່ສາມາດອະນຸມັດວຽກຂອງຕົນເອງ",
    "generatedBy": "ສ້າງໂດຍ {{by}} ເມື່ອ {{at}}",
    "approvedByAt": "ອະນຸມັດໂດຍ {{by}} ເມື່ອ {{at}}",
    "approvedByName": "ອະນຸມັດໂດຍ {{by}}",
    "createdByAt": "ສ້າງໂດຍ {{by}} ເມື່ອ {{at}}",
    "needsOtherApprover": "ລໍຖ້າຜູ້ອື່ນອະນຸມັດ (ແບ່ງແຍກໜ້າທີ່).",
    "invalidatedBecause": "ຍົກເລີກແລ້ວ: {{reason}}",
    "supersededHint": "ມີສະບັບໃໝ່ທີ່ອະນຸມັດແລ້ວແທນສະບັບນີ້.",
    "values": "ຄ່າ",
    "kpi": "KPI",
    "value": "ຄ່າ",
    "formula": "ສູດ",
    "quality": "ຄຸນນະພາບຂໍ້ມູນ",
    "dhis2Batches": "ການສົ່ງ DHIS2",
    "invalidateMessage": "ສະບັບທີ່ຖືກຍົກເລີກຈະບໍ່ສາມາດສົ່ງໄດ້ອີກ; ຊຸດທີ່ຍັງບໍ່ໄດ້ສົ່ງຈະຖືກຍົກເລີກ. ກະລຸນາລະບຸເຫດຜົນ.",
    "reason": "ເຫດຜົນ",
    "connection": "ການເຊື່ອມຕໍ່",
    "createBatch": "ສ້າງຊຸດຂໍ້ມູນ",
    "noConnections": "ຍັງບໍ່ໄດ້ຕັ້ງຄ່າການເຊື່ອມຕໍ່ DHIS2",
    "createBatchHint": "ຄ່າຕ່າງໆຈະຖືກຈັບຄູ່ກັບອົງປະກອບຂໍ້ມູນ DHIS2 ແລະ ກວດສອບ. ຊຸດຂໍ້ມູນຈະສົ່ງໄດ້ຫຼັງຈາກຜູ້ອື່ນອະນຸມັດເທົ່ານັ້ນ.",
    "batchCreated": "ສ້າງຊຸດຂໍ້ມູນແລ້ວ",
    "noIssues": "ບໍ່ພົບບັນຫາ",
    "issue": {
      "INSUFFICIENT_DATA": "ຂໍ້ມູນໜ້ອຍເກີນໄປ",
      "NO_FORMULA": "ບໍ່ມີສູດທີ່ອະນຸມັດ",
      "DIMENSION_TOTAL_MISMATCH": "ຍອດແຍກກຸ່ມບໍ່ກົງກັນ",
      "PERIOD_OPEN": "ໄລຍະຍັງບໍ່ສິ້ນສຸດ",
      "NO_ORG_UNIT_MAPPING": "ຍັງບໍ່ຈັບຄູ່ຫົວໜ່ວຍ",
      "NO_DATA_SET_MAPPING": "ຍັງບໍ່ຈັບຄູ່ຊຸດຂໍ້ມູນ",
      "NO_DATA_ELEMENT_MAPPING": "ຍັງບໍ່ຈັບຄູ່ອົງປະກອບຂໍ້ມູນ",
      "NO_VALUE": "ບໍ່ມີຄ່າ",
      "NOT_SENT_QUALITY": "ບໍ່ສົ່ງ (ຄຸນນະພາບ)",
      "NO_CATEGORY_MAPPING": "ຍັງບໍ່ຈັບຄູ່ໝວດ",
      "NOTHING_TO_SEND": "ບໍ່ມີຫຍັງຈະສົ່ງ"
    },
    "catalogHint": "ສູດແມ່ນຕົວຄິດໄລ່ທີ່ມີໃນລະບົບ. ສູດສະບັບໃໝ່ຈະໃຊ້ໄດ້ຫຼັງຈາກຜູ້ອື່ນທີ່ບໍ່ແມ່ນຜູ້ຂຽນອະນຸມັດເທົ່ານັ້ນ.",
    "newKpi": "ເພີ່ມ KPI",
    "category": "ໝວດ",
    "unit": "ຫົວໜ່ວຍ",
    "noFormula": "ບໍ່ມີສູດທີ່ອະນຸມັດ",
    "draftVersions": "ສະບັບຮ່າງ: {{count}}",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "nameLo": "ຊື່ (ລາວ)",
    "direction": "ທິດທາງ",
    "owner": "ຜູ້ຮັບຜິດຊອບ",
    "unitFixed": "ບໍ່ສາມາດປ່ຽນຫົວໜ່ວຍຫຼັງຈາກສ້າງແລ້ວ",
    "newKpiHint": "ຫຼັງຈາກບັນທຶກ, ໃຫ້ເພີ່ມສູດ ແລະ ໃຫ້ອະນຸມັດກ່ອນ ຈຶ່ງຄິດໄລ່ KPI ໄດ້.",
    "newTarget": "ເພີ່ມເປົ້າໝາຍ",
    "newFormulaVersion": "ເພີ່ມສູດສະບັບໃໝ່",
    "targetNeedsDirection": "ກຳນົດກ່ອນວ່າສູງດີ ຫຼື ຕ່ຳດີ",
    "ownedBy": "ຜູ້ຮັບຜິດຊອບ: {{owner}}",
    "formulaVersions": "ສະບັບຂອງສູດ",
    "definition": "ຄຳນິຍາມ",
    "numerator": "ຕົວຕັ້ງ",
    "denominator": "ຕົວຫານ",
    "effective": "ມີຜົນ",
    "minDenominator": "ຕົວຫານຕ່ຳສຸດ",
    "targets": "ເປົ້າໝາຍ",
    "infoNoTarget": "KPI ເພື່ອຂໍ້ມູນບໍ່ມີເປົ້າໝາຍ",
    "noTargets": "ຍັງບໍ່ມີເປົ້າໝາຍ",
    "formulaApproved": "ອະນຸມັດສູດແລ້ວ",
    "formulaDrafted": "ບັນທຶກສູດສະບັບຮ່າງແລ້ວ",
    "calculator": "ຕົວຄິດໄລ່",
    "parameters": "ພາລາມິເຕີ (JSON)",
    "parametersInvalid": "ໃສ່ JSON object ເຊັ່ນ {\"windowDays\": 30}",
    "effectiveFrom": "ມີຜົນແຕ່ວັນທີ",
    "changeRationale": "ເຫດຜົນຂອງການປ່ຽນແປງ",
    "saveDraft": "ບັນທຶກເປັນຮ່າງ",
    "formulaApprovalHint": "ສະບັບໃໝ່ເລີ່ມໃຊ້ໃນວັນທີມີຜົນຫຼັງອະນຸມັດ; ສະບັບກ່ອນໜ້າສິ້ນສຸດໃນມື້ກ່ອນນັ້ນ.",
    "lowerBetterHint": "ຕ່ຳຍິ່ງດີ: ຄ່າເທົ່າ ຫຼື ຕ່ຳກວ່າເປົ້າໝາຍ ຖືວ່າບັນລຸ, ສູງກວ່າແຕ່ບໍ່ເກີນລະດັບເຕືອນ ຖືວ່າເຕືອນ.",
    "higherBetterHint": "ສູງຍິ່ງດີ: ຄ່າເທົ່າ ຫຼື ສູງກວ່າເປົ້າໝາຍ ຖືວ່າບັນລຸ, ຕ່ຳກວ່າແຕ່ບໍ່ຕ່ຳກວ່າລະດັບເຕືອນ ຖືວ່າເຕືອນ.",
    "batchesHint": "ຊຸດຂໍ້ມູນຈະຖືກສົ່ງໃນເບື້ອງຫຼັງ ແລະ ລອງສົ່ງໃໝ່ອັດຕະໂນມັດເມື່ອ DHIS2 ບໍ່ພ້ອມ.",
    "noBatches": "ຍັງບໍ່ມີການສົ່ງ DHIS2",
    "batch": "ຊຸດຂໍ້ມູນ",
    "batchApproved": "ອະນຸມັດຊຸດຂໍ້ມູນແລ້ວ",
    "batchQueued": "ຊຸດຂໍ້ມູນລໍຖ້າສົ່ງ",
    "batchReconciled": "ກວດທຽບກັບ DHIS2 ແລ້ວ",
    "batchCancelled": "ຍົກເລີກຊຸດຂໍ້ມູນແລ້ວ",
    "cancelBatch": "ຍົກເລີກຊຸດ",
    "send": "ສົ່ງເຂົ້າ DHIS2",
    "retry": "ສົ່ງອີກຄັ້ງ",
    "reconcile": "ກວດທຽບ",
    "dataSetOrgUnit": "ຊຸດຂໍ້ມູນ {{ds}} · ຫົວໜ່ວຍ {{ou}}",
    "batchHasErrors": "ຊຸດນີ້ມີຂໍ້ຜິດພາດ ແລະ ສົ່ງບໍ່ໄດ້. ແກ້ໄຂການຈັບຄູ່, ຍົກເລີກຊຸດນີ້ ແລ້ວສ້າງຊຸດໃໝ່.",
    "reconcileHint": "DHIS2 ບໍ່ຕອບກັບທັນເວລາ. ກົດກວດທຽບເພື່ອອ່ານຄ່າກັບມາກ່ອນສົ່ງໃໝ່.",
    "nextAttempt": "ລອງອັດຕະໂນມັດຄັ້ງຕໍ່ໄປ {{at}}",
    "dataValues": "ຄ່າຂໍ້ມູນ",
    "noValues": "ບໍ່ມີຄ່າ",
    "dataElement": "ອົງປະກອບຂໍ້ມູນ",
    "categoryOptionCombo": "ກຸ່ມໝວດ (COC)",
    "importResults": "ຜົນການນຳເຂົ້າ",
    "counts": "ຈຳນວນ",
    "countsLine": "ນຳເຂົ້າ {{imported}}, ອັບເດດ {{updated}}, ຂ້າມ {{ignored}} ຈາກ {{total}}",
    "conflicts": "ຂໍ້ຂັດແຍ່ງ",
    "activity": "ກິດຈະກຳ",
    "showPayload": "ສະແດງຂໍ້ມູນທີ່ສົ່ງ",
    "hidePayload": "ເຊື່ອງຂໍ້ມູນທີ່ສົ່ງ",
    "mappingType": "ປະເພດການຈັບຄູ່",
    "newMapping": "ເພີ່ມການຈັບຄູ່",
    "noMappings": "ບໍ່ມີການຈັບຄູ່",
    "local": "ລາຍການໃນ HMS",
    "onlyFor": "ສະເພາະ {{report}}",
    "notInMetadata": "ບໍ່ມີໃນ metadata",
    "transform": "ການປັບຄ່າ",
    "retire": "ເຊົາໃຊ້",
    "mappingApproved": "ອະນຸມັດການຈັບຄູ່ແລ້ວ",
    "mappingRetired": "ເຊົາໃຊ້ການຈັບຄູ່ແລ້ວ",
    "mappingDrafted": "ບັນທຶກການຈັບຄູ່ສະບັບຮ່າງແລ້ວ",
    "dhis2Object": "ລາຍການ DHIS2",
    "refreshMetadataFirst": "ກະລຸນາດຶງ metadata DHIS2 ກ່ອນ",
    "cocHint": "ໃຊ້ເມື່ອສົ່ງຄ່າເປັນຍອດລວມ",
    "defaultCoc": "default",
    "scopeReport": "ສະເພາະລາຍງານ",
    "scopeReportHint": "ໃຊ້ເມື່ອ KPI ດຽວກັນສົ່ງໄປອົງປະກອບຂໍ້ມູນອື່ນໃນລາຍງານອື່ນ",
    "anyReport": "ທຸກລາຍງານ",
    "mappingApprovalHint": "ການຈັບຄູ່ຈະໃຊ້ໄດ້ຫຼັງຈາກຜູ້ອື່ນທີ່ບໍ່ແມ່ນຜູ້ສ້າງອະນຸມັດເທົ່ານັ້ນ.",
    "connectionsHint": "HMS ບໍ່ເກັບລະຫັດຜ່ານ: ໃຫ້ລະບຸຊື່ຕົວແປສະພາບແວດລ້ອມ (environment variable) ຂອງເຊີບເວີທີ່ເກັບໄວ້.",
    "newConnection": "ເພີ່ມການເຊື່ອມຕໍ່",
    "connectionOk": "ເຊື່ອມຕໍ່ DHIS2 ສຳເລັດ",
    "connectionFailed": "ເຊື່ອມຕໍ່ DHIS2 ບໍ່ໄດ້",
    "metadataRefreshed": "ດຶງ metadata ແລ້ວ",
    "auth": "ການຢືນຢັນຕົວຕົນ",
    "secretSet": "ຕັ້ງແລ້ວ",
    "secretMissing": "ຍັງບໍ່ໄດ້ຕັ້ງໃນເຊີບເວີ",
    "lastHealth": "ກວດເມື່ອ {{at}}",
    "lastMetadata": "metadata {{at}}",
    "approvedMappings": "ຈັບຄູ່ທີ່ອະນຸມັດ: {{count}}",
    "draftMappings": "ຈັບຄູ່ສະບັບຮ່າງ: {{count}}",
    "testConnection": "ທົດສອບການເຊື່ອມຕໍ່",
    "refreshMetadata": "ດຶງ metadata",
    "baseUrl": "ທີ່ຢູ່ (URL)",
    "baseUrlHint": "ເຊັ່ນ https://dhis2.example.gov.la (ຫ້າມໃສ່ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານໃນລິ້ງ)",
    "environment": "ສະພາບແວດລ້ອມ",
    "apiVersion": "ສະບັບ API",
    "authPat": "Personal access token",
    "authBasic": "ຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານ",
    "secretReference": "ຕົວແປສະພາບແວດລ້ອມ",
    "secretHint": "ຕັ້ງຕົວແປໃນເຊີບເວີ: token ສຳລັບ personal access token, ຫຼື username:password ສຳລັບແບບຊື່ຜູ້ໃຊ້.",
    "enabled": "ເປີດໃຊ້",
    "urlError": {
      "invalid": "ໃສ່ລິ້ງ http(s) ທີ່ບໍ່ມີຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານ",
      "httpsRequired": "ລະບົບຈິງຕ້ອງໃຊ້ https"
    },
    "periodOpenText": "ໄລຍະນີ້ຍັງບໍ່ສິ້ນສຸດ; ຄ່າອາດຈະປ່ຽນແປງໄດ້ອີກ.",
    "msg": {
      "minRecords": "ມີພຽງ {{count}} ລາຍການ; ຕ້ອງມີຢ່າງໜ້ອຍ {{min}}",
      "noData": "ບໍ່ມີຂໍ້ມູນໃນໄລຍະນີ້",
      "noFormula": "ບໍ່ມີສູດທີ່ອະນຸມັດສຳລັບໄລຍະນີ້",
      "stockPoint": "ສະຖານະສາງໃນເວລາຄິດໄລ່",
      "medianNote": "ຄ່າມັດທະຍົມຂອງບັດຄິວທີ່ມີເວລາຄົບ",
      "breakdownGap": "ຍອດແຍກກຸ່ມລວມໄດ້ {{sum}} ຈາກ {{total}} (ບໍ່ຮູ້ເພດ ຫຼື ວັນເກີດ)"
    }
  },
  "tenants": {
    "title": "ອົງກອນ ແລະ ໂຮງໝໍ",
    "subtitle": "ອົງກອນທີ່ໃຊ້ລະບົບນີ້ ແລະ ໂຮງໝໍຂອງແຕ່ລະອົງກອນ. ແຕ່ລະໂຮງໝໍມີຂໍ້ມູນຄົນເຈັບ, ພະນັກງານ, ສາງ ແລະ ການເງິນຂອງຕົນເອງ.",
    "newTenant": "ເພີ່ມອົງກອນ",
    "none": "ຍັງບໍ່ມີອົງກອນ",
    "suspend": "ລະງັບ",
    "activate": "ເປີດໃຊ້",
    "deactivate": "ປິດໃຊ້",
    "addHospital": "ເພີ່ມໂຮງໝໍ",
    "noHospitals": "ຍັງບໍ່ມີໂຮງໝໍ",
    "hospital": "ໂຮງໝໍ",
    "users": "ຜູ້ໃຊ້",
    "patients": "ຄົນເຈັບ",
    "created": "ສ້າງເມື່ອ",
    "signInLink": "ລິ້ງເຂົ້າສູ່ລະບົບ",
    "linkCopied": "ສຳເນົາລິ້ງເຂົ້າສູ່ລະບົບແລ້ວ",
    "openHospital": "ເປີດ",
    "current": "ກຳລັງໃຊ້ຢູ່",
    "sharedCatalogNote": "ລາຍການຢາ, ການກວດວິເຄາະ, ຄ່າບໍລິການ ແລະ ບໍລິການພິເສດ ເປັນລາຍການຮ່ວມລະດັບຊາດ ລວມທັງລາຄາ. ລາຄາແຍກຕາມອົງກອນຈະເຮັດໃນໄລຍະປັບປຸງການແຍກອົງກອນ.",
    "codeHint": "ລະຫັດສັ້ນເປັນຕົວພິມໃຫຍ່ ເຊັ່ນ MOH ຫຼື OPI",
    "type": "ປະເພດ",
    "nameLo": "ຊື່ (ລາວ)",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "hospitalCodeHint": "ລະຫັດບໍ່ຊ້ຳກັນ ໃຊ້ໃນລິ້ງເຂົ້າສູ່ລະບົບນຳ",
    "startingData": "ຂໍ້ມູນເລີ່ມຕົ້ນ",
    "startingDataHint": "ໂຮງໝໍໃໝ່ທຸກແຫ່ງຈະໄດ້ລາຍການພະຍາດ, ລາຍການ KPI ແລະ ລາຍງານລະດັບຊາດ. ປະເພດການນັດໝາຍ ແລະ ພະແນກ (ຖ້າເລືອກ) ຈະສຳເນົາຈາກໂຮງໝໍອື່ນ.",
    "copyFrom": "ສຳເນົາການຕັ້ງຄ່າຈາກ",
    "noTemplate": "ບໍ່ສຳເນົາ",
    "copyDepartments": "ສຳເນົາພະແນກນຳ",
    "firstAdmin": "ຜູ້ດູແລລະບົບຄົນທຳອິດ",
    "adminNew": "ບັນຊີໃໝ່",
    "adminExisting": "ຜູ້ໃຊ້ທີ່ມີຢູ່ແລ້ວ",
    "adminLater": "ພາຍຫຼັງ",
    "passwordHint": "ຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ ມີຕົວພິມໃຫຍ່, ຕົວພິມນ້ອຍ ແລະ ຕົວເລກ; ຜູ້ດູແລຈະປ່ຽນຫຼັງເຂົ້າສູ່ລະບົບ",
    "grantMe": "ໃຫ້ຂ້ອຍເຂົ້າເຖິງໂຮງໝໍນີ້ (ເພື່ອຕັ້ງຄ່າ)",
    "createHospital": "ສ້າງໂຮງໝໍ",
    "hospitalCreated": "ສ້າງ ແລະ ຕັ້ງຄ່າໂຮງໝໍແລ້ວ"
  },
  "referrals": {
    "title": "ການສົ່ງຕໍ່",
    "subtitle": "ຄົນເຈັບທີ່ພວກເຮົາສົ່ງໄປສະຖານທີ່ອື່ນ ແລະ ຄົນເຈັບທີ່ຖືກສົ່ງມາຫາພວກເຮົາ ພ້ອມຄຳຕອບ ແລະ ຜົນ",
    "new": "ສ້າງການສົ່ງຕໍ່",
    "refer": "ສົ່ງຕໍ່",
    "none": "ບໍ່ມີການສົ່ງຕໍ່",
    "number": "ເລກທີສົ່ງຕໍ່",
    "direction": "ທິດທາງ",
    "patient": "ຄົນເຈັບ",
    "facility": "ສະຖານທີ່",
    "reason": "ເຫດຜົນການສົ່ງຕໍ່",
    "priority": "ຄວາມຮີບດ່ວນ",
    "open": "ຍັງບໍ່ສຳເລັດ",
    "search": "ຊອກຫາດ້ວຍເລກທີ, ຄົນເຈັບ ຫຼື ສະຖານທີ່…",
    "outLong": "ພວກເຮົາສົ່ງຄົນເຈັບອອກ",
    "inLong": "ຖືກສົ່ງມາຫາພວກເຮົາ",
    "toFacility": "ສົ່ງໄປ",
    "fromFacility": "ສົ່ງມາຈາກ",
    "facilityContact": "ຕິດຕໍ່ສະຖານທີ່",
    "specialty": "ພະແນກ / ບໍລິການ",
    "diagnosis": "ການບົ່ງມະຕິ",
    "clinicalSummary": "ສະຫຼຸບທາງການແພດ",
    "clinicalSummaryHint": "ປະຫວັດ, ການກວດພົບ, ຜົນກວດ ແລະ ການປິ່ນປົວທີ່ຜ່ານມາ",
    "transport": "ການເດີນທາງ",
    "created": "ສ້າງການສົ່ງຕໍ່ແລ້ວ",
    "sent": "ໝາຍວ່າສົ່ງແລ້ວ",
    "printLetter": "ພິມໃບສົ່ງຕໍ່",
    "printSummary": "ພິມສະຫຼຸບ",
    "logContact": "ບັນທຶກການຕິດຕໍ່",
    "markSent": "ໝາຍວ່າສົ່ງແລ້ວ",
    "markUnreachable": "ຕິດຕໍ່ບໍ່ໄດ້",
    "decline": "ຖືກປະຕິເສດ",
    "accept": "ຮັບແລ້ວ",
    "complete": "ບັນທຶກຜົນ",
    "byOn": "ໂດຍ {{by}} ເມື່ອ {{at}}",
    "encounter": "ການກວດ",
    "appointmentAt": "ນັດໝາຍ",
    "contactAttempts": "ຈຳນວນການຕິດຕໍ່",
    "response": "ຄຳຕອບ",
    "outcome": "ຜົນ",
    "cancelledBecause": "ຍົກເລີກ: {{reason}}",
    "history": "ປະຫວັດ",
    "contactResult": "ຜົນການຕິດຕໍ່",
    "step": {
      "accept": "ຮັບການສົ່ງຕໍ່",
      "decline": "ປະຕິເສດການສົ່ງຕໍ່",
      "unreachable": "ຕິດຕໍ່ສະຖານທີ່ບໍ່ໄດ້",
      "complete": "ຜົນຂອງການສົ່ງຕໍ່",
      "cancel": "ຍົກເລີກການສົ່ງຕໍ່",
      "contact": "ການຕິດຕໍ່ກັບສະຖານທີ່ ຫຼື ຄົນເຈັບ"
    },
    "done": {
      "accept": "ຮັບການສົ່ງຕໍ່ແລ້ວ",
      "decline": "ປະຕິເສດແລ້ວ",
      "unreachable": "ໝາຍວ່າຕິດຕໍ່ບໍ່ໄດ້",
      "complete": "ບັນທຶກຜົນແລ້ວ",
      "cancel": "ຍົກເລີກແລ້ວ",
      "contact": "ບັນທຶກການຕິດຕໍ່ແລ້ວ"
    },
    "noteLabel": {
      "accept": "ໝາຍເຫດ (ຜູ້ຮັບ, ຄຳແນະນຳ)",
      "decline": "ເຫດຜົນທີ່ປະຕິເສດ",
      "unreachable": "ສິ່ງທີ່ໄດ້ລອງແລ້ວ",
      "complete": "ຜົນ (ການບົ່ງມະຕິ, ການປິ່ນປົວ, ແຜນ)",
      "cancel": "ເຫດຜົນການຍົກເລີກ",
      "contact": "ໝາຍເຫດ"
    },
    "letterTitle": "ໃບສົ່ງຕໍ່ຄົນເຈັບ",
    "summaryTitle": "ການຮັບຄົນເຈັບສົ່ງຕໍ່",
    "referringClinician": "ແພດຜູ້ສົ່ງ",
    "receivingFacility": "ສະຖານທີ່ຮັບ",
    "feedbackRequest": "ການແຈ້ງຜົນກັບ",
    "feedbackText": "ກະລຸນາແຈ້ງຜົນການກວດ ແລະ ແຜນການປິ່ນປົວກັບມາ ເພື່ອໃຫ້ພວກເຮົາສືບຕໍ່ເບິ່ງແຍງຄົນເຈັບໄດ້."
  },
  "followUps": {
    "title": "ການນັດຕິດຕາມ",
    "subtitle": "ການນັດຕິດຕາມທຸກພະແນກ: ທີ່ຮອດກຳນົດ, ກາຍກຳນົດ ແລະ ສຳເລັດແລ້ວ",
    "new": "ສ້າງການນັດຕິດຕາມ",
    "plan": "ນັດຕິດຕາມ",
    "none": "ບໍ່ມີການນັດຕິດຕາມ",
    "due": "ກຳນົດ",
    "patient": "ຄົນເຈັບ",
    "reason": "ເຫດຜົນ",
    "who": "ພະແນກ / ແພດ",
    "outcome": "ຜົນ",
    "done": "ສຳເລັດ",
    "missed": "ບໍ່ມາ",
    "reopen": "ເປີດຄືນ",
    "overdueBy": "ກາຍກຳນົດ {{days}} ມື້",
    "inDays": "ອີກ {{days}} ມື້",
    "created": "ນັດຕິດຕາມແລ້ວ",
    "priority": "ຄວາມຮີບດ່ວນ",
    "department": "ພະແນກ",
    "practitioner": "ແພດ",
    "instructions": "ຄຳແນະນຳຄົນເຈັບ",
    "instructionsHint": "ເຊັ່ນ ງົດອາຫານກ່ອນມາ, ເອົາຢາມານຳ",
    "filter": {
      "upcoming": "ຮອດກຳນົດພາຍໃນອາທິດ",
      "overdue": "ກາຍກຳນົດ",
      "today": "ກຳນົດມື້ນີ້",
      "week": "7 ມື້ຂ້າງໜ້າ"
    },
    "action": {
      "complete": "ຕິດຕາມສຳເລັດ",
      "missed": "ຄົນເຈັບບໍ່ມາ",
      "cancel": "ຍົກເລີກການນັດ"
    },
    "noteLabel": {
      "complete": "ຜົນ",
      "missed": "ໝາຍເຫດ (ບໍ່ບັງຄັບ)",
      "cancel": "ເຫດຜົນການຍົກເລີກ"
    }
  },
  "duplicates": {
    "title": "ຄົນເຈັບຊ້ຳກັນ",
    "subtitle": "ບັນທຶກທີ່ອາດເປັນຄົນດຽວກັນ. ຄົນໜຶ່ງຂໍລວມ ແລະ ອີກຄົນໜຶ່ງເປັນຜູ້ອະນຸມັດ.",
    "tabSuggestions": "ອາດຊ້ຳກັນ",
    "tabRequests": "ຄຳຂໍລວມ",
    "noneFound": "ບໍ່ພົບບັນທຶກທີ່ອາດຊ້ຳກັນ",
    "suggestionsHint": "{{count}} ຄູ່ທີ່ອາດຊ້ຳກັນ, ຄູ່ທີ່ໜ້າຈະຊ້ຳທີ່ສຸດຢູ່ກ່ອນ",
    "requestPending": "ລໍຖ້າອະນຸມັດການລວມ",
    "notDuplicates": "ບໍ່ແມ່ນຄົນດຽວກັນ",
    "askMerge": "ຂໍລວມ",
    "dismissed": "ຈະບໍ່ແນະນຳຄູ່ນີ້ອີກ",
    "dismissMessage": "ສອງບັນທຶກນີ້ເປັນຄົນຕ່າງກັນ ແລະ ຈະບໍ່ຖືກແນະນຳອີກ.",
    "dismissReason": "ເປັນຫຍັງ (ເຊັ່ນ ຄູ່ແຝດ, ພໍ່ແມ່ ແລະ ລູກ)",
    "visits": "{{count}} ຄັ້ງທີ່ມາກວດ",
    "lastVisit": "ຫຼ້າສຸດ {{date}}",
    "registered": "ລົງທະບຽນ {{date}}",
    "keepThis": "ເກັບບັນທຶກນີ້",
    "keeping": "ບັນທຶກທີ່ເກັບ",
    "chooseSurvivor": "ເລືອກບັນທຶກທີ່ຈະເກັບ. ທຸກຢ່າງຈາກອີກບັນທຶກຈະຍ້າຍມາ.",
    "mergeExplain": "{{merge}} ຈະຖືກລວມເຂົ້າ {{keep}}: ການກວດ, ໃບບິນ, ຜົນກວດ ແລະ ບັນທຶກອື່ນຈະຍ້າຍໄປ ແລະ ບັນທຶກທີ່ຖືກລວມຈະໃຊ້ບໍ່ໄດ້ອີກ.",
    "reasonLabel": "ເຫດຜົນ",
    "sendForApproval": "ສົ່ງໃຫ້ອະນຸມັດ",
    "requested": "ສົ່ງຄຳຂໍລວມໃຫ້ອະນຸມັດແລ້ວ",
    "noRequests": "ບໍ່ມີຄຳຂໍລວມ",
    "askedBy": "ຂໍໂດຍ {{by}} ເມື່ອ {{at}}",
    "decidedBy": "ຕັດສິນໂດຍ {{by}} ເມື່ອ {{at}}",
    "survivor": "ເກັບໄວ້",
    "duplicate": "ລວມເຂົ້າບັນທຶກທີ່ເກັບ",
    "decisionNote": "ໝາຍເຫດການຕັດສິນ",
    "movedRecords": "ຍ້າຍ {{count}} ລາຍການໄປຫາຄົນເຈັບທີ່ເກັບ",
    "keptOnDuplicate": "ຍັງຢູ່ກັບບັນທຶກທີ່ຖືກລວມ (ໜຶ່ງຕໍ່ຄົນເຈັບ): {{list}}",
    "cancelRequest": "ຍົກເລີກຄຳຂໍ",
    "reject": "ປະຕິເສດ",
    "approveMerge": "ອະນຸມັດການລວມ",
    "mergeNow": "ລວມດຽວນີ້",
    "approveNote": "ໝາຍເຫດ (ບໍ່ບັງຄັບ)",
    "rejectNote": "ເຫດຜົນທີ່ປະຕິເສດ",
    "merged": "ລວມບັນທຶກແລ້ວ",
    "rejected": "ປະຕິເສດການລວມແລ້ວ",
    "mergedBanner": "ບັນທຶກນີ້ຖືກລວມເຂົ້າບັນທຶກຄົນເຈັບອື່ນແລ້ວ ແລະ ໃຊ້ບໍ່ໄດ້ອີກ.",
    "openSurvivor": "ເປີດບັນທຶກທີ່ເກັບ",
    "reason": {
      "NAME_DOB": "ຊື່ ແລະ ວັນເກີດຄືກັນ",
      "SIMILAR_NAME_DOB": "ຊື່ຄ້າຍກັນ, ວັນເກີດຄືກັນ",
      "PHONE_NAME": "ເບີໂທຄືກັນ, ຊື່ຄ້າຍກັນ",
      "IDENTIFIER": "ເລກບັດຄືກັນ"
    }
  },
  "registry": {
    "sectionNamesEn": "ຊື່ພາສາອັງກິດ ແລະ ຊື່ຫຼິ້ນ",
    "firstNameEn": "ຊື່ (ອັງກິດ)",
    "lastNameEn": "ນາມສະກຸນ (ອັງກິດ)",
    "nickname": "ຊື່ຫຼິ້ນ",
    "nicknameEn": "ຊື່ຫຼິ້ນ (ອັງກິດ)",
    "sectionBackground": "ຂໍ້ມູນພື້ນຖານ",
    "nationality": "ສັນຊາດ",
    "country": "ສັນຊາດ (ປະເທດ)",
    "ethnicity": "ຊົນເຜົ່າ",
    "religion": "ສາສະໜາ",
    "firstLanguage": "ພາສາແມ່",
    "occupation": "ອາຊີບ",
    "educationLevel": "ລະດັບການສຶກສາ",
    "sectionBirth": "ບ່ອນເກີດ",
    "birthCountry": "ປະເທດເກີດ",
    "birthPlace": "ບ່ອນເກີດ (ອື່ນໆ)",
    "birthPlaceHint": "ໂຮງໝໍ ຫຼື ສະຖານທີ່ ຖ້າບໍ່ແມ່ນບ້ານ",
    "sectionHousehold": "ຄົວເຮືອນ",
    "houseNo": "ເຮືອນເລກທີ",
    "householdUnit": "ໜ່ວຍ",
    "familyBookNo": "ເລກທີປຶ້ມສຳມະໂນຄົວ",
    "relationshipToHead": "ສາຍພົວພັນກັບຫົວໜ້າຄອບຄົວ",
    "isHouseholdHead": "ເປັນຫົວໜ້າຄອບຄົວ",
    "sectionParents": "ພໍ່ ແລະ ແມ່",
    "fatherName": "ຊື່ພໍ່",
    "motherName": "ຊື່ແມ່",
    "parentOccupation": "ອາຊີບ",
    "parentPhone": "ເບີໂທ",
    "parentNationalId": "ເລກບັດປະຈຳຕົວ",
    "parentWorkplace": "ບ່ອນເຮັດວຽກ",
    "sectionHealth": "ປະຫວັດສຸຂະພາບ",
    "hearingIssue": "ມີບັນຫາການໄດ້ຍິນ",
    "speakingIssue": "ມີບັນຫາການເວົ້າ",
    "visionIssue": "ມີບັນຫາສາຍຕາ",
    "heightCm": "ລວງສູງ (cm)",
    "weightKg": "ນ້ຳໜັກ (kg)",
    "medicalIssues": "ບັນຫາສຸຂະພາບ",
    "seriousIllness": "ເຄີຍເຈັບປ່ວຍໜັກ",
    "title": "ຂໍ້ມູນທະບຽນ",
    "namesEn": "ຊື່ພາສາອັງກິດ",
    "heightWeight": "ລວງສູງ ແລະ ນ້ຳໜັກ",
    "sectionDisability": "ຄວາມພິການ",
    "disabilityTypes": "ປະເພດຄວາມພິການ",
    "disabilityTypesHint": "ເລືອກທຸກຢ່າງທີ່ກ່ຽວຂ້ອງ; ປະເພດຍ່ອຍຈະສະແດງຢູ່ລຸ່ມປະເພດທີ່ເລືອກ. \"ບໍ່ຮູ້ / ຍັງບໍ່ໄດ້ປະເມີນ\" ເລືອກຮ່ວມກັບອັນອື່ນບໍ່ໄດ້.",
    "disabilityChooseOne": "ເລືອກໜຶ່ງ",
    "disabilityChooseAny": "ເລືອກໄດ້ຫຼາຍ"
  },
  "staffKpi": {
    "title": "ສະຫຼຸບຜົນງານ",
    "titleFor": "ສະຫຼຸບຜົນງານ: {{name}}",
    "subtitle": "ວຽກທີ່ບັນທຶກໃນບັນຊີນີ້ແຕ່ລະເດືອນ ແຍກຕາມພາກສ່ວນຂອງລະບົບ",
    "backToUsers": "ກັບໄປລາຍຊື່ຜູ້ໃຊ້",
    "showAll": "ສະແດງວຽກທີ່ບໍ່ມີລາຍການນຳ",
    "nothing": "ບໍ່ມີວຽກບັນທຶກໃນ {{period}}",
    "vsPrevious": "ໄລຍະກ່ອນ {{value}}",
    "column": "ສະຫຼຸບຜົນງານ",
    "open": "ເບິ່ງ",
    "mine": "ສະຫຼຸບຜົນງານຂອງຂ້ອຍ",
    "metric": {
      "PATIENTS_REGISTERED": "ລົງທະບຽນຄົນເຈັບ",
      "APPOINTMENTS_BOOKED": "ນັດໝາຍທີ່ບັນທຶກ",
      "QUEUE_CALLED": "ເອີ້ນຄົນເຈັບຈາກຄິວ",
      "ENCOUNTERS_SEEN": "ກວດຄົນເຈັບ (ເປັນແພດ)",
      "VITALS_RECORDED": "ບັນທຶກສັນຍານຊີບ",
      "DIAGNOSES_RECORDED": "ບັນທຶກການບົ່ງມະຕິ",
      "NOTES_SIGNED": "ເຊັນບັນທຶກ",
      "LAB_ORDERS": "ສັ່ງກວດວິເຄາະ",
      "LAB_RESULTS_ENTERED": "ບັນທຶກຜົນວິເຄາະ",
      "LAB_RESULTS_VERIFIED": "ຢືນຢັນຜົນວິເຄາະ",
      "SERVICES_REPORTED": "ລາຍງານບໍລິການພິເສດ",
      "REFERRALS_MADE": "ສົ່ງຕໍ່ຄົນເຈັບ",
      "FOLLOW_UPS_DONE": "ຕິດຕາມສຳເລັດ",
      "EYE_EXAMS_SIGNED": "ເຊັນການກວດຕາ",
      "VA_MEASURED": "ວັດແທກສາຍຕາ",
      "SURGERIES_PERFORMED": "ຜ່າຕັດ",
      "INJECTIONS_GIVEN": "ສັກຢາ",
      "ADMISSIONS": "ຮັບຄົນເຈັບນອນໂຮງໝໍ",
      "DISCHARGES": "ໃຫ້ອອກໂຮງໝໍ",
      "PRESCRIPTIONS_WRITTEN": "ຂຽນໃບສັ່ງຢາ",
      "DISPENSED": "ຈ່າຍຢາ",
      "POS_SALES": "ຂາຍໜ້າຮ້ານ",
      "STOCK_DOCUMENTS": "ເອກະສານສາງ",
      "INVOICES_ISSUED": "ອອກໃບບິນ",
      "PAYMENTS_RECEIVED": "ຮັບເງິນ",
      "PAYMENTS_AMOUNT": "ຈຳນວນເງິນທີ່ຮັບ",
      "SYSTEM_ACTIONS": "ການກະທຳໃນລະບົບ"
    },
    "team": {
      "title": "KPI ພະນັກງານ",
      "subtitle": "ວຽກທີ່ບັນທຶກຂອງແຕ່ລະຄົນໃນແຕ່ລະເດືອນ ທຽບກັບເປົ້າໝາຍປະຈຳເດືອນ",
      "leaderboard": "ອັນດັບ",
      "targets": "ເປົ້າໝາຍ",
      "metric": "ຕົວວັດ",
      "role": "ບົດບາດ",
      "anyRole": "ທຸກບົດບາດ",
      "showZero": "ສະແດງພະນັກງານທີ່ບໍ່ມີວຽກນຳ",
      "rank": "ອັນດັບ",
      "staff": "ພະນັກງານ",
      "roles": "ບົດບາດ",
      "department": "ພະແນກ",
      "thisMonth": "ໄລຍະນີ້",
      "lastMonth": "ໄລຍະກ່ອນ",
      "target": "ເປົ້າໝາຍ",
      "achievement": "ບັນລຸໄດ້",
      "noTarget": "ບໍ່ມີເປົ້າໝາຍ",
      "total": "ລວມທັງທີມ",
      "counted": "ພະນັກງານທີ່ມີວຽກ",
      "withTarget": "ພະນັກງານທີ່ມີເປົ້າໝາຍ",
      "metTarget": "ບັນລຸເປົ້າໝາຍ",
      "empty": "ບໍ່ມີວຽກທີ່ບັນທຶກສຳລັບຕົວວັດ ແລະ ເດືອນນີ້.",
      "supervisionNote": "ໃຊ້ສຳລັບການຕິດຕາມ ແລະ ແນະນຳເທົ່ານັ້ນ — KPI ພະນັກງານບໍ່ສົ່ງເຂົ້າ DHIS2 ແລະ ບໍ່ໃຊ້ຕັດສິນເລື່ອງບຸກຄະລາກອນແບບອັດຕະໂນມັດ.",
      "addTarget": "ເພີ່ມເປົ້າໝາຍ",
      "editTarget": "ແກ້ໄຂເປົ້າໝາຍ",
      "appliesTo": "ໃຊ້ກັບ",
      "forRole": "ບົດບາດ",
      "forPerson": "ບຸກຄົນ",
      "person": "ບຸກຄົນ",
      "monthlyTarget": "ເປົ້າໝາຍປະຈຳເດືອນ",
      "monthlyTargetMoney": "ເປົ້າໝາຍປະຈຳເດືອນ (ຈຳນວນເງິນ)",
      "targetHint": "ຕໍ່ເດືອນ. ໄຕມາດ ×3, ປີ ×12, ມື້ ແລະ ຊ່ວງວັນທີ ຄິດຕາມສັດສ່ວນຈຳນວນມື້. ເປົ້າໝາຍຂອງບຸກຄົນ ຈະໃຊ້ແທນເປົ້າໝາຍຂອງບົດບາດ.",
      "targetsHelp": "ເປົ້າໝາຍຂອງບົດບາດ ໃຊ້ກັບທຸກຄົນທີ່ມີບົດບາດນັ້ນ; ເປົ້າໝາຍຂອງບຸກຄົນ ຈະໃຊ້ແທນ.",
      "noTargets": "ຍັງບໍ່ມີເປົ້າໝາຍ.",
      "updated": "ແກ້ໄຂລ່າສຸດ",
      "deleteTarget": "ລຶບເປົ້າໝາຍ"
    },
    "dash": {
      "title": "ພາບລວມ",
      "vsLastMonth": "ທຽບກັບໄລຍະກ່ອນ",
      "activeStaff": "ພະນັກງານທີ່ມີວຽກ",
      "targetsMet": "ບັນລຸເປົ້າໝາຍ",
      "ofTargets": "{{met}} ຈາກ {{total}}",
      "byArea": "ວຽກຕາມຂົງເຂດ ຕາມເວລາ",
      "attainment": "ເປົ້າໝາຍໃນໄລຍະນີ້",
      "met": "ບັນລຸ",
      "close": "ໃກ້ (70–99%)",
      "behind": "ຕ່ຳກວ່າ (ຕ່ຳກວ່າ 70%)",
      "noTargets": "ຍັງບໍ່ໄດ້ຕັ້ງເປົ້າໝາຍ — ເພີ່ມໄດ້ໃນແຖບ ເປົ້າໝາຍ.",
      "withoutTarget": "ພະນັກງານທີ່ມີວຽກ {{value}} ຄົນ ຍັງບໍ່ມີເປົ້າໝາຍ.",
      "top5": "5 ອັນດັບທຳອິດ",
      "byRole": "ວຽກຕາມບົດບາດ ໃນໄລຍະນີ້",
      "byRoleHint": "ຜູ້ທີ່ມີຫຼາຍບົດບາດ ຈະນັບໃນທຸກບົດບາດ.",
      "people": "{{value}} ຄົນ",
      "workItems": "ຈຳນວນວຽກ",
      "heatmap": "ວຽກຂອງແຕ່ລະຄົນ ຕາມເວລາ",
      "heatmapHint": "ສີເຂັ້ມ = ວຽກຫຼາຍ. ກົດແຖວເພື່ອເບິ່ງສະຫຼຸບຂອງຄົນນັ້ນ."
    },
    "period": {
      "day": "ມື້",
      "month": "ເດືອນ",
      "quarter": "ໄຕມາດ",
      "year": "ປີ",
      "range": "ຊ່ວງວັນທີ",
      "from": "ຈາກ",
      "to": "ຫາ",
      "vs": "ທຽບກັບ {{previous}}",
      "prorated": "ເປົ້າໝາຍຄິດຕາມສັດສ່ວນຈຳນວນມື້"
    },
    "trendTotal": "ລວມໃນກຣາຟ {{value}}"
  },
  "roles": {
    "title": "ບົດບາດ ແລະ ສິດ",
    "subtitle": "ແຕ່ລະບົດບາດແມ່ນຊຸດສິດ. ມອບບົດບາດໃຫ້ພະນັກງານຢູ່ໜ້າຜູ້ໃຊ້.",
    "newRole": "ເພີ່ມບົດບາດ",
    "howItWorks": "ການປ່ຽນແປງຈະມີຜົນກັບແຕ່ລະຄົນພາຍໃນ 15 ນາທີ (ເມື່ອເຂົ້າລະບົບ ຫຼື ຕໍ່ອາຍຸ token). ບົດບາດໃຊ້ຮ່ວມກັນທຸກໂຮງໝໍ; ສິດລະດັບແພລດຟອມມີສະເພາະຜູ້ດູແລສູງສຸດ.",
    "searchRoles": "ຊອກຫາບົດບາດ…",
    "permissionCount": "{{count}} ສິດ",
    "pick": "ເລືອກບົດບາດ",
    "locked": "ລັອກ",
    "builtIn": "ມີໃນລະບົບ",
    "custom": "ສ້າງເອງ",
    "inUse": "ຍັງມອບໃຫ້ຜູ້ໃຊ້ຢູ່",
    "name": "ຊື່ບົດບາດ",
    "usersLine": "{{here}} ຄົນໃນໂຮງໝໍນີ້ · {{total}} ຄົນທຸກໂຮງໝໍ",
    "saveDetails": "ບັນທຶກລາຍລະອຽດ",
    "lockedHint": "ຜູ້ດູແລສູງສຸດມີທຸກສິດສະເໝີ.",
    "permissions": "ສິດ ({{count}})",
    "searchPermissions": "ຊອກຫາສິດ…",
    "savePermissions": "ບັນທຶກສິດ",
    "platformOnly": "ສະເພາະແພລດຟອມ",
    "deleteRole": "ລຶບບົດບາດ",
    "deleteMessage": "ລຶບບົດບາດ {{name}}? ບໍ່ມີໃຜມີບົດບາດນີ້.",
    "create": "ສ້າງບົດບາດ",
    "codeHint": "ຕົວພິມໃຫຍ່ ແລະ _ ເຊັ່ນ EYE_SCREENER",
    "copyFrom": "ສຳເນົາສິດຈາກ",
    "startEmpty": "ເລີ່ມໂດຍບໍ່ມີສິດ",
    "saved": "ບັນທຶກສິດແລ້ວ",
    "deleted": "ລຶບບົດບາດແລ້ວ",
    "created": "ສ້າງບົດບາດແລ້ວ"
  },
  "permGroup": {
    "appointment": "ນັດໝາຍ",
    "audit": "ບັນທຶກການກວດສອບ",
    "billing": "ໃບບິນ",
    "careplan": "ແຜນການດູແລ",
    "cash": "ລິ້ນຊັກເງິນ",
    "dhis2": "DHIS2",
    "diagnosis": "ການບົ່ງມະຕິ",
    "disease": "ລາຍການພະຍາດ",
    "encounter": "ການກວດປິ່ນປົວ",
    "finance": "ການເງິນ",
    "followup": "ການນັດຕິດຕາມ",
    "i18n": "ພາສາ ແລະ ຂໍ້ຄວາມ",
    "inpatient": "ຄົນເຈັບໃນ",
    "inventory": "ສາງ",
    "kpi": "KPI",
    "lab": "ຫ້ອງວິເຄາະ",
    "location": "ສະຖານທີ່",
    "medication": "ຢາ",
    "note": "ບັນທຶກການແພດ",
    "ophthalmology": "ສູນຕາ",
    "organization": "ໂຮງໝໍ ແລະ ພະແນກ",
    "pathway": "ວົງຈອນການປິ່ນປົວ",
    "patient": "ຄົນເຈັບ",
    "payment": "ການຮັບເງິນ",
    "pharmacy": "ຫ້ອງຢາ",
    "portal": "ແອັບຄົນເຈັບ",
    "pos": "ຮ້ານຂາຍຢາ POS",
    "prescription": "ໃບສັ່ງຢາ",
    "purchase": "ການຈັດຊື້",
    "queue": "ຄິວ",
    "referral": "ການສົ່ງຕໍ່",
    "report": "ລາຍງານ",
    "role": "ບົດບາດ",
    "sales": "ການຂາຍໜ້າຮ້ານ",
    "service": "ບໍລິການພິເສດ",
    "tenant": "ອົງກອນ",
    "user": "ຜູ້ໃຊ້",
    "ward": "ຕຶກ ແລະ ຕຽງ",
    "reference": "ລາຍການລະຫັດກາງ",
    "staffkpi": "KPI ພະນັກງານ"
  },
  "permAction": {
    "admin": "ບໍລິຫານ",
    "approve": "ອະນຸມັດ",
    "collect": "ຮັບເງິນ",
    "discount": "ໃຫ້ສ່ວນຫຼຸດ",
    "dispense": "ຈ່າຍຢາ",
    "enter": "ບັນທຶກຜົນ",
    "global": "ທຸກໂຮງໝໍ",
    "manage": "ຈັດການ",
    "merge": "ລວມບັນທຶກ",
    "order": "ສັ່ງ",
    "perform": "ດຳເນີນ",
    "prepare": "ກະກຽມ",
    "read": "ເບິ່ງ",
    "refund": "ຄືນເງິນ",
    "request": "ຂໍ",
    "sell": "ຂາຍ",
    "sensitive": "ຂໍ້ມູນລະອຽດອ່ອນ",
    "session": "ເປີດ ແລະ ປິດ",
    "sign": "ເຊັນ",
    "stock": "ສະຕັອກ",
    "submit": "ສົ່ງ",
    "surgery": "ຜ່າຕັດ",
    "verify": "ຢືນຢັນ",
    "void": "ຍົກເລີກ",
    "write": "ສ້າງ ແລະ ແກ້ໄຂ",
    "kiosk": "ໃຊ້ຕູ້ບໍລິການ",
    "display": "ສະແດງຈໍຄິວ",
    "triage": "ບູລິມະສິດທາງຄລີນິກ",
    "configure": "ຕັ້ງຄ່າ"
  },
  "apptDash": {
    "title": "ພາບລວມນັດໝາຍ",
    "subtitle": "ຕາຕະລາງນັດມື້ນີ້, ພາບລວມປະຈຳເດືອນ ແລະ ການນັດຕິດຕາມທີ່ຕ້ອງເອົາໃຈໃສ່",
    "followUpWatch": "ເຝົ້າລະວັງການນັດຕິດຕາມ",
    "followUpWatchHint": "ການນັດຕິດຕາມທີ່ກາຍກຳນົດ ຫຼື ໃກ້ຮອດກຳນົດ",
    "followUpRestOfWeek": "ມື້ອື່ນໆໃນ 7 ມື້ຂ້າງໜ້າ",
    "patients": "ຄົນເຈັບ {{value}} ຄົນ",
    "openFollowUps": "ນັດຕິດຕາມທີ່ຍັງເປີດ",
    "needsAttention": "ຕ້ອງເອົາໃຈໃສ່",
    "noOverdue": "ບໍ່ມີການນັດຕິດຕາມທີ່ກາຍກຳນົດ.",
    "otherDepartments": "ອື່ນໆ",
    "byDepartment": "ນັດໝາຍຕາມພະແນກ",
    "byDepartmentHint": "ສັດສ່ວນນັດໝາຍເດືອນ {{month}}",
    "lastMonth": "ເດືອນກ່ອນ",
    "pillHint": "ຕົວເລກໃນແທ່ງ ສະແດງການປ່ຽນແປງທຽບກັບເດືອນກ່ອນ.",
    "scheduled": "ນັດທັງໝົດ",
    "overview": "ສະຫຼຸບນັດໝາຍ",
    "overviewHint": "ຍອດລວມເດືອນ {{month}} · ຕາຕະລາງວັນທີ {{date}}",
    "calendar": "ປະຕິທິນນັດໝາຍ",
    "calendarHint": "ເລືອກມື້ ເພື່ອເບິ່ງຕາຕະລາງນັດ",
    "more": "+ອີກ {{value}} ລາຍການ",
    "legend": "ຄຳອະທິບາຍສີ",
    "legendHint": "ສີໃນປະຕິທິນ ແຍກຕາມພະແນກ",
    "waiting": "ລໍຖ້າ",
    "arrived": "ມາຮອດແລ້ວ",
    "patientsBooked": "ຄົນເຈັບ",
    "beds": "ຕຽງ",
    "bedsHint": "ຫວອດຄົນເຈັບນອນໂຮງໝໍ",
    "doctorsOnDuty": "ແພດປະຈຳການ",
    "activeDoctors": "ແພດທີ່ເຮັດວຽກ",
    "departmentsOpen": "ພະແນກ",
    "upcoming": "ນັດທີ່ຈະມາເຖິງ",
    "next7Days": "7 ມື້ຂ້າງໜ້າ",
    "weekdays": {
      "1": "ຈັນ",
      "2": "ອັງຄານ",
      "3": "ພຸດ",
      "4": "ພະຫັດ",
      "5": "ສຸກ",
      "6": "ເສົາ",
      "7": "ອາທິດ"
    }
  },
  "disabilityTypes": {
    "title": "ປະເພດຄວາມພິການ",
    "subtitle": "ການຈັດປະເພດທີ່ໃຊ້ເວລາລົງທະບຽນຄົນເຈັບ. ໃຊ້ຮ່ວມກັນທຸກໂຮງໝໍ.",
    "new": "ເພີ່ມປະເພດຄວາມພິການ",
    "deleted": "ລຶບປະເພດຄວາມພິການແລ້ວ",
    "inUseHint": "ມີຄົນເຈັບ {{count}} ຄົນທີ່ມີປະເພດນີ້ ຈຶ່ງລຶບບໍ່ໄດ້. ຍົກເລີກ \"ກຳລັງໃຊ້\" ເພື່ອເຊື່ອງຈາກການລົງທະບຽນ.",
    "codeHint": "ຕົວອັກສອນໃຫຍ່, ຕົວເລກ, - ຫຼື _ (ເຊັ່ນ PWD11)",
    "sortOrder": "ລຳດັບການສະແດງ",
    "nameLa": "ຊື່ (ລາວ)",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "activeLabel": "ກຳລັງໃຊ້ (ສະແດງເວລາລົງທະບຽນຄົນເຈັບ)",
    "deleteTitle": "ລຶບປະເພດຄວາມພິການບໍ?",
    "deleteMessage": "{{code}} ຈະຖືກລຶບອອກ. ບໍ່ມີຄົນເຈັບໃດມີປະເພດນີ້.",
    "patients": "ຄົນເຈັບ",
    "parent": "ເປັນປະເພດຍ່ອຍຂອງ",
    "noParent": "— ປະເພດຫຼັກ —",
    "icd11Code": "ລະຫັດ ICD-11",
    "exclusiveLabel": "ເລືອກຮ່ວມກັບປະເພດອື່ນບໍ່ໄດ້ (ເຊັ່ນ ບໍ່ຮູ້ / ຍັງບໍ່ໄດ້ປະເມີນ)",
    "singleChoiceLabel": "ເລືອກປະເພດຍ່ອຍຂອງມັນໄດ້ພຽງອັນດຽວ",
    "exclusiveBadge": "ເລືອກດຽວ",
    "singleChoiceBadge": "ປະເພດຍ່ອຍອັນດຽວ"
  },
  "queueServices": {
    "title": "ຈຸດບໍລິການຄິວ",
    "subtitle": "ແຕ່ລະຈຸດບໍລິການມີຄິວຂອງຕົນເອງທຸກມື້. ຄົນເຈັບໃຊ້ເລກດຽວໃນເວລາຍ້າຍລະຫວ່າງຈຸດ.",
    "add": "ເພີ່ມຈຸດບໍລິການ",
    "edit": "ແກ້ໄຂ {{code}}",
    "prefix": "ຕົວນຳໜ້າເລກ",
    "prefixHint": "ຕົວອັກສອນ ຫຼື ຕົວເລກ, ເຊັ່ນ R ໄດ້ R-001",
    "nameLocal": "ຊື່ (ລາວ)",
    "nameEn": "ຊື່ (ອັງກິດ)",
    "departmentHint": "ນັດໝາຍ ແລະ ຄົນເຈັບ walk-in ຂອງພະແນກ ເລີ່ມທີ່ຈຸດບໍລິການທຳອິດຂອງພະແນກ",
    "noDepartment": "ບໍ່ມີພະແນກ",
    "counters": "ເຄົາເຕີ້ / ຫ້ອງ",
    "countersHint": "ຂັ້ນດ້ວຍຈຸດ (,), ເຊັ່ນ ຫ້ອງ 1, ຫ້ອງ 2",
    "sortOrder": "ລຳດັບ",
    "sortOrderHint": "ເລກນ້ອຍມາກ່ອນ",
    "kiosk": "ຕູ້ບໍລິການ",
    "kioskEnabled": "ຄົນເຈັບ walk-in ເລືອກໄດ້ຢູ່ຕູ້ບໍລິການ"
  }
}
